// Page-specific strings, namespaced as 'pages.<pageName>.<key>'.
// Auto-compiled from the i18n-full-app-coverage workflow run.
export default {
  'pages.chat.sources.close': 'Close sources',
  'pages.chat.sources.searching': 'Searching sources',
  'pages.chat.sources.title': 'Check Sources',
  'pages.chat.sources.web': 'Web sources',
  'pages.chat.sources.vault': 'Vault sources',
  'pages.chat.sources.foundOne': 'source found',
  'pages.chat.sources.foundMany': 'sources found',
  'pages.chat.sources.empty': 'No matching sources found.',
  'pages.chat.sources.vaultEmpty': 'No evidence found for the selected claim in your Vault.',
  'pages.chat.sources.failed': 'Could not load sources. Please try again.',
  'pages.chat.sources.retry': 'Retry',
  'pages.chat.sources.supports': 'Supports claim',
  'pages.chat.sources.partially_supports': 'Partially supports claim',
  'pages.chat.sources.contradicts': 'Contradicts claim',
  'pages.chat.sources.background': 'Background information',
  'pages.chat.sources.unverified': 'Search snippet · not verified',
  'pages.chat.sources.additional': 'Found during verification',
  'pages.chat.selection.singular': 'selection',
  'pages.chat.selection.plural': 'selections',
  'pages.chat.selection.sentPreview': 'Selected passages',
  'pages.chat.selection.showSource': 'Highlight selected passage in chat',
  'pages.chat.selection.packet': 'Selection',
  'pages.chat.selection.remove': 'Remove selection',
  'pages.chat.selection.actions': 'Selected text actions',
  'pages.chat.selection.ask': 'Ask A&GEL',
  'pages.chat.selection.checkSources': 'Check Sources',
  'pages.chat.selection.copy': 'Copy to Clipboard',
  'pages.chat.selection.copied': 'Selection copied to clipboard',
  'pages.chat.selection.copyFailed': 'Could not copy the selection',
  'pages.app.analysisType.cpChecklist.title': 'CP Checklist',
  'pages.app.analysisType.cpChecklist.description':
    'Generate a conditions precedent checklist from the selected documents.',
  'pages.app.analysisType.companyOverview.title': 'Company Overview',
  'pages.app.analysisType.companyOverview.description':
    'Build a company overview from the selected documents.',
  'pages.chat.promptLibrary.purposeRequired': 'Enter the purpose of this prompt.',
  'pages.chat.promptLibrary.metadataUnavailable':
    'Some prompt options are unavailable. At least one practice area is required to save.',
  'pages.chat.promptLibrary.retryOptions': 'Retry',
  'pages.chat.promptLibrary.tags': 'Tags',
  'pages.chat.promptLibrary.tagsRequired': 'Add at least one tag.',
  'pages.chat.promptLibrary.tagsPlaceholder': 'Select or create tags',
  'pages.chat.promptLibrary.practiceAreas': 'Practice Areas',
  'pages.chat.promptLibrary.practiceAreasRequired': 'Select at least one practice area.',
  'pages.chat.promptLibrary.practiceAreasPlaceholder': 'Select practice areas',
  'pages.chat.promptLibrary.exampleTemplate':
    'Task: [Describe the task this prompt should perform.]\n\nInputs: [Specify the documents or information to provide.]\n\nRequirements: [Describe the structure, tone, constraints, and level of detail.]\n\nUse the following as an example of the desired output. Adapt it to the new inputs rather than repeating its facts:\n\n',
  'pages.chat.promptLibrary.discardTitle': 'Discard this prompt draft?',
  'pages.chat.promptLibrary.discardDescription': 'Your edits have not been saved to the library.',
  'pages.chat.promptLibrary.discard': 'Discard',
  'pages.chat.promptLibrary.keepEditing': 'Keep editing',
  'pages.chat.promptLibrary.saved': 'Prompt saved to your personal library.',
  'pages.chat.promptLibrary.viewLibrary': 'View library',
  'pages.chat.promptLibrary.saveFailed':
    'Could not save the prompt. Your draft is still here; try again.',
  'pages.chat.promptLibrary.create': 'Create reusable prompt',
  'pages.chat.promptLibrary.cancel': 'Cancel',
  'pages.chat.promptLibrary.save': 'Save to my library',
  'pages.chat.promptLibrary.reviewTitle': 'Make this useful in a new conversation',
  'pages.chat.promptLibrary.reviewDescription':
    'Keep reusable instructions, or use a useful answer as an example. Replace names and matter-specific facts with placeholders such as [agreement]. Make references like “the above” explicit. Chat history and attached files will not be included.',
  'pages.chat.promptLibrary.original': 'Original chat text',
  'pages.chat.promptLibrary.keepWording': 'Keep selected wording',
  'pages.chat.promptLibrary.useExample': 'Use as an output example',
  'pages.chat.promptLibrary.exampleHelp':
    'Fill in the task, inputs, and requirements below to describe how to produce a similar result.',
  'pages.chat.promptLibrary.name': 'Name',
  'pages.chat.promptLibrary.nameRequired': 'Enter a name for this prompt.',
  'pages.chat.promptLibrary.purpose': 'Purpose',
  'pages.chat.promptLibrary.content': 'Prompt',
  'pages.chat.promptLibrary.contentRequired': 'Enter the instructions to save.',
  'pages.adminManagement.groupName': 'Group Name',
  'pages.adminManagement.personalTag': 'Personal',
  'pages.adminManagement.owner': 'Owner',
  'pages.adminManagement.deletedUserTag': 'Deleted User',
  'pages.adminManagement.members': 'Members',
  'pages.adminManagement.options': 'Options',
  'pages.adminManagement.manageGroupTooltip': 'Manage Group',
  'pages.adminManagement.manageFilesTooltip': 'Manage Files',
  'pages.adminManagement.removeGroupTooltip': 'Remove Group',
  'pages.adminManagement.stats.totalUsers': 'Total Users',
  'pages.adminManagement.stats.totalGroups': 'Total Groups',
  'pages.adminManagement.stats.personalGroups': 'Personal Groups',
  'pages.adminManagement.stats.sharedGroups': 'Shared Groups',
  'pages.adminManagement.stats.totalFiles': 'Total Files',
  'pages.adminManagement.stats.totalFolders': 'Total Folders',
  'pages.adminManagement.sharedTag': 'Shared',
  'pages.adminManagement.moveAll': 'Move All',
  'pages.adminManagement.fileDescription': '{username} · {action} {date}',
  'pages.adminManagement.fileAction.uploaded': 'Uploaded',
  'pages.adminManagement.fileAction.created': 'Created',
  'pages.adminManagement.createGroupButton': 'Create Group',
  'pages.adminManagement.modifyUserGroupTitle': 'Modify User Group',
  'pages.adminManagement.createUserGroupTitle': 'Create User Group',
  'pages.adminManagement.updateSubmitText': 'Update',
  'pages.adminManagement.userGroupUpdatedSuccess': 'User group updated successfully',
  'pages.adminManagement.userGroupCreatedSuccess': 'User group created successfully',
  'pages.adminManagement.groupNameRequiredMessage': 'Please enter group name',
  'pages.adminManagement.ownerRequiredMessage': 'Please select group owner',
  'pages.adminManagement.membersRequiredMessage': 'Please select group members',
  'pages.adminManagement.moveFolderTitle': 'Move Folder',
  'pages.adminManagement.moveFileTitle': 'Move File',
  'pages.adminManagement.allMovedSuccess': 'All moved successfully',
  'pages.adminManagement.folderMovedSuccess': 'Folder moved successfully',
  'pages.adminManagement.fileMovedSuccess': 'File moved successfully',
  'pages.adminManagement.destinationGroupLabel': 'Destination Group',
  'pages.adminManagement.destinationGroupRequiredMessage': 'Please select destination group',
  'pages.adminManagement.destinationFolderPlaceholder': 'Select destination folder',
  'pages.adminManagement.renameOptionalLabel': 'Rename (optional)',
  'pages.adminManagement.loadFolderDataError': 'Failed to load folder data',
  'pages.adminManagement.ownerCannotBeRemovedWarning':
    'The group owner cannot be removed from members',
  'pages.aISetting.promptCopied': 'Prompt copied!',
  'pages.aISetting.failedToCopyPrompt': 'Failed to copy prompt',
  'pages.aISetting.updatedByMeta': 'Updated {date} by {user}',
  'pages.aISetting.updateButton': 'Update',
  'pages.aISetting.systemPromptLabel': 'System Prompt',
  'pages.aISetting.additionalPromptLabel': 'Additional Prompt',
  'pages.aISetting.temperatureLabel': 'Temperature',
  'pages.aISetting.updatedBadge': 'Updated!!',
  'pages.aISetting.requiredParamsMissing': 'Required parameter(s) missing: {params}',
  'pages.angelInsider.micrositeFrameTitle': 'A&GEL Insider',
  'pages.angelInsider.nav.basics': 'Basics',
  'pages.angelInsider.nav.learnMore': 'Learn More',
  'pages.angelInsider.nav.whatsNew': "What's New",
  'pages.angelInsider.nav.futureStuff': 'Future Stuff',
  'pages.angelInsider.nav.logoAlt': 'A&GEL Insider',
  'pages.angelInsider.landing.tiles.basics.title': 'Basics',
  'pages.angelInsider.landing.tiles.basics.subtitle':
    'Start here. Everything you need from day one.',
  'pages.angelInsider.landing.tiles.learnMore.title': 'Learn More',
  'pages.angelInsider.landing.tiles.learnMore.subtitle':
    'Power features for those who want to go further.',
  'pages.angelInsider.landing.tiles.whatsNew.title': "What's New",
  'pages.angelInsider.landing.tiles.whatsNew.subtitle': 'Recently launched features and updates.',
  'pages.angelInsider.landing.tiles.comingUp.title': 'Future Stuff',
  'pages.angelInsider.landing.tiles.comingUp.subtitle': 'What the team is building next.',
  'pages.angelInsider.landing.pills.all': 'All',
  'pages.angelInsider.landing.pills.chatAndContext': 'Chat & Context',
  'pages.angelInsider.landing.pills.filesAndVault': 'Files & Vault',
  'pages.angelInsider.landing.pills.promptLibrary': 'Prompt Library',
  'pages.angelInsider.landing.pills.quickInfo': 'Quick Info',
  'pages.angelInsider.landing.pills.scribe': 'Scribe',
  'pages.angelInsider.landing.pills.disputeResolution': 'Dispute Resolution',
  'pages.angelInsider.landing.pills.sideBySide': 'Side-by-Side',
  'pages.angelInsider.landing.pills.multiStepPrompt': 'Multi-Step Prompt',
  'pages.angelInsider.landing.pills.timeline': 'Timeline',
  'pages.angelInsider.landing.pills.workstudio': 'Workstudio',
  'pages.angelInsider.landing.pills.deepResearch': 'Deep Research',
  'pages.angelInsider.landing.pills.scopeSummary': 'Scope Summary',
  'pages.angelInsider.landing.pills.review': 'Review',
  'pages.angelInsider.landing.pills.whatsNew': "What's New",
  'pages.angelInsider.landing.pills.futureStuff': 'Future Stuff',
  'pages.angelInsider.landing.preferOneFeature': 'Prefer to learn one feature at a time?',
  'pages.angelInsider.landing.scrollFeatureList': 'Scroll feature list',
  'pages.angelInsider.basics.habits.habit1.num': 'Habit 01',
  'pages.angelInsider.basics.habits.habit1.title': 'Give A&GEL Something to Work With',
  'pages.angelInsider.basics.habits.habit1.intro':
    'The most common mistake new users make is underestimating the importance of giving AI tools sufficient information to work with as a starting point.',
  'pages.angelInsider.basics.habits.habit2.num': 'Habit 02',
  'pages.angelInsider.basics.habits.habit2.title':
    'Use LLMs as "Text Processors", Not Knowledge Engines',
  'pages.angelInsider.basics.habits.habit2.intro':
    'It is crucial to understand what Large Language Models (LLMs) actually are. They are not databases of truth, nor are they substitutes for human judgment. Instead, think of an LLM as a high-speed CPU or processor for language and basic cognitive tasks.',
  'pages.angelInsider.basics.habits.habit3.num': 'Habit 03',
  'pages.angelInsider.basics.habits.habit3.title': "Don't Just Chat—Explore other features",
  'pages.angelInsider.basics.heading': 'Basics',
  'pages.angelInsider.basics.welcome.intro':
    'We’re thrilled to have you here. As you begin exploring A&GEL, we want to share a few thoughts to get you started on good footing.',
  'pages.angelInsider.basics.welcome.timeHeading':
    'Learning New Tools Takes Time – And That’s Okay',
  'pages.angelInsider.basics.welcome.supportParagraph':
    'We know that getting comfortable with new technology can feel challenging at first. Please remember: we’re here to support you every step of the way. Don’t hesitate to reach out to us if you have any questions, got stuck somewhere, or simply would like our help to walk you through something.',
  'pages.angelInsider.basics.welcome.differentParagraph':
    'AI tools like A&GEL <strong>are different</strong> from the ones before — they empower <strong>you directly</strong>. Think of it like having an army of assistants at your fingertips: they may not replace human judgment, but in many ways, they amplify your capabilities far beyond what’s possible alone.',
  'pages.angelInsider.basics.welcome.bestWayParagraph':
    '<strong>The best way to start learning is to start using A&GEL —</strong> we encourage you to explore freely. Try things out, make mistakes (the safe kind), and discover what works best for you.',
  'pages.angelInsider.basics.welcome.pacingHeading': 'Progress at Your Own Pace',
  'pages.angelInsider.basics.welcome.staircaseParagraph':
    'Think of skill-building like climbing a staircase. Start with the basics, and as you grow more confident, moving to the next level will feel much more natural. There’s no rush — this isn’t a race. Take the time you need to build a strong foundation.',
  'pages.angelInsider.basics.welcome.togetherHeading': 'Together, We Can Go Further',
  'pages.angelInsider.basics.welcome.togetherParagraph':
    'When teams and firms embrace A&GEL together, the benefits compound for everyone. Sharing knowledge and collaborating across your community of users creates a ripple effect that lifts all.',
  'pages.angelInsider.basics.welcome.welcomeAboardParagraph':
    'Welcome aboard — we’re excited to see what we can accomplish with A&GEL.',
  'pages.angelInsider.basics.welcome.signatureName': 'Kok Leong',
  'pages.angelInsider.basics.welcome.signatureTeam': 'A&GEL Development Team',
  'pages.angelInsider.basics.welcome.ctaLetsBegin': 'Let’s begin →',
  'pages.angelInsider.basics.habitsSection.title': 'Just 3 Habits to Guide You On Your Journey',
  'pages.angelInsider.basics.habitsSection.intro':
    'Getting started with A&GEL is about more than just typing a question and hitting enter in Chat. To truly harness the power of AI tools like A&GEL, you need to shift how you think about interacting with AI.',
  'pages.angelInsider.basics.habitsSection.lockHint':
    'Click on the panel to lock in a wider viewing surface. Click to unlock.',
  'pages.angelInsider.reader.back': '← Back',
  'pages.angelInsider.reader.label': 'A&GEL INSIDER',
  'pages.angelInsider.reader.contents': 'Contents',
  'pages.angelInsider.reader.issueNumber': 'Issue {number}',
  'pages.angelInsider.reader.featureGuide': 'Feature Guide',
  'pages.angelInsider.reader.minRead': '{minutes} min read',
  'pages.angelInsider.reader.atAGlance': 'At a glance',
  'pages.angelInsider.blockRenderer.supportedAlt': 'Supported',
  'pages.angelInsider.typewriterExample.badLabel': 'This is ok:',
  'pages.angelInsider.typewriterExample.goodLabel': 'But this is better:',
  'pages.angelInsider.basics.habits.labels.takeaways': 'Takeaways',
  'pages.angelInsider.basics.habits.labels.examples': 'Examples',
  'pages.angelInsider.basics.habits.labels.benefits': 'Benefits',
  'pages.angelInsider.basics.habits.habit1.tile.patternMatchers':
    'AI tools like A&GEL are not mind-readers; they are <strong>pattern-matchers</strong>. If you ask a vague question, you will get a generic answer. If you provide rich, specific context, you are much more likely to get a precise, actionable result.',
  'pages.angelInsider.basics.habits.habit1.tile.callItContext':
    'Let’s call this starting point <strong>“context.”</strong>',
  'pages.angelInsider.basics.habits.habit1.tile.rawMaterial':
    'Think of context as the raw material A&GEL works with. When drafting a legal memo, don’t just say, “Summarise this case.” Instead, upload the judgment, identify the key factual or legal issues you are concerned with, and tell the AI who the audience is (or you could use pre-made prompts which we have developed for summarising which can be found in the Prompt Library). As a general rule, the more context you provide, the better A&GEL performs.',
  'pages.angelInsider.basics.habits.habit1.tile.promptLibraryLink': 'See more on Prompt Library',
  'pages.angelInsider.basics.habits.habit1.tile.empowerYou':
    'AI tools like A&GEL empower <em>you</em> directly—they amplify your capabilities, but only if you provide the direction. Without context, the AI is like a brilliant lawyer who hasn’t been briefed on the facts, or a capable colleague who lacks the background information needed to do the job.',
  'pages.angelInsider.basics.habits.habit1.tile.vault.title': 'Your Vault is your brain on A&GEL',
  'pages.angelInsider.basics.habits.habit1.tile.vault.body':
    'Your Vault is the primary source of context for A&GEL, grounding its outputs in your trusted, curated knowledge base. A&GEL does not search the internet – it works strictly within what you have uploaded. Think of it as a tireless co-worker: hand them a messy desk of unrelated files and their work suffers; hand them a single, relevant precedent and their work sharpens. Organise files into logical sub-folders, be selective about uploads, and use Referenced File Weight and Session File Weight to fine-tune what A&GEL prioritises. Treat your Vault like a curated library, not a landfill.',
  'pages.angelInsider.basics.habits.habit1.tile.vault.link': 'See more on Your Vault',
  'pages.angelInsider.basics.habits.habit1.tile.documents.title':
    'Giving A&GEL specific documents before you prompt',
  'pages.angelInsider.basics.habits.habit1.tile.documents.body':
    'If you drag and drop a file onto chat or select a file and chat with it, this is like loading A&GEL’s short-term memory only with the contents of that document. Many of you who attended our workshops would have heard us describing the file as the ‘K-drama episode you just watched last night’ (<em>it is all you want to talk about today</em>). This makes A&GEL have tunnel vision and can be channeled for accurate outputs.',
  'pages.angelInsider.basics.habits.habit1.tile.documents.link': 'See more on Context',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.title':
    'Working with A&GEL is not unlike working with a colleague',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.body':
    'Just as you would give a team member some information to help them along the way, it is the same with A&GEL.',
  'pages.angelInsider.basics.habits.habit1.tile.query.title':
    'What about the query or instruction in my prompt itself? Does that count as ‘giving something to A&GEL?’',
  'pages.angelInsider.basics.habits.habit1.tile.query.body':
    'Yes. To AI tools like A&GEL, the prompt is ingested/processed just as a series of words, so this means the entire prompt is just ‘context’ for the AI tool or A&GEL. If you are asking a question in your prompt, ask better questions and you will get better answers.',
  'pages.angelInsider.basics.habits.habit1.tile.query.link': 'See more on Prompting',
  'pages.angelInsider.basics.habits.habit1.tile.benefitsIntro':
    'By giving A&GEL rich context, you gain:',
  'pages.angelInsider.basics.habits.habit1.tile.benefit1':
    '<strong>Better Outputs:</strong> Specific context produces specific results — a well-briefed A&GEL behaves like a colleague who already knows the facts of the matter, not one starting from scratch.',
  'pages.angelInsider.basics.habits.habit1.tile.benefit2':
    '<strong>Fewer Iterations:</strong> The more precise your starting point, the less time you spend reprompting or correcting. Get it right earlier in the chain.',
  'pages.angelInsider.basics.habits.habit1.tile.benefit3':
    '<strong>Tunnel Vision (the good kind):</strong> Uploading a specific document before you prompt locks A&GEL’s focus — it works only within that context, which means higher accuracy and less noise in the output.',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.bad':
    'Treating each A&GEL chat as a one-off, starting from zero every time',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.good':
    'Loop A&GEL in like a new colleague joining the team — a short brief on the matter, the parties, and what you’re trying to achieve before asking it to get to work.',
  'pages.angelInsider.basics.habits.habit1.examples.clause.bad':
    'Asking A&GEL to “Review this clause”',
  'pages.angelInsider.basics.habits.habit1.examples.clause.good':
    '“Review this clause for the [customer], for […]” and state what the review should be looking out for (e.g. “any issues that relate to fees or financial matters”).',
  'pages.angelInsider.basics.habits.habit2.tile.intro':
    'An LLM excels at structuring information, identifying patterns, drafting text, and organising complex data. It is a tool for <em>processing</em>, not for <em>deciding</em>. You remain the judge, the strategist, and the final authority. The AI handles the heavy lifting of language manipulation—rephrasing, summarising, extracting clauses—while you apply your professional expertise to validate the output. This distinction is vital: trust the AI to process, but never outsource your judgment. As the guide reminds us, AI tools “may not replace human judgment, but in many ways, they amplify your capabilities.”',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.title':
    'Break it down (especially long prompts)',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.body':
    'Many users treat A&GEL like a simple chatbot, typing one long prompt and hoping for the best. This is not the best way to use AI tools like A&GEL. Advanced users break down complex tasks into smaller, manageable ones – so instead of one large prompt, have several sub-prompts. This technique, known as <em>decomposition</em>, often leads to higher quality results.',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.imageAlt': 'One Long Prompt',
  'pages.angelInsider.basics.habits.habit2.tile.oneGoExample':
    'Running a large, elaborate, multi-part prompt at one go, e.g. “prepare a report that captures all my concerns from document 1 and document 2 and then summarise the report to create an executive summary and thereafter combine the full report and executive summary into one document”.',
  'pages.angelInsider.basics.habits.habit2.tile.breakTaskIntro':
    'Break the task into smaller, sequential steps and execute them using Multi-Step Prompt in Apps.',
  'pages.angelInsider.basics.habits.habit2.tile.step1.title': 'Step 1: Extraction',
  'pages.angelInsider.basics.habits.habit2.tile.step1.context':
    'Input Context: [<em>Insert text of Document 1 and Document 2</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step1.prompt':
    'Prompt 1: “Generate a comprehensive, bulleted list of all the concerns, issues, or risks mentioned across both documents.”',
  'pages.angelInsider.basics.habits.habit2.tile.step2.title': 'Step 2: Drafting the Full Report',
  'pages.angelInsider.basics.habits.habit2.tile.step2.context':
    'Input Context: [<em>Insert output from Step 1</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step2.prompt':
    'Prompt 2: “Prepare a detailed, formal report using the bulleted list. Group similar concerns under relevant headings. Do not include an introduction or executive summary.”',
  'pages.angelInsider.basics.habits.habit2.tile.step3.title':
    'Step 3: Executive Summary & Final Compilation',
  'pages.angelInsider.basics.habits.habit2.tile.step3.context':
    'Input Context: [<em>Insert output from Step 2</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step3.prompt':
    'Prompt 3: “First, write a concise, one-paragraph executive summary of the formal report. Then, output the executive summary, add a visual divider, and output the exact formal report below it to create one combined document.”',
  'pages.angelInsider.basics.habits.habit2.tile.multiStepLink':
    'See full worked example on Multi-Step Prompt',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.title':
    'Use A&GEL to reshape, format, or extrapolate from existing text',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.body':
    'Rather than asking A&GEL to draft complex legal documents from scratch without any reference materials, do provide reference materials and (i) use A&GEL’s language abilities to take your drafts and change their tone, structure, or formatting, or mash multiple drafts together; or (ii) extrapolate intention, direction, implications, or other second-order characteristics (e.g. to create a Review checklist of findings across several paragraphs or documents).',
  'pages.angelInsider.basics.habits.habit2.tile.benefitsIntro':
    'By treating A&GEL as a text processor and breaking down your tasks, you gain:',
  'pages.angelInsider.basics.habits.habit2.tile.benefit1':
    '<strong>Higher Quality Outputs:</strong> Decomposing a complex task into sub-prompts lets A&GEL focus on one thing at a time — each step builds cleanly on the last, rather than collapsing under the weight of a single overloaded prompt.',
  'pages.angelInsider.basics.habits.habit2.tile.benefit2':
    '<strong>More Predictable Results:</strong> When you control each step, you control the output. You validate before moving forward, rather than hoping one large prompt landed correctly.',
  'pages.angelInsider.basics.habits.habit2.tile.benefit3':
    '<strong>Better Use of Your Expertise:</strong> A&GEL handles the heavy lifting of language — rephrasing, structuring, extracting. You stay in the role of reviewer and strategist, which is where your judgment matters most.',
  'pages.angelInsider.basics.habits.habit2.examples.nda.bad':
    'Asking A&GEL to “Draft an NDA for a software project”',
  'pages.angelInsider.basics.habits.habit2.examples.nda.good':
    '“Here is our standard NDA template [paste]. Update the confidentiality term to 5 years, add a carve-out for regulatory disclosures, and replace all references to Singapore law with Hong Kong law.”',
  'pages.angelInsider.basics.habits.habit3.tile.intro':
    'By exploring features beyond simple chat—such as uploading documents, using specific Apps or Specialised Features, or chaining features together through steps—you gain granular control over the output.',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.title': 'Experimentation is key',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.body':
    'Please experiment and explore the other features freely and try things out. Many of the features under the Specialised Modes are tuned for more accuracy and thoroughness. Discover which features work best for your workflow, and don’t be afraid to make mistakes. Skill-building is like climbing a staircase; start with the basics, and as you grow more confident, you will naturally move to more advanced techniques.',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.closing':
    'By mastering context, respecting the AI’s role as a text processor (and your own, as the expert), and breaking down complex tasks, you will transform A&GEL from a novelty into an indispensable part of your daily practice.',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.title':
    'A&GEL is less chatbot and more Swiss Army knife',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.body':
    'It’s a design choice we made at the start to feature a versatile suite of knowledge tools designed to cut through complexity with precision, instead of folding every capability into a single chat window. Chat is great for brainstorming and quick questions, but it struggles on really large documents (e.g. documents over 20,000 words) or complex multi-step or multi-part tasks. Instead of hiding these power tools inside chat, we put them front and center in the left-hand sidebar. Our goal is to help you connect your specific work objectives with the right feature—or combination of features.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.title':
    'Explore other features beyond Chat',
  'pages.angelInsider.basics.habits.habit3.tile.explore.review':
    'Review: Ideal for multi-document analysis, due diligence, and navigating complex files using structured question lists.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.reviewLink': 'See more on Review',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudio':
    'Workstudio: Standardises contract drafting by automatically enforcing house positions.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudioLink': 'See more on Workstudio',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribe':
    'Scribe: Transcribes audio files into precise text, including live transcription and simultaneous translation for cross-border calls.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribeLink': 'See more on Scribe',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfo':
    'Quick Info / Guided Summary: A fast, sourced read of any single document. Quick Info for a snapshot; Guided Summary when you want to steer the focus.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfoLink':
    'See more on Quick Info & Guided Summary',
  'pages.angelInsider.basics.habits.habit3.tile.explore.translation':
    'Translation: Provides dedicated, paragraph-level accurate translation for legal and business content.',
  'pages.angelInsider.basics.habits.habit3.tile.explore.apps':
    'Apps: Tuned for higher accuracy and thoroughness in specific tasks. For instance, Multi-Step Prompt offers a variety of analysis tools for dissecting documents for specific points, providing the precision needed for longer, more complex workloads that exceed Chat’s capabilities.',
  'pages.angelInsider.basics.habits.habit3.tile.benefitsIntro':
    'By mapping your tasks to specific features, you gain:',
  'pages.angelInsider.basics.habits.habit3.tile.benefit1':
    '<strong>More Control:</strong> Higher accuracy by selecting the right tool for the job, instead of relying on a single chat interface.',
  'pages.angelInsider.basics.habits.habit3.tile.benefit2':
    '<strong>Skill Building:</strong> Experimentation is key. As you try different features and combinations, you build a mental model of what A&GEL can do. This is like climbing a staircase: start with basic queries in Chat, then graduate to complex multi-step analyses in Apps or Review as your skill grows.',
  'pages.angelInsider.basics.habits.habit3.tile.benefit3':
    '<strong>Efficiency:</strong> Knowing which tool to use saves time. You stop wrestling with prompts in Chat for tasks that are better handled by dedicated features like Scribe for transcription or Translation for precise language conversion.',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.bad':
    'Only ever using Chat, even for 90-page agreements or multi-step analysis',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.good':
    'Trying Review on a lengthy contract, or Multi-Step Prompt for a task with several stages — and noting which feature felt faster or more accurate for that job.',
  'pages.angelInsider.basics.habits.habit3.examples.paste.bad':
    'Pasting a 90-page agreement into Chat and asking “what are the risks?”',
  'pages.angelInsider.basics.habits.habit3.examples.paste.good':
    'Run it through ‘Review’ with a structured question list — or ‘Multi-Step’ in Apps — to work through the document section by section and pinpoint exactly what you are looking for.',
  'pages.angelInsider.seeMore': 'See More',
  'pages.angelInsider.learnMore.heading': 'Learn More',
  'pages.angelInsider.learnMore.intro':
    'Beyond Chat, A&GEL’s Apps mode covers focused tasks: Deep Research, Guided Summary, Quick Info, Timeline, and Extract Deadlines. These features reward precision and preparation.',
  'pages.angelInsider.learnMore.featuredBadge': 'Featured',
  'pages.angelInsider.learnMore.cards.usingFiles.title': 'Using your files on A&GEL',
  'pages.angelInsider.learnMore.cards.usingFiles.body':
    'Scanned hard copies need a text layer before A&GEL can read them. Use Kofax to make your PDF searchable, then upload.',
  'pages.angelInsider.learnMore.cards.workStudio.title': 'Workstudio',
  'pages.angelInsider.learnMore.cards.workStudio.body':
    'Encode your team’s house position once — A&GEL returns a Word document in tracked changes.',
  'pages.angelInsider.learnMore.cards.workStudio.imageAlt': 'Workstudio',
  'pages.angelInsider.learnMore.cards.review.title': 'Review',
  'pages.angelInsider.learnMore.cards.review.body':
    'Pose multiple questions across multiple documents at once — outputs appear in a table with inline citations. Use mini-chat to follow up without leaving the page.',
  'pages.angelInsider.learnMore.cards.review.imageAlt': 'Review mode',
  'pages.angelInsider.learnMore.cards.dispute.title': 'Dispute Resolution',
  'pages.angelInsider.learnMore.cards.dispute.body':
    'Case summaries, SOC analysis, Defence drafting, and pleadings tracking across the full document set.',
  'pages.angelInsider.learnMore.cards.dispute.imageAlt': 'Pleadings Tracker',
  'pages.angelInsider.learnMore.cards.sideBySide.title': 'Side-by-Side & Comparison',
  'pages.angelInsider.learnMore.cards.sideBySide.body':
    'Clause-by-clause review with full source-paragraph verification. Comparison handles tracked changes and amendments.',
  'pages.angelInsider.learnMore.cards.sideBySide.imageAlt': 'Side-by-Side analysis',
  'pages.angelInsider.learnMore.cards.multiStep.title': 'Multi-Step Prompt',
  'pages.angelInsider.learnMore.cards.multiStep.body':
    'Break complex legal tasks into sequential steps, each building on the last.',
  'pages.angelInsider.learnMore.cards.multiStep.imageAlt': 'Apps mode',
  'pages.angelInsider.learnMore.cards.timeline.title': 'Timeline',
  'pages.angelInsider.learnMore.cards.timeline.body':
    'Combine chronologies across up to 100 documents into one source-verified timeline.',
  'pages.angelInsider.learnMore.cards.timeline.imageAlt': 'Timeline',
  'pages.angelInsider.learnMore.cards.deepResearch.title': 'Deep Research',
  'pages.angelInsider.learnMore.cards.deepResearch.body':
    'Run deep, cross-document analysis under a structured research prompt. Every finding links back to its source paragraph via clickable inline citations.',
  'pages.angelInsider.learnMore.cards.deepResearch.imageAlt': 'Deep Research',
  'pages.angelInsider.learnMore.cards.scopeSummary.title': 'Scope Summary',
  'pages.angelInsider.learnMore.cards.scopeSummary.body':
    'Generate a structured summary scoped to your defined focus areas. Every extracted point carries a clickable inline citation to verify against the source.',
  'pages.angelInsider.learnMore.faq.heading': 'Frequently Asked Questions',
  'pages.angelInsider.learnMore.faq.group1.kicker': 'General Principles',
  'pages.angelInsider.learnMore.faq.experts.question':
    'What does “always let subject matter experts be subject matter experts” mean?',
  'pages.angelInsider.learnMore.faq.experts.answer':
    'Your judgment, insight, and integrity as a professional should remain at the heart of your work. A&GEL does not replace your expertise — it is designed to help you do more with more.',
  'pages.angelInsider.learnMore.faq.unfamiliar.question':
    'What if I am completely unfamiliar with the subject matter I am asking A&GEL about?',
  'pages.angelInsider.learnMore.faq.unfamiliar.answer':
    'You can still use A&GEL — but be more mindful and conduct more checks on the output. Consider using A&GEL as a gateway to your team’s existing know-how, gaining on-demand insights to support your training and development.',
  'pages.angelInsider.learnMore.faq.group2.kicker': 'File Management',
  'pages.angelInsider.learnMore.faq.referenceMaterial.question':
    'What kind of reference material should I upload to A&GEL?',
  'pages.angelInsider.learnMore.faq.referenceMaterial.answer':
    'Upload only trusted, reliable, and accurate material — primary legal sources (statutes, case law) and trusted internal materials (company know-how, proven documents). Maintain a clear naming convention.',
  'pages.angelInsider.learnMore.faq.thirdParty.question': 'Can I upload third-party documents?',
  'pages.angelInsider.learnMore.faq.thirdParty.answer':
    'Yes — including documents from opposing counsel. Upload them to a clearly labelled folder to distinguish them from your trusted precedents. Observe any applicable company policies on AI usage and third-party content.',
  'pages.angelInsider.learnMore.faq.processingTime.question':
    'Why does A&GEL take a long time to process uploaded files?',
  'pages.angelInsider.learnMore.faq.processingTime.answer':
    'Documents must be converted into “embeddings” that A&GEL can work with — this happens once on upload. In Chat, re-use an uploaded document in a fresh session by selecting it via the Context button.',
  'pages.angelInsider.learnMore.faq.bulkUpload.question': 'How should I upload documents in bulk?',
  'pages.angelInsider.learnMore.faq.bulkUpload.answer':
    'In File mode, click the upload button at the top right, select your files, and press “Open”. You can continue using A&GEL while the upload is in progress.',
  'pages.angelInsider.learnMore.faq.sorting.question':
    'How should I sort and manage my reference materials?',
  'pages.angelInsider.learnMore.faq.sorting.answer':
    'Do not upload everything into one folder. Group documents by (i) subject matter and (ii) workflow — e.g. <code>Home / IP Licensing / Licensor</code>. This helps A&GEL retrieve the right context and makes it easier to verify its outputs.',
  'pages.angelInsider.learnMore.faq.group3.kicker': 'Prompting',
  'pages.angelInsider.learnMore.faq.promptTypes.question': 'What types of prompts can I use?',
  'pages.angelInsider.learnMore.faq.promptTypes.answer':
    'Information-seeking (question-based, explanation, research), task-oriented (instruction, multi-step, template-based), analytical (data analysis, problem-solving, comparative), classification (classify, sort, tag), and transformation (translation, format conversion, style) prompts — among others.',
  'pages.angelInsider.learnMore.faq.effectivePrompts.question': 'How do I write effective prompts?',
  'pages.angelInsider.learnMore.faq.effectivePrompts.answer':
    'The most effective prompts have four parts: <strong>(a) Persona</strong> — who A&GEL should emulate; <strong>(b) Task</strong> — the specific instruction; <strong>(c) Context</strong> — background information and reference material; <strong>(d) Format</strong> — how you want the output structured.',
  'pages.angelInsider.learnMore.faq.rag.question': 'What is RAG and when does A&GEL use it?',
  'pages.angelInsider.learnMore.faq.rag.answer':
    'RAG (Retrieval-Augmented Generation) is A&GEL’s default Chat mode. It draws on your Vault reference materials and passes them to the model alongside your prompt, enhancing the precision and reliability of the output.',
  'pages.angelInsider.learnMore.faq.allMaterials.question':
    'Why shouldn’t I allow A&GEL to consider all my uploaded materials for every prompt?',
  'pages.angelInsider.learnMore.faq.allMaterials.answer':
    'Providing irrelevant context reduces speed, accuracy, and reliability. A&GEL operates probabilistically and may draw from materials not suited to your current task. Restrict context to only the documents relevant to your prompt.',
  'pages.angelInsider.learnMore.faq.selectMaterials.question':
    'How do I select the relevant reference materials for each prompt?',
  'pages.angelInsider.learnMore.faq.selectMaterials.answer':
    'In Chat mode, navigate to “Context”, click the selection symbol, and select only the relevant documents or folders.',
  'pages.angelInsider.learnMore.faq.group4.kicker': 'Using Outputs',
  'pages.angelInsider.learnMore.faq.outputAsIs.question': 'May I use A&GEL’s output as-is?',
  'pages.angelInsider.learnMore.faq.outputAsIs.answer':
    'No — always check A&GEL’s output before use. Treat it as a starting point and cross-check against trusted knowledge sources, including your uploaded reference materials.',
  'pages.angelInsider.learnMore.faq.accuracy.question':
    'How should I check the accuracy and reliability of the output?',
  'pages.angelInsider.learnMore.faq.accuracy.answer':
    'In Chat mode, outputs include reference links to the source documents A&GEL drew from. Click each reference to verify it against the original material. A&GEL should be a gateway to your know-how — not the source of it. Outputs without references are prone to hallucinations and should not be used unless the prompt was purely for writing, formatting, or text-editing with sufficient context provided.',
  'pages.angelInsider.learnMore.faq.group5.kicker': 'Glossary',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.term': 'Favourite File Weight',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.definition':
    'Adjusts how heavily A&GEL prioritises documents flagged as “favourites” in Vault when generating responses.',
  'pages.angelInsider.learnMore.glossary.reRanking.term': 'Re-Ranking',
  'pages.angelInsider.learnMore.glossary.reRanking.definition':
    'A secondary sorting process that reviews initial search results to prioritise the most relevant clauses and text segments before the response is generated.',
  'pages.angelInsider.learnMore.glossary.searchRatio.term': 'Search Ratio',
  'pages.angelInsider.learnMore.glossary.searchRatio.definition':
    'Controls how broadly A&GEL searches your Vault. Higher ratio = broader context; lower ratio = exact-match focus.',
  'pages.angelInsider.learnMore.glossary.systemPrompt.term': 'System Prompt',
  'pages.angelInsider.learnMore.glossary.systemPrompt.definition':
    'The base instructions that establish A&GEL’s role, tone, and boundaries for every session.',
  'pages.angelInsider.learnMore.glossary.thinking.term': '‘Thinking’ / ‘Reasoning’',
  'pages.angelInsider.learnMore.glossary.thinking.definition':
    'A&GEL’s internal step-by-step deliberation before generating a final response, intended to reduce errors in complex analysis.',
  'pages.angelInsider.learnMore.issues.heading': 'If you want to read the issues',
  'pages.angelInsider.learnMore.issues.issue1.title': 'Context is (Almost) Everything',
  'pages.angelInsider.learnMore.issues.issue1.description':
    'Basics • Prompting Essentials • 17 Feb 2026',
  'pages.angelInsider.learnMore.issues.issue2.title': 'Dispute Resolution Use Cases',
  'pages.angelInsider.learnMore.issues.issue2.description':
    'Case summaries • Pleadings tracker • Tips for prompting • 19 Mar 2026',
  'pages.angelInsider.learnMore.issues.issue3.title': 'New Timeline & Multi-Step Prompt Apps',
  'pages.angelInsider.learnMore.issues.issue3.description':
    'Email uploads • Scribe updates • Timeline revamp • 19 Mar 2026',
  'pages.angelInsider.learnMore.issues.issue4.title': 'Scribe Live Translation & Workstudio',
  'pages.angelInsider.learnMore.issues.issue4.description':
    'Live translation • New Workstudio feature • 1 Apr 2026',
  'pages.angelInsider.learnMore.issues.issue5.title': 'Inline Referencing, Mini-Chat & More',
  'pages.angelInsider.learnMore.issues.issue5.description':
    'Pin-cite citations • Moveable mini-chat • Scribe timestamps • 10 Apr 2026',
  'pages.angelInsider.learnMore.issues.pill': 'Issue {number}',
  'pages.angelInsider.whatsNew.heading': "What's New",
  'pages.angelInsider.whatsNew.cards.msgUpload.title': '.msg Email Upload',
  'pages.angelInsider.whatsNew.cards.msgUpload.body':
    'Upload .msg email files directly, with full reading of attachments included.',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.title': 'Inline Referencing',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.body':
    'Deep Research, Timeline, Scope Summary, and Review now carry clickable pin-cite citations — verify any output against its source without leaving the page.',
  'pages.angelInsider.comingUp.heading': 'Future Stuff',
  'pages.angelInsider.comingUp.intro':
    'In the next issue of A&GEL Insider, we’ll go deeper into Workstudio. You’ll learn how to construct multi-step prompts from scratch and leverage them to generate tracked-changes drafts that reflect your team’s house position. Stay tuned.',
  'pages.angelInsider.comingUp.cards.workstudioV2.title': 'Workstudio V2',
  'pages.angelInsider.comingUp.cards.workstudioV2.body':
    'Deeper Workstudio authoring tools and expanded tracked-changes output. Details in Issue 5.',
  'pages.angelInsider.comingUp.cards.workstudioV2.badge': 'Coming Soon',
  'pages.angelInsider.comingUp.cards.moreToCome.title': 'More to Come',
  'pages.angelInsider.comingUp.cards.moreToCome.body':
    'The A&GEL team is continuously shipping. Stay tuned for the next Insider issue.',
  'pages.angelInsider.comingUp.cards.moreToCome.badge': 'In Pipeline',
  'pages.angelInsider.issues.basics-intro.title': 'Welcome to A&GEL',
  'pages.angelInsider.issues.basics-intro.subtitle':
    'A few thoughts to get you started on a good footing.',
  'pages.angelInsider.issues.basics-intro.glance.0':
    "Learning new tools takes time — we're here to support you every step.",
  'pages.angelInsider.issues.basics-intro.glance.1':
    'A&GEL tools <strong>amplify your capabilities</strong> far beyond what was possible alone.',
  'pages.angelInsider.issues.basics-intro.glance.2':
    'The best way to learn is to <strong>start using A&GEL</strong> — explore freely, make mistakes.',
  'pages.angelInsider.issues.basics-intro.glance.3':
    'When teams embrace A&GEL together, the benefits compound for everyone.',
  'pages.angelInsider.issues.basics-intro.sections.0.kicker': '01 — Getting started',
  'pages.angelInsider.issues.basics-intro.sections.0.heading':
    "Learning New Tools Takes Time – And That's Okay",
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.0.p':
    "We're thrilled to have you here. As you begin exploring A&GEL, we want to share a few thoughts to get you started on a good footing.",
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.1.p':
    "We know that getting comfortable with new technology can feel challenging at first. Please remember: we're here to support you every step of the way. Don't hesitate to reach out to us if you have any questions, got stuck somewhere, or simply would like our help to walk you through something.",
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.3.p':
    'AI tools like A&GEL <strong>are different</strong> from the ones before — they empower <strong>you directly</strong>. Think of it like having an army of assistants at your fingertips: they may not replace human judgment, but in many ways, they amplify your capabilities far beyond what was possible alone.',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.4.p':
    '<strong>The best way to start learning is to start using A&GEL —</strong> we encourage you to explore freely. Try things out, make mistakes (the same safe kind), and discover what works best for you.',
  'pages.angelInsider.issues.basics-intro.sections.1.kicker': '02 — Skill building',
  'pages.angelInsider.issues.basics-intro.sections.1.heading': 'Progress at Your Own Pace',
  'pages.angelInsider.issues.basics-intro.sections.1.blocks.0.p':
    "Think of skill-building like climbing a staircase. Start with the basics, and as you grow more confident, moving to the next level will feel much more natural. There's no rush — this isn't a race. Take the time you need to build a strong foundation.",
  'pages.angelInsider.issues.basics-intro.sections.2.kicker': '03 — Community',
  'pages.angelInsider.issues.basics-intro.sections.2.heading': 'Together, We Can Go Further',
  'pages.angelInsider.issues.basics-intro.sections.2.blocks.0.p':
    'When teams and firms embrace A&GEL together, the benefits compound for everyone. Sharing knowledge and collaborating across your community of users creates a ripple effect that lifts all.',
  'pages.angelInsider.issues.basics-intro.signoff.line':
    "Welcome aboard — we're excited to see what we can accomplish with A&GEL.",
  'pages.angelInsider.issues.basics-intro.signoff.name': 'Kok Leong<br>A&GEL Development Team',
  'pages.angelInsider.issues.issue-1.title': 'Context is (almost) Everything',
  'pages.angelInsider.issues.issue-1.subtitle':
    'Prompting essentials — how context selection shapes everything A&GEL returns.',
  'pages.angelInsider.issues.issue-1.date': '15 Jan 2026',
  'pages.angelInsider.issues.issue-1.glance.0':
    'Chat now has a dedicated <strong>Context</strong> button and a <strong>"% Context"</strong> indicator.',
  'pages.angelInsider.issues.issue-1.glance.1':
    'The default search parameter is now <strong>zero context</strong> — faster, ideal for proofreading and light edits.',
  'pages.angelInsider.issues.issue-1.glance.2':
    'Build a <strong>default context preset</strong> from your Vault for everyday work.',
  'pages.angelInsider.issues.issue-1.glance.3':
    'A prompt without context is just a guess — always supply the background only you hold.',
  'pages.angelInsider.issues.issue-1.sections.0.kicker': '01 — Chat',
  'pages.angelInsider.issues.issue-1.sections.0.heading':
    'Context in Chat: a dedicated button and a "% Context" indicator',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.0.p':
    "A&GEL's Chat function uses a customised <strong>Retrieval-Augmented Generation (RAG)</strong> pipeline. It draws on the know-how and reference materials in your Vault and passes that to the model to generate output. The single most important factor in RAG quality is <em>context selection</em> — how much of your Vault the answer is drawn from.",
  'pages.angelInsider.issues.issue-1.sections.0.blocks.1.p':
    'To make that visible, we have added a <strong>"% Context"</strong> indicator — a rough but useful at-a-glance signifier of how much of your Vault is in scope for the current chat session. Click the Context button to choose exactly which folders or files to chat with.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.title':
    'New default: zero context',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.body':
    'The default search parameter is now zero context (top-right of the Chat window). Chat is faster this way, generating from pre-trained public knowledge alone — ideal for simple queries like proofreading or editorial amendments. In the zero-context setting, A&GEL should respond within seconds.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.3.h': 'Set a default context for daily use',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.4.p':
    'Since A&GEL answers from <em>your</em> know-how, you may create a default context preset: click the Context button, select your folders, then the plus (+) button. Name the preset, optionally check <strong>"Set as default"</strong>, and click OK.',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.5.p':
    'Selecting <strong>every</strong> folder (100% context) makes A&GEL slower, as it searches every document — a broad parameter is not always optimal. Tailor the context to the specific query. Responses can take up to a minute depending on how many files you can access and the complexity of the query.',
  'pages.angelInsider.issues.issue-1.sections.1.kicker': '02 — Prompts',
  'pages.angelInsider.issues.issue-1.sections.1.heading': 'Always add your context when prompting',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.0.quote':
    'A prompt without context is just a guess — "prompt roulette".',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.1.p':
    'To be effective, prompts must be fed the right information — especially in fields of deep specialisation. Think of A&GEL as a capable assistant that needs the full picture: provide the background only you know — your key goals, success metrics, even examples of what a "good" or "bad" answer looks like.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.2.h':
    'A simple framework for richer prompts',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.3.p':
    'Keep asking yourself whether you have given enough context. This is where you exercise your subject-matter mastery — and where the quality of results can be night-and-day versus basic prompting.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.title': 'Litigation example',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.body':
    'Litigators get far sharper output by cloning a prompt and editing the square-bracketed parts to suit their matter. The more legal context (a short summary of the applicable law) and commercial context (the surrounding facts) you supply, the better the prompt performs as an analyser.',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.5.p':
    'You know your context best — so always add the particular type of context that brings out the effectiveness of your prompts, question lists and custom instructions.',
  'pages.angelInsider.issues.issue-1.sections.2.kicker': '03 — Get started',
  'pages.angelInsider.issues.issue-1.sections.2.heading': 'Need help?',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.title':
    'Hit an issue? Tell us three things',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.body':
    'Message or e-mail the A&GEL Developer. It is enough to include:',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.0':
    '<strong>Timestamp</strong> — e.g. "a chat I started at 4:31pm today"',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.1':
    '<strong>Feature in issue</strong> — e.g. "tried uploading a file in Analysis → Deep Research, it did not load"',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.2':
    '<strong>Brief description</strong> or screenshots',
  'pages.angelInsider.issues.issue-1.signoff.line': 'Cheers, and remember — context first.',
  'pages.angelInsider.issues.issue-1.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.issue-2.title': 'Dispute Resolution Use Cases',
  'pages.angelInsider.issues.issue-2.subtitle':
    'Generate summaries and first drafts, analyse and track pleadings — plus tips for prompting.',
  'pages.angelInsider.issues.issue-2.date': '12 Feb 2026',
  'pages.angelInsider.issues.issue-2.glance.0':
    'Two <strong>Case Summariser</strong> prompts (Concise & Detailed) — the Detailed version shines on complex judgments.',
  'pages.angelInsider.issues.issue-2.glance.1':
    'Prompts to draft a <strong>Defence</strong> and client-facing <strong>legal updates</strong>.',
  'pages.angelInsider.issues.issue-2.glance.2':
    'A suite of prompts to <strong>analyse pleadings</strong> — Statement of Claim, Defence, and sufficiency.',
  'pages.angelInsider.issues.issue-2.glance.3':
    'Use <strong>Review mode</strong> as a pleadings tracker across multiple documents.',
  'pages.angelInsider.issues.issue-2.sections.0.kicker': '01 — Summaries',
  'pages.angelInsider.issues.issue-2.sections.0.heading': 'Generate case summaries',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.0.p':
    "We have developed two prompts for summarising cases — one for a concise overview, one for a more detailed analysis. They were adapted from SAL's published prompts and refined with generative AI (including by asking A&GEL to critique its own output).",
  'pages.angelInsider.issues.issue-2.sections.0.blocks.1.p':
    'In our experience the <strong>Detailed</strong> Case Summariser is generally superior, especially on more complex judgments. A&GEL is instructed to rely <em>exclusively</em> on the source decision — though note it can struggle to distinguish <em>ratio decidendi</em> from <em>obiter dicta</em>.',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.title': 'Not a silver bullet',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.body':
    'Outputs must still be reviewed and verified in the usual manner — checked thoroughly for accuracy and completeness. These prompts give you an efficient starting point, not a finished work product.',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.3.p':
    'Pair these with the <strong>Guided Summary</strong> function (under Apps), which summarises a single document guided by a prompt. Upload a Singapore court decision, pick the Case Summariser (Detailed) prompt, and add any specific points you are concerned with.',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.4.figure.caption':
    'Case Summariser (Concise) v1.1 and Case Summariser (Detailed) v1.1 in the Prompt Library.',
  'pages.angelInsider.issues.issue-2.sections.1.kicker': '02 — Drafting',
  'pages.angelInsider.issues.issue-2.sections.1.heading': 'Generate initial drafts',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.0.p':
    "A prompt (based on SAL's published prompts) generates a first-draft <strong>Defence</strong> in response to a Statement of Claim. Clone and adapt it, and be sure to incorporate sufficient context.",
  'pages.angelInsider.issues.issue-2.sections.1.blocks.1.p':
    'A second prompt produces client-facing <strong>legal updates</strong> from a case summary, with a short Knowledge Management sample article guiding style, structure and tone.',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.0.caption':
    'Draft a Defence to a Statement of Claim.',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.1.caption':
    'Draft to the style and tone of a reference article v1.2.',
  'pages.angelInsider.issues.issue-2.sections.2.kicker': '03 — Pleadings',
  'pages.angelInsider.issues.issue-2.sections.2.heading': 'Analyse pleadings',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.0.p':
    'We have prepared a number of pleadings-analysis prompts. These are lightly tested — try them, clone and improve them, and share with other users.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.0':
    '<strong>Analyse a Statement of Claim</strong> — executive summary, chronology, sufficiency against the Rules of Court 2021, key issues and preliminary objections, immediate action items and next steps.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.1':
    '<strong>Analyse a Defence</strong> — extract the defence strategy and any gaps where allegations in the Statement of Claim are not specifically addressed.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.2':
    '<strong>Sufficiency of pleadings</strong> — originally built to assess a Defence; clone and adapt for the pleading you are reviewing.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.0.caption':
    'Statement of Claim Analysis & Chronology v1.5.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.1.caption':
    'Analyse a Defence to a SOC v1.0.',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.2.caption':
    'Sufficiency of Pleadings for Defence v1.0.',
  'pages.angelInsider.issues.issue-2.sections.3.kicker': '04 — Review mode',
  'pages.angelInsider.issues.issue-2.sections.3.heading': 'Using Review as a pleadings tracker',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.0.p':
    "See each party's position across the dispute's lifetime at a glance. In <strong>Review mode</strong>, treat every cause of action in the Statement of Claim as a guiding question to systematically examine and challenge the positions advanced in the pleadings and affidavits.",
  'pages.angelInsider.issues.issue-2.sections.3.blocks.1.h':
    'Step 1 — Generate the question list in Chat',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.2.p':
    'Upload the Statement of Claim to your files or directly into Chat, then run a prompt to extract the causes of action:',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.label': 'Question-list generator',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.text':
    'You are a litigation lawyer with 20 years of experience. Take a deep breath and focus.\n\nThe document uploaded is a Statement of Claim. Your task is to produce a point-form summary. Each bullet should cover (a) one cause of action, (b) the defendant it is against, (c) the factual assertions relied upon, and (d) the remedies sought. Present every sub-point within the same bullet — avoid sub-level bullets. Extract all content from the document. If there are multiple defendants, cover all causes of action against the 1st defendant before the 2nd, and so on.\n\nBe comprehensive but concise: summarise and reference all content directly relevant to each cause of action. Be precise: avoid vague wording and use the phrasing of the document.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.4.h':
    'Step 2 — Run the list against the pleadings in Review',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.5.p':
    'Copy the generated list, switch to <strong>Review</strong>, and click <strong>Quick Questions</strong>. Paste the list into <em>Add Questions</em>, click <em>Add +</em>, attach your Statement of Claim, and press submit.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.6.gallery.0.caption':
    'Review mode — add a question list as a quick-questions matrix.',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.title': 'Beyond pleadings',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.body':
    "Review's ability to pose many questions to many documents suits other document-intensive work too — discovery, document review, and reviewing voluminous affidavits.",
  'pages.angelInsider.issues.issue-2.sections.4.kicker': '05 — Craft',
  'pages.angelInsider.issues.issue-2.sections.4.heading': 'Tips for prompting: test and improve',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.0.p':
    "<strong>Test your prompt.</strong> Gauge a prompt by comparing A&GEL's output against a model answer you have already prepared. If it aligns closely, your prompt is likely well-developed; if not, identify the gaps and add context.",
  'pages.angelInsider.issues.issue-2.sections.4.blocks.1.p':
    '<strong>Improve your prompt.</strong> Use the <em>Improve My Prompt v1.0</em> tool in your prompt library to refine it further.',
  'pages.angelInsider.issues.issue-2.signoff.line': 'Clone, adapt, and share what works.',
  'pages.angelInsider.issues.issue-2.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-scribe.title': 'Scribe',
  'pages.angelInsider.issues.feature-scribe.subtitle':
    'Record, transcribe, live-translate and edit meetings — all in one place.',
  'pages.angelInsider.issues.feature-scribe.glance.0':
    '<strong>Live editing</strong> — edit the transcript as Scribe records; edited portions are underlined.',
  'pages.angelInsider.issues.feature-scribe.glance.1':
    '<strong>Audio playback</strong> — click any transcript segment to play back its recording from that point.',
  'pages.angelInsider.issues.feature-scribe.glance.2':
    '<strong>Live Translation</strong> — translate in real time into the language of your choice.',
  'pages.angelInsider.issues.feature-scribe.glance.3':
    '<strong>Timestamped downloads</strong> — exported Word transcripts carry timestamps for easy navigation.',
  'pages.angelInsider.issues.feature-scribe.sections.0.kicker': 'Scribe',
  'pages.angelInsider.issues.feature-scribe.sections.0.heading': 'Live editing & audio playback',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.0.p':
    '<strong>Live editing</strong> — the improved Scribe lets you edit the transcript; edited portions are underlined for ease of reference. <strong>Audio playback</strong> — after transcription is saved, open the raw transcript and click any segment to play the recording from that point.',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.0.caption':
    'Scribe recording in progress, with live transcription.',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.1.caption':
    'The raw transcript — click a segment to play back its audio.',
  'pages.angelInsider.issues.feature-scribe.sections.1.kicker': 'Scribe',
  'pages.angelInsider.issues.feature-scribe.sections.1.heading': 'Live-translation, now in Scribe',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.0.p':
    'Understand calls and meetings in the language of your choice. Tick the <strong>Live Translation</strong> box and pick a language — A&GEL renders the translation beneath the original transcription on the fly.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.1.figure.caption':
    'Enable Live Translation and select a language from the drop-down.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.2.p':
    "As A&GEL transcribes and translates, you can type notes or amend the transcript directly — your edits appear in <strong>yellow</strong> to distinguish them from A&GEL's text. Saved transcripts retain both the translation and your edits.",
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.0.caption':
    'Live translation beneath the original, with editable notes in yellow.',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.1.caption':
    'Timestamps run down the left of the raw transcription.',
  'pages.angelInsider.issues.feature-scribe.sections.2.kicker': 'Scribe',
  'pages.angelInsider.issues.feature-scribe.sections.2.heading':
    'Downloadable transcripts, now with timestamps',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.0.p':
    'Scribe transcripts now include <strong>timestamps</strong> within the downloaded Word document — markers that make it simpler to navigate to specific moments in a recorded conversation or meeting.',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.1.figure.caption':
    'A downloaded Scribe transcript with timestamps and translation retained.',
  'pages.angelInsider.issues.feature-scribe.signoff.line': 'Record, review, replay.',
  'pages.angelInsider.issues.feature-scribe.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-prompt-library.title': 'Prompt Library',
  'pages.angelInsider.issues.feature-prompt-library.subtitle':
    'Find, clone and adapt community-built prompts — and sharpen them with built-in tools.',
  'pages.angelInsider.issues.feature-prompt-library.glance.0':
    'Browse, clone and adapt community-built prompts from the Prompt Library for your specific matter.',
  'pages.angelInsider.issues.feature-prompt-library.glance.1':
    "<strong>Test your prompt</strong> — compare A&GEL's output against a model answer you have already prepared.",
  'pages.angelInsider.issues.feature-prompt-library.glance.2':
    "Use <strong>Improve My Prompt v1.0</strong> in the prompt library to further refine any prompt that isn't performing as expected.",
  'pages.angelInsider.issues.feature-prompt-library.sections.0.kicker': 'Craft',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.heading':
    'Tips for prompting: test and improve',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.0.p':
    '<strong>Test your prompt.</strong> An effective way to gauge a prompt\'s effectiveness is to compare A&GEL\'s output against a "model answer" or reference output you have already prepared.',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.1.p':
    "For instance, if you are developing a prompt to summarise a case, refer to a case summary you have previously prepared and are familiar with as your benchmark. Run your summary prompt and assess A&GEL's output against your prior work. If the output aligns closely with your benchmark, your prompt is likely well-developed. If it does not, identify the specific gaps and refine your prompt accordingly — for example, by adding further context.",
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.2.p':
    '<strong>Improve your prompt.</strong> Consider using the <em>Improve My Prompt v1.0</em> tool available in your prompt library to further refine your prompt.',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.3.figure.caption':
    'Improve My Prompt v1.0 — refine an existing prompt in the library.',
  'pages.angelInsider.issues.feature-prompt-library.signoff.line':
    'Clone, adapt, and share what works.',
  'pages.angelInsider.issues.feature-prompt-library.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-prompting.title': 'Prompting',
  'pages.angelInsider.issues.feature-prompting.subtitle':
    "A prompt without context is a guess. Here's the framework that changes that.",
  'pages.angelInsider.issues.feature-prompting.glance.0':
    'Every effective prompt has four parts: <strong>Persona, Task, Context, and Format</strong>.',
  'pages.angelInsider.issues.feature-prompting.glance.1':
    "Context is the part only <em>you</em> can supply — it's where your expertise makes the difference.",
  'pages.angelInsider.issues.feature-prompting.glance.2':
    'A prompt without context is "prompt roulette" — technically valid, but unlikely to produce useful output.',
  'pages.angelInsider.issues.feature-prompting.glance.3':
    "Clone a prompt from the library, then adapt it with your matter's specific facts and legal framework.",
  'pages.angelInsider.issues.feature-prompting.sections.0.kicker': '01 — The Framework',
  'pages.angelInsider.issues.feature-prompting.sections.0.heading':
    'Persona, Task, Context, Format',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.0.p':
    'Every effective prompt has four parts. Think of it as a checklist:',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.1.p':
    '<strong>Persona</strong> — tell A&GEL what role to adopt. <em>"You are a litigation lawyer with 20 years of experience."</em> This shapes the tone, depth, and specificity of the output.',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.2.p':
    '<strong>Task</strong> — describe what you want done, clearly and specifically.',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.3.p':
    '<strong>Context</strong> — this is the part only you can supply. The specific legal framework, the commercial facts, the surrounding circumstances of the matter. A prompt without context is just a guess — what the team calls "prompt roulette". The quality of A&GEL\'s output is directly proportional to the quality of context you provide.',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.4.p':
    "<strong>Format</strong> — specify how you want the output structured. A numbered list? A table? A draft clause? A concise paragraph? If you don't specify, A&GEL will default to a generic format that may not suit your workflow.",
  'pages.angelInsider.issues.feature-prompting.sections.1.kicker': '02 — Context in Practice',
  'pages.angelInsider.issues.feature-prompting.sections.1.heading': 'The difference context makes',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.0.p':
    'Think of A&GEL as a capable assistant that needs the full picture to do its best work. Instead of asking simple questions, provide the specific background details that only you know — your key goals, the facts of the matter, what a "good" or "bad" answer looks like.',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.1.p':
    'The more legal content (e.g. a short summary of the applicable areas of law) and commercial context (e.g. the surrounding facts of the transaction or dispute) you supply, the more useful the output. When such context is provided, the quality of results can be night and day compared to basic prompting.',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.title':
    'Case summary example',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.body':
    'When using a case summary prompt, add brief details of the legal issues you care about — e.g. the distinction between ratio decidendi and obiter dicta. Clone the prompt from the library, edit it to reflect your specific focus, and you will find the output far more targeted than using the prompt as-is.',
  'pages.angelInsider.issues.feature-prompting.sections.2.kicker': '03 — Test & Improve',
  'pages.angelInsider.issues.feature-prompting.sections.2.heading': 'Benchmark, then refine',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.0.p':
    'Test any prompt against a "model answer" you already have — a case summary you\'ve prepared, a clause you\'ve drafted previously. Run the prompt and compare the output against your benchmark. If it aligns, the prompt is well-developed. If not, identify the specific gaps and add context accordingly.',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.1.p':
    "Use the <strong>Improve My Prompt v1.0</strong> tool in the Prompt Library to further refine any prompt that isn't performing as expected.",
  'pages.angelInsider.issues.feature-prompting.signoff.line':
    'You know your context best — put it in the prompt.',
  'pages.angelInsider.issues.feature-prompting.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-prompting.altCta.label': 'More about Prompt Library &rarr;',
  'pages.angelInsider.issues.feature-guided-summary.title': 'Quick Info & Guided Summary',
  'pages.angelInsider.issues.feature-guided-summary.subtitle':
    'A fast, sourced read of any single document — snapshot or steered.',
  'pages.angelInsider.issues.feature-guided-summary.glance.0':
    'Use <strong>Quick Info</strong> for an instant snapshot of any document.',
  'pages.angelInsider.issues.feature-guided-summary.glance.1':
    '<strong>Guided Summary</strong> (under Apps) lets you steer the focus — pair it with a prompt from the library.',
  'pages.angelInsider.issues.feature-guided-summary.glance.2':
    'Upload a document, pick a prompt, and add any specific points you want covered.',
  'pages.angelInsider.issues.feature-guided-summary.glance.3':
    'Now faster — with <strong>interim updates and inline references</strong> during generation.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.kicker': '01 — Guided Summary',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.heading':
    'A sourced summary of any document, steered by a prompt',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.0.p':
    "The prompt library includes two prompts for summarising documents — one for a concise overview, one for a more detailed analysis. They were adapted from SAL's published prompts and refined with generative AI.",
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.1.p':
    'In our experience the <strong>Detailed</strong> summariser is generally superior, especially on more complex documents. A&GEL is instructed to rely <em>exclusively</em> on the source — though it can struggle to distinguish <em>ratio decidendi</em> from <em>obiter dicta</em> in case law.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.title':
    'Not a silver bullet',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.body':
    'Outputs must still be reviewed and verified in the usual manner — checked thoroughly for accuracy and completeness. These prompts give you an efficient starting point, not a finished work product.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.3.p':
    'Use the <strong>Guided Summary</strong> function (under Apps) to run any prompt against a single document. Upload the file, pick the prompt from the library, and add any specific points you are concerned with.',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.4.figure.caption':
    'Case Summariser (Concise) v1.1 and Case Summariser (Detailed) v1.1 in the Prompt Library.',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.kicker': '02 — Speed & Updates',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.heading':
    'Faster generation with interim updates',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.0.p':
    'Guided Summary now provides <strong>interim updates with inline references</strong> during generation — you can see sections arrive progressively and begin cross-checking citations before the full output is complete.',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.1.p':
    'Overall output speed is also increased. Note: for simpler documents, the summary may load fast enough that the interim updates are skipped entirely.',
  'pages.angelInsider.issues.feature-guided-summary.signoff.line':
    'Quick Info for a snapshot; Guided Summary when you want to steer the focus.',
  'pages.angelInsider.issues.feature-guided-summary.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-vault.title': 'Your Vault',
  'pages.angelInsider.issues.feature-vault.subtitle':
    "Your Vault is your brain on A&GEL — curate it well, and the AI's outputs sharpen accordingly.",
  'pages.angelInsider.issues.feature-vault.glance.0':
    'A&GEL does <strong>not</strong> search the internet — it works exclusively within your Vault.',
  'pages.angelInsider.issues.feature-vault.glance.1':
    '<strong>Context is everything</strong>: precise, selective uploads produce precise, reliable outputs.',
  'pages.angelInsider.issues.feature-vault.glance.2':
    'Your folder structure is metadata — it guides the AI to the right perspective.',
  'pages.angelInsider.issues.feature-vault.glance.3':
    'Use <strong>Referenced File Weight</strong> and <strong>Session File Weight</strong> to fine-tune what A&GEL prioritises.',
  'pages.angelInsider.issues.feature-vault.sections.0.kicker': '01 — The Brain',
  'pages.angelInsider.issues.feature-vault.sections.0.heading': 'Your Vault is your brain on A&GEL',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.0.p':
    "Your Vault was designed to serve as the primary source of context for A&GEL, grounding the AI's probabilistic outputs in your trusted, curated knowledge base.",
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.1.p':
    '<strong>Does A&GEL search the internet for answers?</strong> No. A&GEL operates strictly within the boundaries of your Vault, relying exclusively on the documents you have uploaded and curated. This is a deliberate design choice serving three purposes: ensuring accuracy of outputs, maintaining security, and preserving the integrity of your proprietary knowledge base.',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.2.p':
    "Instead of pulling in unverified information from the web, A&GEL relies strictly on your Vault as its sole source of truth. If your Vault is well curated, A&GEL's features are grounded in precedents you respect, facts you have vetted, and strategies you endorse. When A&GEL answers a question, it is not guessing from general knowledge — it is synthesising insights from your specific, authoritative sources.",
  'pages.angelInsider.issues.feature-vault.sections.1.kicker': '02 — Uploading',
  'pages.angelInsider.issues.feature-vault.sections.1.heading': 'What and how to upload',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.0.p':
    '<strong>What can you upload?</strong> Any Word documents, PDFs or emails. Other file formats are in progress.',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.1.p':
    '<strong>How?</strong> Upload files by dragging and dropping individual files or entire folders onto the Files surface, or by clicking the upload button.',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.2.figure.caption':
    'Drag and drop files or folders directly onto the Files surface.',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.title':
    'Garbage In, Garbage Out',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.body':
    "Think of A&GEL not as a magic oracle, but as a tireless co-worker who has read everything you've uploaded. Hand that co-worker a messy desk piled with unrelated files and their work will likely be confused. Hand them a single, relevant precedent and their work will sharpen. This is the core truth of using A&GEL: <strong>Context is everything.</strong>",
  'pages.angelInsider.issues.feature-vault.sections.2.kicker': '03 — Structure',
  'pages.angelInsider.issues.feature-vault.sections.2.heading': 'Have some folder structure',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.0.p':
    'Your folder structure isn\'t just for tidiness — it\'s metadata that guides the AI. Organising files into logical sub-folders, like separating "Seller" from "Customer" precedents, helps A&GEL retrieve the right perspective.',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.1.figure.caption':
    'Drilling into a sub-folder — separating "Licensee" from "Licensor" precedents keeps context clean.',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.2.p':
    '<strong>Avoid the "Upload Everything" trap.</strong> It\'s tempting to dump your entire library into one folder and let the AI figure it out. Don\'t. A&GEL uses Retrieval-Augmented Generation (RAG), meaning it pulls answers from your uploaded files. GenAI doesn\'t "understand" facts — it predicts probabilities. When you feed it irrelevant noise, you dilute the signal. The result: less accurate, less precise, less reliable outputs. Always manually select the specific documents or folders relevant to your prompt.',
  'pages.angelInsider.issues.feature-vault.sections.3.kicker': '04 — Fine-Tuning',
  'pages.angelInsider.issues.feature-vault.sections.3.heading': 'Fine-tune the signal',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.0.p':
    'A&GEL gives you dials to control this process. Use <strong>Referenced File Weight</strong> to force the AI to prioritise specific documents you cite, and <strong>Session File Weight</strong> to boost files uploaded just for that chat.',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.1.p':
    'Finally, remember: A&GEL is a starting point — a brainstorming partner or collaborative space to refine initial thoughts, not a finish line. Always verify outputs against the source documents linked in the response.',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.title': 'The Bottom Line',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.body':
    'Treat your Vault like a curated library, not a landfill. Know where you keep your documents, be selective about your context, and A&GEL transforms from a noisy chatbot into a high-precision assistant.',
  'pages.angelInsider.issues.feature-vault.signoff.line':
    'Curate your Vault. Control your context.',
  'pages.angelInsider.issues.feature-vault.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-vault.cta.label': 'Back to Basics →',
  'pages.angelInsider.issues.issue-3.title': 'New Timeline & Multi-Step Prompt Apps',
  'pages.angelInsider.issues.issue-3.subtitle':
    '.msg uploads, a smarter Scribe, structured multi-step prompting, and a substantially revamped Timeline.',
  'pages.angelInsider.issues.issue-3.date': '18 Mar 2026',
  'pages.angelInsider.issues.issue-3.glance.0':
    '<strong>Email files (.msg)</strong> can now be uploaded and read in full — including attachments.',
  'pages.angelInsider.issues.issue-3.glance.1':
    '<strong>Scribe</strong> now supports live editing, audio playback, and one-minute autosave.',
  'pages.angelInsider.issues.issue-3.glance.2':
    'New <strong>Multi-Step Prompt</strong> mode breaks complex legal workflows into targeted steps.',
  'pages.angelInsider.issues.issue-3.glance.3':
    '<strong>Timeline</strong> revamped to combine chronologies across multiple documents.',
  'pages.angelInsider.issues.issue-3.sections.0.kicker': '01 — Files',
  'pages.angelInsider.issues.issue-3.sections.0.heading': 'Upload email files (.msg)',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.0.p':
    'A&GEL users can now upload entire <strong>.msg</strong> email files into Files, for use with Chat or any specialised mode. A&GEL reads all contents — including attachments — except attachments carrying <em>Internal Only</em> sensitivity labels or that are password-protected.',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.1.p':
    'Once uploaded, ask A&GEL to summarise the email, summarise the attached documents, or run any prompt from the library against it.',
  'pages.angelInsider.issues.issue-3.sections.1.kicker': '02 — Scribe',
  'pages.angelInsider.issues.issue-3.sections.1.heading': 'Scribe: live editing & audio playback',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.0.p':
    '<strong>Live editing</strong> — the improved Scribe lets you edit the transcript; edited portions are underlined for ease of reference. <strong>Audio playback</strong> — after transcription is saved, open the raw transcript and click any segment to play the recording from that point.',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.0.caption':
    'Scribe recording in progress, with live transcription.',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.1.caption':
    'The raw transcript — click a segment to play back its audio.',
  'pages.angelInsider.issues.issue-3.sections.2.kicker': '03 — New mode',
  'pages.angelInsider.issues.issue-3.sections.2.heading': 'Multi-Step Prompt',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.0.p':
    'Found under <strong>Specialised Apps</strong>. While single-shot prompts are efficient for simple queries, complex legal tasks benefit from a structured, iterative approach. Multi-Step Prompt lets you deconstruct a problem into a sequence of targeted interactions — our favourite mode for moderate-to-complex work on documents.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.1.h': 'Break workflows into logical phases',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.n': 'Corporate · Step 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.text':
    'Summarise what each party is obligated to do.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.n': 'Step 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.text':
    'With that summary in mind, flag any one-sided or unusual clauses.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.n': 'Step 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.text':
    'For the flagged clauses, redline the top five changes I should push for if I represent [party].',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.n': 'Litigation · Step 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.text':
    'Based on the Statement of Claim [attached], draft a first set of interrogatories.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.n': 'Step 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.text':
    'Having completed Step 1, draft corresponding document requests.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.n': 'Step 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.text':
    'As a final step, identify the top five custodians likely to have responsive documents, and explain why.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.title':
    'Only one prompt? Still use it',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.body':
    'Even with a single step, this app is excellent for complex single prompts you need carried out on a document — often better than Chat mode.',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.5.figure.caption':
    'Multi-Step Prompt output — references open an inline document viewer with highlights.',
  'pages.angelInsider.issues.issue-3.sections.3.kicker': '04 — Timeline',
  'pages.angelInsider.issues.issue-3.sections.3.heading': 'A substantially revamped Timeline',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.0.p':
    '<strong>Combine timelines across documents.</strong> The updated Timeline extracts a chronology from each selected document and merges them into one — invaluable when you have multiple large affidavits, pleadings or submissions, each with its own timeline.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.0.caption':
    'A combined Statement of Claim & Defence timeline across five files.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.1.caption':
    "Drill into a single document's timeline with source references.",
  'pages.angelInsider.issues.issue-3.sections.3.blocks.2.p':
    '<strong>View the source.</strong> Click the reference at the end of any event to open the source document, with the originating line highlighted.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.3.h':
    'Smart timelines, tuned to your matter',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.4.p':
    'After choosing documents, click <strong>Extend Prompt</strong> to focus extraction on topics of interest. The <em>Basic Litigation (shared)</em> configuration extracts Event Description, Source Document, Entities / Individuals and Supporting Paragraph — add your own fields too.',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.title': 'Works on messages too',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.body':
    'Point Timeline at chat logs or screenshots of messages (WhatsApp, WeChat) to build a chronology.',
  'pages.angelInsider.issues.issue-3.signoff.line': 'Smaller steps, sharper chronologies.',
  'pages.angelInsider.issues.issue-3.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-dispute.title': 'Dispute Resolution',
  'pages.angelInsider.issues.feature-dispute.subtitle':
    'Case summaries, SOC analysis, Defence drafting, and pleadings tracking — all within A&GEL.',
  'pages.angelInsider.issues.feature-dispute.glance.0':
    '<strong>Case summaries</strong> — the Detailed version generally outperforms Concise for complex judgments.',
  'pages.angelInsider.issues.feature-dispute.glance.1':
    '<strong>SOC Analysis</strong> — upload the Statement of Claim and run the analysis prompt directly.',
  'pages.angelInsider.issues.feature-dispute.glance.2':
    '<strong>Defence drafting</strong> — generate a first-draft defence from the SOC.',
  'pages.angelInsider.issues.feature-dispute.glance.3':
    "<strong>Pleadings tracker</strong> — REVIEW mode maps each cause of action against every party's position across the full document set.",
  'pages.angelInsider.issues.feature-dispute.sections.0.kicker': '01 — Case Summaries',
  'pages.angelInsider.issues.feature-dispute.sections.0.heading':
    'Summarising judgments and pleadings',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.0.p':
    'The Prompt Library includes two case summariser prompts — Concise and Detailed. In our experience, the <strong>Detailed</strong> version is generally superior, especially for complex judgments. A&GEL is instructed to rely exclusively on the source document.',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.1.figure.caption':
    'Case Summariser (Concise) v1.1 and Case Summariser (Detailed) v1.1 in the Prompt Library.',
  'pages.angelInsider.issues.feature-dispute.sections.1.kicker': '02 — SOC & Defence',
  'pages.angelInsider.issues.feature-dispute.sections.1.heading':
    'Statement of Claim analysis and Defence drafting',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.0.p':
    'Use the <strong>Statement of Claim Analysis and Chronology</strong> prompt for early case assessment. Upload the SOC and run the prompt — A&GEL extracts the key facts, causes of action, and a chronology.',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.1.p':
    'To draft a first Defence, use the <strong>Draft a defence to a Statement of Claim</strong> prompt from the library. Clone it and adapt the context to your matter.',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.title':
    'Detailed over Concise',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.body':
    'For complex judgments or lengthy SOCs, the Detailed summariser consistently produces more accurate and complete outputs.',
  'pages.angelInsider.issues.feature-dispute.sections.2.kicker': '03 — Pleadings Tracker',
  'pages.angelInsider.issues.feature-dispute.sections.2.heading':
    'REVIEW mode as a pleadings tracker',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.0.p':
    "REVIEW mode runs a question list across multiple documents simultaneously. For dispute resolution, load the Statement of Claim, defences, and replies, define your questions (one per cause of action), and A&GEL maps each party's position in a single table.",
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.1.figure.caption':
    'Lim Group: REVIEW mode tracking fraud and misconduct claims across 5 files.',
  'pages.angelInsider.issues.feature-dispute.signoff.line':
    'Faster case assessment, better preparation.',
  'pages.angelInsider.issues.feature-dispute.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-sidebyside.title': 'Side-by-Side & Comparison',
  'pages.angelInsider.issues.feature-sidebyside.subtitle':
    'The most granular review modes — clause by clause, with full source-paragraph verification.',
  'pages.angelInsider.issues.feature-sidebyside.glance.0':
    '<strong>Side-by-Side</strong> works clause by clause, with full source-paragraph verification for every finding.',
  'pages.angelInsider.issues.feature-sidebyside.glance.1':
    '<strong>Comparison</strong> generates a first-pass legal review of tracked changes or document amendments.',
  'pages.angelInsider.issues.feature-sidebyside.glance.2':
    'Every finding links back to the exact source clause — no hunting through the document.',
  'pages.angelInsider.issues.feature-sidebyside.glance.3':
    'The <strong>mini-chat window</strong> is now moveable and resizable — drag it clear of your workspace.',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.kicker': '01 — Side-by-Side',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.heading':
    'Clause-by-clause analysis with source verification',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.0.p':
    "Side-by-Side is A&GEL's most granular review mode. It works through a document clause by clause, and for every finding it surfaces the exact source paragraph — so you can verify the output directly against the original.",
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.1.figure.caption':
    'Side-by-Side analysis of an SPA — each finding links back to the source clause.',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.2.figure.caption':
    "The explanation panel — A&GEL's reasoning shown inline alongside the source.",
  'pages.angelInsider.issues.feature-sidebyside.sections.1.kicker': '02 — Comparison',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.heading':
    'First-pass review of tracked changes',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.0.p':
    '<strong>Comparison</strong> generates a first-pass legal review of tracked changes or document amendments. Upload the amended document and A&GEL produces a structured analysis of what has changed and what the implications are.',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.title':
    'A starting point, not a finished product',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.body':
    'Side-by-Side and Comparison outputs are efficient starting points — always verify against the source before finalising.',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.kicker': '03 — Mini-Chat',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.heading': 'Moveable mini-chat interface',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.blocks.0.p':
    "Review, Comparison, and Side by Side all feature a <strong>mini-chat window</strong> that lets you ask questions about the documents and A&GEL outputs simultaneously. The window is now <strong>moveable and resizable</strong> — drag it anywhere on screen so it doesn't obstruct the output you are reviewing.",
  'pages.angelInsider.issues.feature-sidebyside.signoff.line': 'Clause by clause. Source verified.',
  'pages.angelInsider.issues.feature-sidebyside.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-multistep.title': 'Multi-Step Prompt',
  'pages.angelInsider.issues.feature-multistep.subtitle':
    'Break complex legal tasks into sequential steps — each building on the last.',
  'pages.angelInsider.issues.feature-multistep.glance.0':
    'Found under <strong>Specialised Apps</strong>.',
  'pages.angelInsider.issues.feature-multistep.glance.1':
    'Each step builds on the output of the previous — ideal for complex workflows.',
  'pages.angelInsider.issues.feature-multistep.glance.2':
    'Works for both multi-step workflows <em>and</em> single complex prompts on a document.',
  'pages.angelInsider.issues.feature-multistep.glance.3':
    'Outputs include inline source references — click to open the source with highlights.',
  'pages.angelInsider.issues.feature-multistep.sections.0.kicker': '01 — Getting started',
  'pages.angelInsider.issues.feature-multistep.sections.0.heading':
    'A structured mode for complex legal work',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.0.p':
    'Found under <strong>Specialised Apps</strong>. Multi-Step Prompt lets you deconstruct a legal problem into a sequence of targeted steps — each builds on the last. Well suited to both multi-step workflows and single complex prompts that need document-level precision.',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.1.figure.caption':
    'Multi-Step Prompt in the Specialised Apps grid.',
  'pages.angelInsider.issues.feature-multistep.sections.1.kicker': '02 — Examples',
  'pages.angelInsider.issues.feature-multistep.sections.1.heading':
    'Breaking workflows into logical phases',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.n': 'Corporate · Step 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.text':
    'Summarise what each party is obligated to do.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.n': 'Step 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.text':
    'With that summary in mind, flag any one-sided or unusual clauses.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.n': 'Step 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.text':
    'For the flagged clauses, redline the top five changes I should push for if I represent [party].',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.n':
    'Litigation · Step 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.text':
    'Based on the Statement of Claim [attached], draft a first set of interrogatories.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.n': 'Step 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.text':
    'Having completed Step 1, draft corresponding document requests.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.n': 'Step 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.text':
    'Identify the top five custodians likely to have responsive documents, and explain why.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.title':
    'Only one prompt? Still use it',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.body':
    'Even with a single step, this app is excellent for complex prompts on a document — often better than Chat mode.',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.3.figure.caption':
    'Multi-Step Prompt output — references open an inline document viewer with highlights.',
  'pages.angelInsider.issues.feature-multistep.sections.2.kicker': '03 — Worked example',
  'pages.angelInsider.issues.feature-multistep.sections.2.heading':
    'Report drafting across two documents',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.0.p':
    'A three-step workflow for extracting concerns from two documents and combining them into a single report with an executive summary — too complex to do reliably in one chat prompt.',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.title':
    'Step 1 — Extraction',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.body':
    '<strong>Input Context:</strong> [Insert text of Document 1 and Document 2]<br><strong>Prompt:</strong> "Read the provided text. Extract a comprehensive, bulleted list of all the concerns, issues, or risks mentioned across both documents."<br><em>Output: a clean, consolidated list of concerns.</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.title':
    'Step 2 — Drafting the Full Report',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.body':
    '<strong>Input Context:</strong> [Output from Step 1]<br><strong>Prompt:</strong> "Using the provided list of concerns, write a detailed, formal report. Group similar concerns under relevant headings. Do not include an introduction or executive summary at this stage."<br><em>Output: the full, structured report.</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.title':
    'Step 3 — Executive Summary &amp; Final Compilation',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.body':
    '<strong>Input Context:</strong> [Output from Step 2]<br><strong>Prompt:</strong> "Read the provided report. First, write a concise, one-paragraph executive summary. Then, output the executive summary, add a visual divider, and output the exact full report below it to create a single, combined document."<br><em>Output: the final combined document.</em>',
  'pages.angelInsider.issues.feature-multistep.signoff.line': 'Smaller steps, sharper outputs.',
  'pages.angelInsider.issues.feature-multistep.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-timeline.title': 'Timeline',
  'pages.angelInsider.issues.feature-timeline.subtitle':
    'Combine chronologies across up to 100 documents into a single, source-verified timeline.',
  'pages.angelInsider.issues.feature-timeline.glance.0':
    'Combines chronologies from <strong>up to 100 documents</strong> into one timeline.',
  'pages.angelInsider.issues.feature-timeline.glance.1':
    '<strong>Clickable inline citations</strong> — click any reference to open the source with the passage highlighted.',
  'pages.angelInsider.issues.feature-timeline.glance.2':
    '<strong>Smart Timeline</strong> lets you extract custom fields: entities, supporting paragraphs, and more.',
  'pages.angelInsider.issues.feature-timeline.glance.3':
    'Works on chat logs and message screenshots (WhatsApp, WeChat) too.',
  'pages.angelInsider.issues.feature-timeline.sections.0.kicker': '01 — Combined timelines',
  'pages.angelInsider.issues.feature-timeline.sections.0.heading':
    'Chronologies across multiple documents',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.0.p':
    'The updated Timeline extracts a chronology from each selected document and merges them into one — invaluable when you have multiple large affidavits, pleadings or submissions, each with its own timeline.',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.0.caption':
    'A combined Statement of Claim & Defence timeline across five files.',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.1.caption':
    'Drill into a single event — source document, entities, and supporting paragraph all shown.',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.2.p':
    '<strong>View the source.</strong> Click the inline citation at the end of any event to open the source document with the originating line highlighted.',
  'pages.angelInsider.issues.feature-timeline.sections.1.kicker': '02 — Smart Timeline',
  'pages.angelInsider.issues.feature-timeline.sections.1.heading':
    'Extract custom fields for your matter',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.0.p':
    'Click <strong>Extend Prompt</strong> to focus extraction on topics of interest. The <em>Basic Litigation (shared)</em> configuration extracts Event Description, Source Document, Entities / Individuals, and Supporting Paragraph — add your own fields too.',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.1.figure.caption':
    'Smart Timeline: add custom extraction fields under Extend Prompt.',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.title':
    'Works on messages too',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.body':
    'Point Timeline at chat logs or screenshots of messages (WhatsApp, WeChat) to build a chronology.',
  'pages.angelInsider.issues.feature-timeline.signoff.line': 'One timeline. Every document.',
  'pages.angelInsider.issues.feature-timeline.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-using-files.title': 'Using your files on A&GEL',
  'pages.angelInsider.issues.feature-using-files.subtitle':
    'A&GEL works natively with Word documents, PDFs and emails (and adding more formats in the future). However, certain files can fail to upload to A&GEL due to missing text layers, incorrect sensitivity labels or file format, and each issue has a simple fix.',
  'pages.angelInsider.issues.feature-using-files.intro':
    'You may encounter issues with certain files not uploading to A&GEL successfully. This guide covers the most common causes &mdash; from scanned documents without a text layer, to document sensitivity labels &mdash; and how to resolve them.',
  'pages.angelInsider.issues.feature-using-files.glance.0':
    'A&GEL reads the <strong>text layer</strong> in a PDF &mdash; scanned hard copies often have none.',
  'pages.angelInsider.issues.feature-using-files.glance.1':
    'Common with older files and hard copies that were scanned without any OCR.',
  'pages.angelInsider.issues.feature-using-files.glance.2':
    'Fix it: make the PDF searchable, then re-upload to A&GEL.',
  'pages.angelInsider.issues.feature-using-files.glance.3':
    'Converting a large batch of PDFs at once? The A&GEL development team can help.',
  'pages.angelInsider.issues.feature-using-files.glance.4':
    'Internal documents must be relabelled <strong>External</strong> before upload, or A&GEL will reject them.',
  'pages.angelInsider.issues.feature-using-files.glance.5':
    'Older Word documents (1997&ndash;2004, pre-OOXML .doc) are already supported &mdash; no conversion needed.',
  'pages.angelInsider.issues.feature-using-files.sections.0.kicker': '01 — Missing text layer',
  'pages.angelInsider.issues.feature-using-files.sections.0.heading':
    'Problems with scanned documents',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.0.p':
    'A&GEL reads documents by extracting the text layer embedded in a PDF. When a document has no text layer, such as a scanned hard copy, A&GEL only sees an image of the page and cannot process it.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.1.p':
    'Most scanned documents, especially those digitised on a photocopier, are saved as image-only PDFs. This is common with older files and scans of documents as images (and OCR has not been applied).',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.2.p':
    'Open your file in a PDF reader that supports OCR (optical character recognition) &mdash; such as Kofax &mdash; before uploading, to make sure it processes successfully.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.n': 'Step 1',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.text':
    'Open your scanned PDF in a PDF reader with OCR capability, such as Kofax.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.n': 'Step 2',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.text':
    'Run OCR to make the file searchable &mdash; in Kofax, this is the <strong>&ldquo;Make Searchable&rdquo;</strong> or <strong>&ldquo;Searchable PDF&rdquo;</strong> function. If you have several files to convert, look for a batch or multi-file OCR option (in Kofax, this sits under Advanced Processing) rather than converting one at a time.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.n': 'Step 3',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.text':
    'Save the converted file, then upload it to A&GEL.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.4.p':
    'Once converted, the file will contain a searchable text layer and A&GEL will be able to process it as normal. Alternatively, you may make a searchable PDF at the point of scanning, rather than converting it afterwards &mdash; many printers and scanners can produce a searchable PDF directly during the scan. Look for an equivalent &ldquo;Searchable PDF&rdquo; or OCR option on your own device, as menu names and steps vary by model.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.5.figure.caption':
    'Example: on this scanner&rsquo;s &ldquo;Scan and Send&rdquo; screen, selecting PDF as the file format and enabling OCR (Prioritize Speed or Prioritize Precision) produces a searchable PDF with a text layer.',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.6.p':
    'Need to OCR a large batch of PDFs at once? Reach out to the A&GEL development team &mdash; they can help process bulk conversions for you.',
  'pages.angelInsider.issues.feature-using-files.sections.1.kicker': '02 — Sensitivity labels',
  'pages.angelInsider.issues.feature-using-files.sections.1.heading':
    'Problems with sensitivity labels',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.0.p':
    'Every document carries a sensitivity label, set when it is saved in Word or Outlook, and A&GEL checks this label before accepting an upload.',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.1.p':
    'A&GEL rejects files saved with an Internal sensitivity label &mdash; relabel the document as External and save it before uploading.',
  'pages.angelInsider.issues.feature-using-files.sections.2.kicker': '03 — Older Word files',
  'pages.angelInsider.issues.feature-using-files.sections.2.heading':
    'Older Word documents supported',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.0.p':
    'Older Word documents are also supported. None of the following formats need to be converted or re-saved before upload:',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.left.label': 'PDF',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.topMiddle.label':
    'MS Word current (.docx)',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.bottomMiddle.label':
    'MS Word 1997&ndash;2004 (.doc)',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.right.label':
    'Email (.msg)',
  'pages.angelInsider.issues.feature-using-files.signoff.line':
    "Make scanned documents searchable with Kofax or your printer's OCR setting, save internal documents as External before uploading, and note that both older and current Word formats already work without conversion.",
  'pages.angelInsider.issues.feature-using-files.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-work-studio.title': 'Workstudio',
  'pages.angelInsider.issues.feature-work-studio.subtitle':
    "Codify your team's house position into a standardised review — returns a Word document in tracked changes.",
  'pages.angelInsider.issues.feature-work-studio.glance.0':
    "Encode your team's negotiating positions into a Workstudio once — reuse it on every contract.",
  'pages.angelInsider.issues.feature-work-studio.glance.1':
    'A&GEL applies the Workstudio and returns a <strong>Word document in tracked changes</strong>.',
  'pages.angelInsider.issues.feature-work-studio.glance.2':
    'Review amendments with accepted / rejected / pending states.',
  'pages.angelInsider.issues.feature-work-studio.glance.3':
    'More detail on building and using Workstudios coming in the next A&GEL Insider issue.',
  'pages.angelInsider.issues.feature-work-studio.sections.0.kicker': '01 — Workstudio',
  'pages.angelInsider.issues.feature-work-studio.sections.0.heading':
    'Your house position, automated',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.0.p':
    "Workstudio lets you encode your team's negotiating and standard positions into a reusable review template. Once built, upload any contract and A&GEL applies the Workstudio — returning a Word document with proposed changes in tracked-changes format, ready for review and amendment.",
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.1.figure.caption':
    'Workstudio in action — reviewing amendments and comments with accepted/rejected/pending states.',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.title':
    'Full Workstudio guide coming soon',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.body':
    "The next A&GEL Insider issue will cover how to build a Workstudio from scratch and how to put it to work on your team's matters.",
  'pages.angelInsider.issues.feature-work-studio.signoff.line':
    'Your positions. Applied automatically.',
  'pages.angelInsider.issues.feature-work-studio.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-deepresearch.title': 'Deep Research',
  'pages.angelInsider.issues.feature-deepresearch.subtitle':
    'Cross-document analysis under a structured research prompt — every finding links back to its source paragraph.',
  'pages.angelInsider.issues.feature-deepresearch.glance.0':
    'Runs a structured research prompt across your entire selected document set.',
  'pages.angelInsider.issues.feature-deepresearch.glance.1':
    'Every finding carries a <strong>clickable inline citation</strong> — open the source with the passage highlighted.',
  'pages.angelInsider.issues.feature-deepresearch.glance.2':
    'Found under <strong>Specialised Apps</strong>.',
  'pages.angelInsider.issues.feature-deepresearch.glance.3':
    'Pair with curated Vault uploads of primary sources for maximum precision.',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.kicker': '01 — What it does',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.heading':
    'Cross-document analysis under a structured prompt',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.0.p':
    'Deep Research runs a structured research prompt across your selected documents and returns a detailed, sourced analysis. It is designed for tasks that require synthesising information across multiple documents — case law analysis, market research, regulatory mapping — rather than interrogating a single file.',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.1.figure.caption':
    'Deep Research output — each finding links back to its source document via clickable inline citations.',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.kicker': '02 — Inline Citations',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.heading':
    'Verify every finding against its source',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.0.p':
    'Every finding in a Deep Research output carries a <strong>numbered inline citation</strong>. Click any citation to open the source document with the originating passage highlighted — all without leaving the page.',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.title':
    'Use selective context',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.body':
    'Restrict your context to the documents most relevant to your research question. Broad context dilutes the signal — Deep Research performs best on curated, targeted uploads.',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.kicker': '03 — When to use it',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.heading':
    'Best suited to synthesis tasks',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.blocks.0.p':
    'Use Deep Research when you need to synthesise across sources — comparing positions across multiple affidavits, summarising case law on a specific issue, or mapping regulatory requirements across jurisdictions. For a single document, consider Guided Summary or Scope Summary instead.',
  'pages.angelInsider.issues.feature-deepresearch.signoff.line': 'Every finding. Source verified.',
  'pages.angelInsider.issues.feature-deepresearch.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-scopesummary.title': 'Scope Summary',
  'pages.angelInsider.issues.feature-scopesummary.subtitle':
    'A structured summary scoped to your defined focus areas — every extracted point carries a clickable inline citation.',
  'pages.angelInsider.issues.feature-scopesummary.glance.0':
    'Generates a summary focused on your defined scope — not the whole document.',
  'pages.angelInsider.issues.feature-scopesummary.glance.1':
    'Every extracted point carries a <strong>clickable inline citation</strong> to verify against the source.',
  'pages.angelInsider.issues.feature-scopesummary.glance.2':
    'Found under <strong>Specialised Apps</strong>.',
  'pages.angelInsider.issues.feature-scopesummary.glance.3':
    'Tighter scope definitions produce more targeted, actionable extractions.',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.kicker': '01 — What it does',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.heading':
    'Focused extraction within a defined scope',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.0.p':
    'Scope Summary lets you define the areas you want A&GEL to focus on — obligations, risk allocation, termination rights, IP provisions — and generates a structured summary restricted to those scope areas. The output is more targeted than a full-document summary and directly mapped to your review priorities.',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.title':
    'Define your scope clearly',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.body':
    'The tighter the scope, the more precise the output. Broad scopes produce outputs similar to a full-document summary. Targeted scopes — e.g. "data protection and security obligations" — produce concise, actionable extractions.',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.kicker': '02 — Inline Citations',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.heading':
    'Every point, source verified',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.blocks.0.p':
    'Each extracted point in a Scope Summary carries a <strong>clickable inline citation</strong> — click it to open the source document with the originating clause or paragraph highlighted. No tab-switching; all verification happens on a single page.',
  'pages.angelInsider.issues.feature-scopesummary.signoff.line': 'Scoped. Sourced. Verified.',
  'pages.angelInsider.issues.feature-scopesummary.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-review.title': 'Review',
  'pages.angelInsider.issues.feature-review.subtitle':
    'Pose multiple questions across multiple documents at once — outputs appear in a table with inline citations.',
  'pages.angelInsider.issues.feature-review.glance.0':
    'Run a <strong>question list across multiple documents simultaneously</strong> — outputs in one table.',
  'pages.angelInsider.issues.feature-review.glance.1':
    'Click any cell to expand the <strong>Explanation panel</strong> with inline citations to source clauses.',
  'pages.angelInsider.issues.feature-review.glance.2':
    'Use <strong>mini-chat</strong> to follow up without leaving the review page.',
  'pages.angelInsider.issues.feature-review.glance.3':
    'Found under <strong>Specialised Apps</strong>.',
  'pages.angelInsider.issues.feature-review.sections.0.kicker': '01 — What it does',
  'pages.angelInsider.issues.feature-review.sections.0.heading':
    'Multi-document, multi-question review in one table',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.0.p':
    'Review runs a question list across multiple documents simultaneously, returning results in a table — one row per question, one column per document. The format is well suited to contract comparison, due diligence across a document set, or mapping positions across pleadings.',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.1.figure.caption':
    'AI SaaS Benchmarking Review — 20 files reviewed against a defined question set in a single table.',
  'pages.angelInsider.issues.feature-review.sections.1.kicker': '02 — Explanation Panel',
  'pages.angelInsider.issues.feature-review.sections.1.heading':
    'Source-verified explanations for every finding',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.0.p':
    'Click any cell to expand the <strong>Explanation panel</strong>. Each finding is broken down with structured inline references — click any reference to open the source clause directly.',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.1.figure.caption':
    'The Explanation panel in Review — each finding linked to its source clause.',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.title':
    'Build your question list once, reuse it',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.body':
    'A well-structured question list becomes a reusable template for that document type. Save it and apply it to the next set of contracts in the same category.',
  'pages.angelInsider.issues.feature-review.sections.2.kicker': '03 — Mini-Chat',
  'pages.angelInsider.issues.feature-review.sections.2.heading':
    'Follow up without leaving the page',
  'pages.angelInsider.issues.feature-review.sections.2.blocks.0.p':
    'The <strong>mini-chat window</strong> lets you ask follow-up questions about the documents and Review outputs simultaneously — without navigating away. The window is moveable and resizable, so it stays clear of your workspace.',
  'pages.angelInsider.issues.feature-review.signoff.line':
    'Every document. Every question. One table.',
  'pages.angelInsider.issues.feature-review.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-msg.title': '.msg Email Upload',
  'pages.angelInsider.issues.feature-msg.subtitle':
    'Upload entire email files into A&GEL — including attachments — and work with them like any other document.',
  'pages.angelInsider.issues.feature-msg.glance.0':
    'Upload <strong>.msg</strong> email files directly into Files.',
  'pages.angelInsider.issues.feature-msg.glance.1':
    'A&GEL reads all contents — including attachments.',
  'pages.angelInsider.issues.feature-msg.glance.2':
    'Use with Chat or any specialised mode (Guided Summary, Timeline, etc.).',
  'pages.angelInsider.issues.feature-msg.glance.3':
    'Exception: attachments with <em>Internal Only</em> labels or password protection are skipped.',
  'pages.angelInsider.issues.feature-msg.sections.0.kicker': '.msg Upload',
  'pages.angelInsider.issues.feature-msg.sections.0.heading': 'Upload email files (.msg)',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.0.p':
    'A&GEL users can now upload entire <strong>.msg</strong> email files into Files, for use with Chat or any specialised mode. A&GEL reads all contents — including attachments — except attachments carrying <em>Internal Only</em> sensitivity labels or that are password-protected.',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.1.p':
    'Once uploaded, ask A&GEL to summarise the email, summarise the attached documents, or run any prompt from the library against it.',
  'pages.angelInsider.issues.feature-msg.signoff.line': 'Emails, attachments and all.',
  'pages.angelInsider.issues.feature-msg.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-inline-ref.title': 'Inline Referencing',
  'pages.angelInsider.issues.feature-inline-ref.subtitle':
    'Clickable pin-cite citations in Deep Research, Timeline, Scope Summary, and Review — verify every output against its source without leaving the page.',
  'pages.angelInsider.issues.feature-inline-ref.glance.0':
    'Deep Research, Timeline, and Scope Summary outputs now carry <strong>clickable inline citations</strong>.',
  'pages.angelInsider.issues.feature-inline-ref.glance.1':
    'Click any citation to open the source document with the exact passage highlighted.',
  'pages.angelInsider.issues.feature-inline-ref.glance.2':
    "Review's <strong>Explanation panel</strong> also has structured inline references for each AI-generated finding.",
  'pages.angelInsider.issues.feature-inline-ref.glance.3':
    'No tab-switching — all verification happens on a single page.',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.kicker': 'Inline Referencing',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.heading':
    'Verify every output against its source',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.0.p':
    'All major A&GEL output apps — <strong>Deep Research, Timeline, Scope Summary</strong> — now feature clickable inline citations. Each reference is numbered and linked: click it to open the source document with the exact passage highlighted.',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.1.p':
    'This eliminates the need to switch tabs or manually search source documents to verify a specific point. Cross-referencing is available on a single page.',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.kicker': 'Inline Referencing in Review',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.heading':
    'Structured citations in the Explanation panel',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.0.p':
    "The Review page's <strong>Explanation</strong> section — expanded by clicking any cell — now features structured inline references. Each explanatory point is linked to its source clause or paragraph, making verification of AI-generated findings against the ground truth straightforward.",
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.1.figure.caption':
    'The Explanation panel in Review, with structured inline references linked to source documents.',
  'pages.angelInsider.issues.feature-inline-ref.signoff.line': 'Every output. Source verified.',
  'pages.angelInsider.issues.feature-inline-ref.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.issue-5.title': 'Inline Referencing, Mini-Chat & More',
  'pages.angelInsider.issues.issue-5.subtitle':
    'Pin-cite citations across all apps, a moveable mini-chat, Scribe timestamps, and a string of quality-of-life updates.',
  'pages.angelInsider.issues.issue-5.date': '10 Apr 2026',
  'pages.angelInsider.issues.issue-5.glance.0':
    'Deep Research, Timeline, Scope Summary & Review now feature <strong>clickable inline citations</strong>.',
  'pages.angelInsider.issues.issue-5.glance.1':
    'The mini-chat window in Review, Comparison & Side by Side is now <strong>moveable and resizable</strong>.',
  'pages.angelInsider.issues.issue-5.glance.2':
    'Scribe transcripts now include <strong>timestamps</strong> in the downloaded Word document.',
  'pages.angelInsider.issues.issue-5.glance.3':
    'Sessions can now be <strong>terminated via the History tab</strong> in addition to the Stop button.',
  'pages.angelInsider.issues.issue-5.glance.4':
    'Search improvements: better keyword matching and in-document search.',
  'pages.angelInsider.issues.issue-5.sections.0.kicker': '01 — Inline Referencing',
  'pages.angelInsider.issues.issue-5.sections.0.heading': 'Pin-cite citations across all apps',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.0.p':
    'Deep Research, Timeline, and Scope Summary now feature <strong>clickable inline citations</strong>. These references allow you to cross-check outputs against source documents instantly — click any citation to open the source with the relevant passage highlighted, all without leaving the page.',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.1.p':
    "The Review page's expanded <strong>Explanation</strong> section also receives structured inline references linked to source documents, making it easier to verify AI-generated analysis against the ground truth.",
  'pages.angelInsider.issues.issue-5.sections.0.blocks.2.figure.caption':
    'The Explanation panel in Review — structured inline references linked to source documents.',
  'pages.angelInsider.issues.issue-5.sections.1.kicker': '02 — Mini-Chat',
  'pages.angelInsider.issues.issue-5.sections.1.heading': 'Moveable mini-chat interface',
  'pages.angelInsider.issues.issue-5.sections.1.blocks.0.p':
    'The mini-chat window available in <strong>Review, Comparison, and Side by Side</strong> is now moveable and resizable. Drag it out of the way while you work through outputs — it no longer obstructs your primary workspace.',
  'pages.angelInsider.issues.issue-5.sections.2.kicker': '03 — Scribe',
  'pages.angelInsider.issues.issue-5.sections.2.heading': 'Timestamps in downloaded transcripts',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.0.p':
    'Downloaded Scribe transcripts (Word documents) now include <strong>timestamps</strong> — markers that allow you to navigate to a specific moment in the recording directly from the document.',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.1.figure.caption':
    'A downloaded Scribe transcript showing timestamps alongside translation.',
  'pages.angelInsider.issues.issue-5.sections.3.kicker': '04 — Other Updates',
  'pages.angelInsider.issues.issue-5.sections.3.heading': 'Quality-of-life improvements',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.0.h': 'Easier session termination',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.1.p':
    'Ongoing sessions can now be terminated by <strong>deleting them from the History tab</strong>, in addition to the existing Stop button — useful when you need to amend a prompt and rerun, or when a session is unresponsive.',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.2.h': 'Enhanced Search',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.3.p':
    'Search now benefits from <strong>inline referencing</strong>, better keyword matching, and in-document search — making it easier to locate specific content across your Vault.',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.4.h': 'Faster Guided Summary',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.5.p':
    'Guided Summary now provides <strong>interim updates with inline references</strong> during generation, and overall output speed is increased. For simpler documents, the summary may load fast enough that interim updates are skipped.',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.6.h': 'Optimised Files UI',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.7.p':
    'The Files page now has improved pagination — you can see more files and folders at a glance, with the page filling your screen dynamically.',
  'pages.angelInsider.issues.issue-5.signoff.line': 'Faster verification. Cleaner workspace.',
  'pages.angelInsider.issues.issue-5.signoff.name': 'A&GEL Development Team',
  'pages.angelInsider.issues.feature-faq.title': 'Frequently Asked Questions',
  'pages.angelInsider.issues.feature-faq.subtitle':
    'Getting started with A&GEL — from file management and prompting to checking your outputs.',
  'pages.angelInsider.issues.feature-faq.date': '10 Feb 2026',
  'pages.angelInsider.issues.feature-faq.glance.0':
    'How A&GEL supports — but does not replace — your subject matter expertise.',
  'pages.angelInsider.issues.feature-faq.glance.1':
    'File management best practices: what to upload and how to organise it.',
  'pages.angelInsider.issues.feature-faq.glance.2':
    'How to write effective prompts using the Persona–Task–Context–Format framework.',
  'pages.angelInsider.issues.feature-faq.glance.3':
    "How to check the accuracy and reliability of A&GEL's outputs.",
  'pages.angelInsider.issues.feature-faq.glance.4': 'Glossary of technical terms used in A&GEL.',
  'pages.angelInsider.issues.feature-faq.sections.0.kicker': '1 — General Principles',
  'pages.angelInsider.issues.feature-faq.sections.0.heading':
    'Always let subject matter experts be subject matter experts',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.0.h':
    'Q: Part of A&GEL\'s design philosophy is that we should "always let subject matter experts be subject matter experts". What does that mean?',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.1.p':
    '"Always let subject matter experts be subject matter experts" refers to how your judgment, insight, and integrity as a professional / expert in your domain should remain at the heart of your work.',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.2.p':
    'A&GEL does not replace that expertise or act as a subject matter expert. Instead, it is designed to help you as a knowledge worker / lawyer do more with more.',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.3.h':
    'Q: What if I am completely unfamiliar with the subject matter I am asking A&GEL about? Should I not use A&GEL in that case?',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.4.p':
    "If you are still developing your expertise — this does not mean you should avoid using A&GEL. It means being more mindful of how you use A&GEL. You should take extra care and conduct more checks on A&GEL's output.",
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.5.p':
    'Furthermore, consider using A&GEL as a gateway and guide to the existing knowhow which your team or company has uploaded. Used as a new way to access such know-how and gain on-demand insights and teachings from such know-how, A&GEL will become a powerful tool to support your training and development.',
  'pages.angelInsider.issues.feature-faq.sections.1.kicker': '2 — File Management',
  'pages.angelInsider.issues.feature-faq.sections.1.heading':
    'What to upload, and how to organise it',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.0.h':
    'Q: What kind of reference material should I upload to A&GEL?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.1.p':
    'As a general rule, upload only trusted, reliable, and accurate material. Examples include primary legal sources (such as statutes, case law, etc.) and trusted internal materials (such as company knowhow or your own tried and tested documents).',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.2.p':
    "As A&GEL's output heavily relies on the document / folder you specify, make sure to select and upload the correct ones to A&GEL and have a clear naming convention for such trusted documents.",
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.title':
    'Word document settings',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.body':
    "Word documents must have their security settings set to 'External' (or its equivalent) prior to uploading them to A&GEL.",
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.4.h':
    'Q: What about third-party documents? Can I upload them to A&GEL?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.5.p':
    "Certainly! You are encouraged to use A&GEL to analyse, interrogate or review third-party documents — in fact, it's one of the core strengths of many of the specialised modes of A&GEL (like Review). This includes documents from your opposing counsel / counterparty.",
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.6.p':
    'Just be sure to upload it to a folder that clearly demarcates that it is a third-party document so that you can tell from the file path whether it is a trusted precedent or in fact a "foreign" document that you are working on.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.7.p':
    'Keep in mind any company policies (such as policies which cover the usage of Generative AI) and acceptable use policies relevant to your use of A&GEL as well, including the use of third party content with the appropriate permissions, where required.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.8.h':
    'Q: Why does A&GEL take a long time to "process" files which I upload to the Files tab or in a Chat?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.9.p':
    'Documents have to be converted into a form that A&GEL can work with (the form is called "embeddings") and thus may take some time when being uploaded — but this occurs one-time only upon uploading to your Files in Vault. Documents uploaded to the Files tab may be reused in new sessions by selecting the file as the context in Chat or in any of the Specialised Modes.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.10.p':
    'In Chat, once you have uploaded a document, you can re-chat with the same document in a fresh Chat session by clicking on the "Context" button and then "Start a new Chat with documents" button.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.11.h':
    'Q: How should I upload my documents to the Files tab in bulk?',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.12.p':
    'In the File mode, click the upload button at the top right of the screen. Select whichever and however many files you wish to upload, and press "open". You may continue to use A&GEL\'s other functionalities while your reference materials are uploading.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.13.h':
    "Q: How should I sort and manage the reference materials I've uploaded to A&GEL? Why shouldn't I just upload everything into one folder?",
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.14.p':
    '<strong>Why is file management important?</strong> Appropriate file management is crucial for ensuring that you can effectively: (a) select relevant reference materials for A&GEL to contextualise its responses to; and (b) check which reference materials A&GEL has used to ensure the accuracy and reliability of the output generated.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.15.p':
    '<strong>How should I manage the reference materials uploaded?</strong> When uploading reference materials to A&GEL, we strongly recommend that you do not upload everything into one folder. Instead, we recommend that you curate and group your documents by: (i) subject matter; and (ii) workflow.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.16.p':
    'To do so in the File tab, before uploading your documents, create a new folder by clicking on the "Create Folder" button at the top right corner and label it with your subject matter. In the newly created folder, create a sub folder and label it with the workflow of the documents you are uploading.',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.17.p':
    'When you then upload your documents, there will be an appropriate file path which displays both the subject matter and workflow of the document. For example: <code>Home / IP Licensing Agreements / Licensor</code>',
  'pages.angelInsider.issues.feature-faq.sections.2.kicker': '3 — Prompting A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.2.heading': 'Writing effective prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.0.h':
    'Q: What types of prompts may I use?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.1.p':
    'You may prompt A&GEL in many ways. Here are some suggestions of various types of prompts (including some that you might not have thought of):',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.2.h':
    'Information seeking and retrieval',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.0':
    '<strong>Question-Based Prompts:</strong> Direct questions seeking factual information, explanations, or clarifications.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.1':
    '<strong>Explanation Prompts:</strong> Requests for detailed explanations of concepts, processes, or phenomena. These often use phrases like "explain," "describe," or "break down".',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.2':
    '<strong>Research Prompts:</strong> More complex information-gathering requests that may require synthesising information from multiple sources.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.4.h': 'Task-oriented and instructional',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.0':
    '<strong>Instruction Prompts:</strong> Clear, direct commands using action verbs like "write," "create," "analyse," or "summarise".',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.1':
    '<strong>Multi-Step Task Prompts:</strong> Complex instructions that break down larger tasks into sequential steps.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.2':
    '<strong>Template-Based Prompts:</strong> Structured prompts that provide a specific format or framework for the AI to follow.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.6.h': 'Analytical and problem-solving',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.0':
    '<strong>Data Analysis Prompts:</strong> Instructions for analysing datasets, identifying patterns, or extracting insights.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.1':
    '<strong>Problem-Solving Prompts:</strong> Requests that present a challenge and ask the AI to provide solutions, strategies, or recommendations.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.2':
    '<strong>Comparative Analysis Prompts:</strong> Instructions to compare and contrast different options, evaluate alternatives, or assess pros and cons.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.8.h': 'Classification and organisation',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.0':
    '<strong>Classification Prompts:</strong> Instructions to categorise text, data, or information into predefined classes or labels.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.1':
    '<strong>Sorting and Ranking Prompts:</strong> Requests to organise information according to specific criteria, such as importance, priority, or preference.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.2':
    '<strong>Tagging and Labelling Prompts:</strong> Instructions to assign tags, labels, or metadata to content for organisation or search purposes.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.10.h': 'Transformation and formatting',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.0':
    '<strong>Translation Prompts:</strong> Instructions to convert text from one language to another or adapt content for different cultural contexts.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.1':
    '<strong>Format Conversion Prompts:</strong> Requests to change the structure or presentation of information, such as converting prose to bullet points.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.2':
    '<strong>Style Transformation Prompts:</strong> Instructions to rewrite content in different tones, styles, or for different audiences.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.12.h': 'Other types of prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.0':
    'Role-Playing and Persona Prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.1':
    'Conversational and Interactive Prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.2':
    'System and Behavioural Prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.3':
    'Reasoning and Logic Prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.4': 'Code and Technical Prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.5':
    'Educational and Training Prompts',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.14.h':
    'Q: How do I write effective prompts?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.15.p':
    'Generally, the most effective prompts consist of 4 parts: <strong>(a) Persona; (b) Task; (c) Context; and (d) Format.</strong>',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.16.h': '(a) Persona',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.17.p':
    'Persona refers to the information you provide about yourself or what A&GEL is to emulate when writing an AI prompt. This helps channel A&GEL to write in a certain style and tone. Adding a persona would help you get a response that suits you better.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.label': 'Example',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.text':
    "You are an experienced lawyer with 30 years' experience.",
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.19.h': '(b) Task',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.20.p':
    "This is the instruction you give the model. You should be specific about your task instructions to get the best results. However, it's also important to be clear and concise when assigning AI tasks.",
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.label': 'Example',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.text':
    'Summarise this document in no more than 100 words.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.22.h': '(c) Context',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.23.p':
    'The context (i.e. information) you feed A&GEL can make all the difference. Context is the best way to get targeted results from your A&GEL prompts. Such context may also be stated in the form of expert "Knowledge" that you want A&GEL to specifically take into account when generating its output.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.label': 'Example',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.text':
    'This summary is for the client, the buyer in this transaction. Include details of the transaction from the perspective of the buyer in your summary.\n\nKnowledge: Assignment, novation or transfer clauses are not examples of change of control, ownership or interest provisions or clauses.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.25.h': '(d) Format',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.26.p':
    'This is the form of the output. Options include lists, tables, and Markdown format.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.label': 'Example',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.text':
    'Present the summary in the form of a table.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.title':
    'Start from the Prompt Library',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.body':
    'One way to write effective prompts is by taking an existing prompt that has been proven to be effective and adapting it for your purposes. Go to the Prompt Library tab, "Clone" the relevant prompt, and adapt it for your matter.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.29.h':
    'Full example — Persona + Task + Context + Format',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.label': 'Full prompt example',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.text':
    'You are an experienced lawyer. Generate a concise (in no more than 100 words each) summary of this document. Instructions: focus on pointing out (1) key benefits and positive points covered. In a separate bullet point, give at least one example of facts cited to illustrate this and (b) key risks and downsides covered. In a separate bullet point, give at least one example of facts cited to illustrate this. Ensure coherence and clarity in the summary. Where more than one example or supporting argument is found, state which is the best or worst, as described in the article. Use formal language and maintain a neutral tone. Avoid including personal opinions or interpretations. Present all output in markdown format, using bullet points for each key point and bold text for particularly important findings. Your work must be precise, accurate, and professional, as it will be reviewed by senior legal professionals and used in high-stakes financial transactions.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.31.h':
    'Q: What is RAG and when does A&GEL use it?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.32.p':
    "By default, A&GEL's chat function uses Retrieval-Augmented Generation (RAG). This draws information from the reference materials you uploaded to the File tab before passing the information on to the generative component (i.e. the LLM) along with the prompt you made to A&GEL. A&GEL then generates an output based on the data it has — with added context from the RAG.",
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.33.p':
    'The combination of RAG and LLM technology gives context and relevant information for A&GEL to produce an "augmented response", enhancing the precision of A&GEL\'s output and in turn, creates a higher probability that the answer would be reliable.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.34.h':
    "Q: Why shouldn't I simply allow A&GEL to consider all my uploaded materials for all prompts?",
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.35.p':
    'We strongly recommend that you do not have A&GEL consider uploaded materials that are not relevant to your prompt.',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.36.p':
    "Gen AI tools like A&GEL do not understand the meaning of words, clauses, agreements etc. They operate through a probabilistic method, rather than true comprehension. In chat mode, A&GEL will, if all Files are selected as Context, draw references from all documents uploaded to your Files in Vault. However, the relevant contextual materials for your prompt may only be those of a specific subject matter, or furthermore, a specific workflow. Providing A&GEL with additional context not relevant to your purposes will likely reduce the speed, accuracy, precision, and reliability of A&GEL's output.",
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.37.h':
    'Q: How do I select the relevant reference materials for each prompt?',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.38.p':
    'In Chat mode, to restrict A&GEL to only use strictly relevant reference materials as context for your prompt, navigate to "Context", click the selection symbol, and only select the relevant documents / folders.',
  'pages.angelInsider.issues.feature-faq.sections.3.kicker': '4 — Using Outputs',
  'pages.angelInsider.issues.feature-faq.sections.3.heading': 'Checking accuracy and reliability',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.0.h':
    'Q: I have prompted A&GEL and gotten my output. May I use the output as-is?',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.1.p':
    "Generally speaking, you should always check A&GEL's output before it is used for your work product. You are recommended to only use output from A&GEL as a starting point or as a point of reference, and should always cross-check against trusted/reliable knowledge sources (such as your uploaded reference materials or verified legal materials).",
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.2.h':
    'Q: How should I check the accuracy and reliability of the output?',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.3.p':
    "In Chat mode, A&GEL's outputs have been optimised to include references whenever available. These references are links to trusted information (e.g. your uploaded materials in the Files tab).",
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.4.p':
    "<strong>A&GEL should be a gateway to your know-how, not the source of your know-how.</strong> By clicking on each reference link, you will be able to see the reference material from which A&GEL took context from. You should always check A&GEL's output against these reference materials to ensure its accuracy and reliability.",
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.5.p':
    'If appropriate A&GEL file management practices were implemented, the reference links — which show the file path of the documents referenced — would also give you a good snapshot of whether A&GEL had augmented its output using the correct subject matter (and workflow) materials. For example, if you are prompting from the position of a "Leasehold Assignor" but notice that A&GEL has referenced a document contained in the "Leasehold Assignee" folder, you can immediately tell that the output is not fully contextualised to your purposes.',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.title':
    'What if the output does not have any references?',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.body':
    "Outputs without references are prone to hallucinations as they are not grounded in any trusted reference material. If you don't see any references, it is almost certainly the case that the information presented in the output comes only from the model's pre-training. You should not use the output unless you are sure that it was given in response to a general writing or text editing-related prompt (e.g. simplify this document or proof-reading) or summarisation, where the model has been given sufficient context.",
  'pages.angelInsider.issues.feature-faq.sections.4.kicker': '5 — Glossary',
  'pages.angelInsider.issues.feature-faq.sections.4.heading': 'Technical terms used in A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.0.p':
    '<strong>Favourite File Weight:</strong> Adjusts how heavily A&GEL prioritises documents you have flagged as "favourites" (within Vault) when generating responses. A higher weight ensures these preferred sources influence the output more significantly than general files in your Vault.',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.1.p':
    '<strong>Re-Ranking:</strong> A secondary sorting process where A&GEL reviews initial search results to prioritise the most relevant clauses or text segments. This ensures the most pertinent information appears at the top before the response is generated.',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.2.p':
    '<strong>Search Ratio:</strong> Controls the volume of internal data the AI retrieves to answer a query. A higher ratio broadens the search to capture more context (useful for broad exploration), while a lower ratio focuses strictly on exact matches (loosely similar to CTRL+F).',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.3.p':
    '<strong>System Prompt:</strong> The base set of instructions that establishes A&GEL\'s specific role, tone, and operational boundaries (e.g., "You are a Senior Partner with 20 years of experience"). These settings serve as the primary framework that guides how A&GEL handles every subsequent request.',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.4.p':
    "<strong>'Thinking' or 'Reasoning':</strong> A process where A&GEL logically breaks down complex queries step-by-step before generating a final response. This internal deliberation mimics human reasoning and is intended to help reduce errors in complicated analysis.",
  'pages.angelInsider.issues.feature-faq.signoff.line':
    'Every new tool takes a bit of getting used to — and A&GEL is no different. The more you use it, the more useful it becomes.',
  'pages.angelInsider.issues.feature-faq.signoff.name': 'A&GEL Development Team',
  'pages.app.addCustomFieldsTitle': 'Add custom fields to extract for each event',
  'pages.app.addCustomStepButton': 'Custom Step',
  'pages.app.addFieldButton': 'Add Field',
  'pages.app.addFromLibraryButton': 'from Library',
  'pages.app.addFromSavedButton': 'Saved Config',
  'pages.app.addToMattersButton': 'Add to Matters',
  'pages.app.analysisType.agenticResearch.description':
    'Explores the selected documents and uploaded files, then synthesises a comprehensive answer with citations.',
  'pages.app.analysisType.agenticResearch.title': 'Agentic Research',
  'pages.app.analysisType.comparison.description':
    'Compares two documents and gives a report describing the differences. You may provide a prompt to target the comparison.',
  'pages.app.analysisType.comparison.title': 'Comparison',
  'pages.app.analysisType.contractDeadlines.description':
    "List all deadlines, important dates and durations found in the contract/document. It help to  give details of the client (such as 'clients are a Singapore bank which specialises in e-banking services')",
  'pages.app.analysisType.contractDeadlines.title': 'Extract Deadlines',
  'pages.app.analysisType.executiveSummary.description':
    'Provides a concise executive summary of key advice, issues, risks, and actions.',
  'pages.app.analysisType.executiveSummary.title': 'Executive Summary',
  'pages.app.analysisType.gartnerReport.description':
    'Provides an in-depth industry report with forecasts and recommendations.',
  'pages.app.analysisType.gartnerReport.title': 'Gartner-style Report',
  'pages.app.analysisType.guidedSummary.description':
    'Provides a detailed summary of a single document guided by a prompt.',
  'pages.app.analysisType.multiStepPrompt.description':
    "Execute multiple prompts sequentially, building on each step's output.",
  'pages.app.analysisType.multiStepPrompt.title': 'Multi-Step Prompt',
  'pages.app.analysisType.scopeOfWork.description':
    'Upload or select a client email, letter or RFP with a request for assistance or services. In the "Prompt", it helps to  give details of the client (such as \'clients are a Singapore bank which specialises in e-banking services\')',
  'pages.app.analysisType.scopeOfWork.title': 'Scope of Work Summary',
  'pages.app.analysisType.standardInfo.description':
    'Provides a concise summary, a list of people and entities of interest and a short timeline of events. You may provide up to 100 documents.',
  'pages.app.analysisType.timeline.description':
    'Provides a detailed timeline of events over up to 100 documents.',
  'pages.app.analyzingFiles': 'Analyzing files...',
  'pages.app.applicablePartiesColumnTitle': 'Applicable Parties',
  'pages.app.appsInstructions':
    'Select several files to work with and then choose a type of analysis from the list below. Requests take around 1-5 minutes to process.',
  'pages.app.appsList.agenticResearch.description':
    'Explores the selected documents and uploaded files, then synthesises a comprehensive answer with citations.',
  'pages.app.appsList.contractDeadlines.description':
    'List all deadlines, important dates and durations found in the contract/document.',
  'pages.app.appsList.executiveSummary.description':
    'High-level overview of key points, findings, and recommendations for leadership',
  'pages.app.appsList.gartnerReport.description':
    'In-depth industry analysis using confident and objective research methodology',
  'pages.app.appsList.guidedSummary.description':
    'Provides a detailed summary of a single document guided by a prompt',
  'pages.app.appsList.multiStepPrompt.description':
    "Execute multiple prompts sequentially, building on each step's output",
  'pages.app.appsList.scopeOfWork.description':
    'Upload or select a client email, letter or RFP with a request for assistance or services.',
  'pages.app.appsList.standardInfo.description':
    'Provides a concise summary, list of people and entities, and short timeline',
  'pages.app.appsList.timeline.description':
    'Provides a detailed timeline of events over up to 100 documents',
  'pages.app.appsTitle': 'Apps',
  'pages.app.backToSavedPromptsLabel': 'Back to saved prompts',
  'pages.app.backgroundColumnTitle': 'Background',
  'pages.app.buildMultiStepPromptTitle': 'Build your multi-step prompt',
  'pages.app.buildNewButton': 'New config',
  'pages.app.clauseColumnTitle': 'Clause',
  'pages.app.clearStepsButton': 'Clear',
  'pages.app.clearStepsConfirm': 'Remove all steps from the list?',
  'pages.app.clientDetailsPlaceholder': 'Name and brief details of the client',
  'pages.app.clientInformationTitle': 'Client Information',
  'pages.app.clientLabel': 'Client',
  'pages.app.collapseAllPrompts': 'Collapse all prompts',
  'pages.app.collapsePrompt': 'Collapse prompt',
  'pages.app.compilingFinalSummary': 'Compiling final summary...',
  'pages.app.complexityLabel': 'Complexity',
  'pages.app.configNameLabel': 'Config Name',
  'pages.app.configTagsLabel': 'Tags',
  'pages.app.configurationDeletedSuccess': 'Configuration deleted',
  'pages.app.configurationSavedSuccess': 'Configuration saved successfully',
  'pages.app.configurationUpdatedSuccess': 'Configuration updated successfully',
  'pages.app.contactLabel': 'Contact',
  'pages.app.counterpartyLabel': 'Counterparty',
  'pages.app.dateReferenceColumnTitle': 'Date/Reference',
  'pages.app.deadlinesSectionTitle': 'Deadlines',
  'pages.app.deleteConfigConfirmTitle': 'Are you sure you want to delete this configuration?',
  'pages.app.deleteStepTooltip': 'Delete step',
  'pages.app.detailsColumnTitle': 'Details',
  'pages.app.doneCount': 'Done ({completed}/{total})',
  'pages.app.dragHereToUpload': 'Drag here to upload',
  'pages.app.dragStepTooltip': 'Drag step',
  'pages.app.dropZoneForNamedStep': 'Drop zone for {stepName}',
  'pages.app.dropZoneForStepNumber': 'Drop zone for step {stepNumber}',
  'pages.app.durationColumnTitle': 'Duration',
  'pages.app.enterConfigNamePlaceholder': 'Enter config name',
  'pages.app.enterDescriptionPlaceholder': 'Enter description',
  'pages.app.enterTagsPlaceholder': 'Type a tag and press Enter',
  'pages.app.entitiesColumnTitle': 'Entities',
  'pages.app.expandAllPrompts': 'Expand all prompts',
  'pages.app.expandPrompt': 'Expand prompt',
  'pages.app.extendPromptTabLabel': 'Extend Prompt',
  'pages.app.extraFieldDescriptionPlaceholder':
    'Description (e.g. Extract the monetary value mentioned)',
  'pages.app.extraFieldKeyPlaceholder': 'Key (e.g. Budget)',
  'pages.app.extractColumnTitle': 'Extract',
  'pages.app.extractDeadlinesModalDescription':
    "List all deadlines, important dates and durations found in the contract/document. It help to give details of the client (such as 'clients are a Singapore bank which specialises in e-banking services')",
  'pages.app.fileCountLabel': '{count} File(s)',
  'pages.app.filesCompleteCount': '{completed}/{total} files complete',
  'pages.app.hardDeadlineColumnTitle': 'Hard Deadline',
  'pages.app.inProgressSuffix': ' (in progress)',
  'pages.app.keyDatesDeadlinesTitle': 'Key Dates & Deadlines',
  'pages.app.libraryPanelTitle': 'Prompt Library',
  'pages.app.loadSavedConfigPlaceholder': 'Load saved config',
  'pages.app.loadingDocumentTip': 'Loading document...',
  'pages.app.mattersUpdatedSuccess': 'Matters updated successfully',
  'pages.app.moveStepDownTooltip': 'Move down',
  'pages.app.moveStepUpTooltip': 'Move up',
  'pages.app.newAnalysisModesDescription':
    'We have introduced two new powerful analysis modes to help you get more value from your contracts.',
  'pages.app.newAnalysisModesTitle': 'New Analysis Modes',
  'pages.app.newFieldDefaultKey': 'Field {number}',
  'pages.app.newSessionLabel': 'New Session',
  'pages.app.newStepDefaultName': 'New Step',
  'pages.app.noSourceDocumentsDescription': 'No source documents',
  'pages.app.noTimelineItemsExtracted': 'No timeline items extracted.',
  'pages.app.overallTabLabel': 'Overall',
  'pages.app.overviewSectionTitle': 'Overview',
  'pages.app.partiesSectionTitle': 'Parties',
  'pages.app.peopleEntitiesInvolvedLabel': 'People / Entities Involved',
  'pages.app.periodsDurationsTitle': 'Periods & Durations',
  'pages.app.pleaseEnterPlaceholder': 'Please enter',
  'pages.app.processingNextStep': 'Processing next step...',
  'pages.app.promptForStepPlaceholder': 'Prompt for this step',
  'pages.app.promptLabelWithValue': 'Prompt: {prompt}',
  'pages.app.provideDetailsTabLabel': 'Provide details',
  'pages.app.provideDocumentsTabLabel': 'Provide documents',
  'pages.app.providePromptsTabLabel': 'Provide prompts',
  'pages.app.provisionColumnTitle': 'Provision',
  'pages.app.publishAudienceGroupsLabel': 'Groups',
  'pages.app.publishAudienceLabel': 'Audience',
  'pages.app.publishAudienceOptionFirmWide': 'Firm-wide',
  'pages.app.publishAudienceOptionGroup': 'Group',
  'pages.app.publishAudienceOptionPublic': 'Public',
  'pages.app.publishButton': 'Publish',
  'pages.app.publishConfigTitle': 'Publish Config',
  'pages.app.publishFirmWideNotice':
    'This config will be shared with everyone in your organisation. A request will be sent to the org admin for approval.',
  'pages.app.publishPublicNotice':
    'This config will be visible to all users. A request will be sent to the super admin for approval.',
  'pages.app.publishRequestSubmitted': 'Publish request submitted — awaiting admin approval',
  'pages.app.publishedToGroup': 'Published to group',
  'pages.app.readingDocumentName': 'Reading {name}',
  'pages.app.restrictionColumnTitle': 'Restriction',
  'pages.app.restrictiveCovenantsTitle': 'Restrictive Covenants',
  'pages.app.reuseButton': 'Re-use',
  'pages.app.runAppButton': 'Run App',
  'pages.app.sanitizedCheckingDocuments': 'Checking documents…',
  'pages.app.sanitizedSearchingDocuments': 'Searching documents…',
  'pages.app.sanitizedWorkingThroughDocuments': 'Working through documents…',
  'pages.app.saveAsConfigButton': 'Save as',
  'pages.app.saveConfigButton': 'Save Config',
  'pages.app.saveConfigurationTitle': 'Save Configuration',
  'pages.app.savedPromptStepCount': '{count, plural, one {# step} other {# steps}}',
  'pages.app.savedPromptsEmpty': 'No saved multi-step prompts found',
  'pages.app.savedPromptsPanelTitle': 'Select saved config',
  'pages.app.savedPromptsSearchPlaceholder': 'Search saved prompts...',
  'pages.app.savedPromptsTagFilterPlaceholder': 'Filter by tag',
  'pages.app.scopeOfWorkModalDescription':
    'Upload or select a client email, letter or RFP with a request for assistance or services. In the "Prompt", it helps to give details of the client (such as \'clients are a Singapore bank which specialises in e-banking services\')',
  'pages.app.searchMattersPlaceholder': 'Search matters...',
  'pages.app.searchPromptsPlaceholder': 'Search prompts...',
  'pages.app.selectAtLeastOneGroupError': 'Select at least one group',
  'pages.app.selectDocumentsStepTitle': '1. Select the document(s) you wish to analyse',
  'pages.app.selectMattersLabel': 'Select matter(s):',
  'pages.app.sharedConfigLabel': '{name} (shared)',
  'pages.app.sourcesColumnTitle': 'Sources',
  'pages.app.specialRequestsSectionTitle': 'Special Requests',
  'pages.app.specificInformationStepTitle': '2. Specific information (optional)',
  'pages.app.stepNamePlaceholder': 'Step Name (e.g. Extract Entities)',
  'pages.app.stepNumberLabel': 'Step {number}',
  'pages.app.stepsAddedFromConfig': '{count, plural, one {# step added} other {# steps added}}',
  'pages.app.subagentLabel': 'Subagent {number}',
  'pages.app.subjectLabel': 'Subject',
  'pages.app.summaryLabel': 'Summary',
  'pages.app.timelineFieldsDescription':
    'Define additional columns you want to see in the timeline. For each field, provide a key (column header) and a description of what information to extract.',
  'pages.app.tool.checkingDocuments': 'Checking documents',
  'pages.app.tool.readingDocument': 'Reading document',
  'pages.app.tool.searchingDocuments': 'Searching documents',
  'pages.app.tool.workingWithName': 'Working ({name})',
  'pages.app.tool.writingReport': 'Writing report',
  'pages.app.untitledSession': '(Untitled)',
  'pages.app.updateConfigButton': 'Update',
  'pages.app.updateConfigurationTitle': 'Update Configuration',
  'pages.app.updateMattersFailed': 'Failed to update matters',
  'pages.app.uploadOrSelectFilesError': 'Please upload files or select existing files',
  'pages.app.urgencyColumnTitle': 'Urgency',
  'pages.app.useAnotherAppButton': 'Use another App',
  'pages.app.whatsNew': "What's New",
  'pages.app.workingEllipsis': 'Working…',
  'pages.app.workingThroughDocumentsCount': 'Working through documents ({completed}/{total})',
  'pages.chat.addToMatters': 'Add to Matters',
  'pages.chat.agentQuestion.answersSent': 'Answers sent to agent',
  'pages.chat.agentQuestion.customAnswerPlaceholder': 'Or type your own answer...',
  'pages.chat.agentQuestion.dismissQuestion': 'Dismiss question',
  'pages.chat.agentQuestion.noAnswer': '(no answer)',
  'pages.chat.agentQuestion.question': 'Question',
  'pages.chat.agentQuestion.questionOfTotal': 'Question {current} of {total}',
  'pages.chat.agentQuestion.questionProgress': '{current} / {total}',
  'pages.chat.agentQuestion.reviewAnswers': 'Review answers',
  'pages.chat.agentQuestion.reviewYourAnswers': 'Review your answers before submitting.',
  'pages.chat.agentQuestion.seeLess': 'See less',
  'pages.chat.agentQuestion.seeMore': 'See more',
  'pages.chat.agentQuestion.sendAnswers': 'Send Answers',
  'pages.chat.agentQuestion.submitted': 'Submitted',
  'pages.chat.agentQuestion.summary': 'Summary',
  'pages.chat.agenticRag': 'Agentic RAG',
  'pages.chat.agenticRag.lockedByDeepResearch':
    'Deep Research requires this feature to be enabled.',
  'pages.chat.agenticRag.description': 'Agent decides when to search your context files',
  'pages.chat.agenticRag.tooltip':
    'Enable agentic retrieval with cited sources. Requires documents in chat context.',
  'pages.chat.allowSelfPrompting': 'Allow self-prompting',
  'pages.chat.allowSelfPrompting.description': 'Agent applies a matching prompt from your library',
  'pages.chat.allowSelfPrompting.tooltip':
    'When enabled, the assistant may suggest and apply library prompts to improve responses.',
  'pages.chat.attachedDocument': 'Attached document',
  'pages.chat.auth.contentOpenedInNewTab': 'Content opened in new tab',
  'pages.chat.auth.dataOpenedInNewTab': 'Data opened in new tab',
  'pages.chat.auth.failedToFetchUrl': 'Failed to fetch URL: {error}',
  'pages.chat.auth.failedToOpenNewTab': 'Failed to open new tab',
  'pages.chat.auth.fileOpenedInNewTab': 'File opened in new tab',
  'pages.chat.auth.jsonResponseTitle': 'JSON Response',
  'pages.chat.auth.textResponseTitle': 'Text Response',
  'pages.chat.cannotCopyNonTextContent': 'Cannot copy non-text content',
  'pages.chat.chatTitle': 'Chat',
  'pages.chat.clickOrDragToUpload': 'Click or drag to upload',
  'pages.chat.connectionInterrupted': 'Your connection was interrupted. Please tap to {retry}.',
  'pages.chat.context.custom': 'Custom {suffix}',
  'pages.chat.context.defaultWithName': 'Default ({name})',
  'pages.chat.context.fullContext': 'Full Context',
  'pages.chat.context.label': 'Context',
  'pages.chat.context.selectedLabel': 'selected',
  'pages.chat.customisation': 'Customisation',
  'pages.chat.dragHereToUpload': 'Drag here to upload',
  'pages.chat.emptyState.desktopTitle': 'What can A&GEL help you with today?',
  'pages.chat.emptyState.mobileTitle': 'How can A&GEL help?',
  'pages.chat.emptyState.subtitle':
    'Pick a prompt below to jump straight in, or type directly to chat with A&GEL.',
  'pages.chat.failedToCopyMessage': 'Failed to copy message',
  'pages.chat.failedToDownloadFile': 'Failed to download file: {error}',
  'pages.chat.fileDownloadedSuccessfully': 'File downloaded successfully',
  'pages.chat.filesInVault': 'Files in Vault',
  'pages.chat.home': 'Home',
  'pages.chat.htmlContentIframeTitle': 'HTML Content',
  'pages.chat.messageCopied': 'Message copied!',
  'pages.chat.newChatConfirm.content':
    'Are you sure you want to clear the current chat history and start a new session?',
  'pages.chat.newChatConfirm.okText': 'Yes, start new chat',
  'pages.chat.newChatConfirm.title': 'Start a new chat?',
  'pages.chat.nextStep.button': 'Next Step',
  'pages.chat.nextStep.review': 'Review',
  'pages.chat.nextStep.workstudio': 'Workstudio',
  'pages.chat.referenceDocument': 'Reference document',
  'pages.chat.referenceTitle': 'Reference: {title}',
  'pages.chat.referencesCount': '{count} references',
  'pages.chat.selectedContext': 'Selected Context',
  'pages.chat.selfPromptedUsing': 'Self-prompted using {name}.',
  'pages.chat.showMoreLines': 'Show more ({count} lines)',
  'pages.chat.sourcesCount': 'Sources ({count})',
  'pages.chat.startNewChat': 'Start a new Chat',
  'pages.chat.starterPrompt.caseSummariser.description':
    'A detailed prompt with Legal Context for summarising Singapore cases.',
  'pages.chat.starterPrompt.caseSummariser.name': 'Case Summariser',
  'pages.chat.starterPrompt.draftChecklist.description':
    'A prompt to get Angel to create a checklist from any document.',
  'pages.chat.starterPrompt.draftChecklist.name': 'Draft a checklist',
  'pages.chat.starterPrompt.summariseArticle.description':
    'General purpose summariser of articles.',
  'pages.chat.starterPrompt.summariseArticle.name': 'Summarise this article',
  'pages.chat.status.completed': 'Completed',
  'pages.chat.status.working': 'Working',
  'pages.chat.toolCategory.compare': 'Comparing texts',
  'pages.chat.toolCategory.generate': 'Generating document',
  'pages.chat.toolCategory.read': 'Reading document',
  'pages.chat.toolCategory.searchDoc': 'Searching document',
  'pages.chat.toolCategory.searchFiles': 'Searching files',
  'pages.chat.toolCategory.selfInstruction': 'Applying instruction',
  'pages.chat.transientFiles': 'Transient Files',
  'pages.chat.unknownFileName': 'Unknown',
  'pages.chat.unknownFileNameLong': 'Unknown File',
  'pages.chat.untitledSession': '(Untitled)',
  'pages.chat.upload.failedToUploadFile': 'Failed to upload {fileName}',
  'pages.chat.upload.fileTypeNotAllowed':
    'File type not allowed. Only PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT, PPTX are allowed.',
  'pages.chat.upload.onlyAllowedTypes':
    'Please upload only PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT or PPTX files',
  'pages.chat.upload.someFilesSkipped':
    'Some files were skipped. Only PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT or PPTX files are allowed',
  'pages.chat.uploadedImageAlt': 'uploaded',
  'pages.chat.waiting.almostThere': 'Almost there...',
  'pages.chat.waiting.fetchingThatForYou': 'Fetching that for you...',
  'pages.chat.waiting.hangTight': "Hang tight, I'm on it...",
  'pages.chat.waiting.holdOnRetrieving': "Hold on, I'm retrieving info...",
  'pages.chat.waiting.justAMoment': 'Just a moment...',
  'pages.chat.waiting.letMeCheck': 'Let me check...',
  'pages.chat.waiting.lookingThatUp': 'Looking that up for you...',
  'pages.chat.waiting.oneSecPlease': 'One sec, please...',
  'pages.chat.waiting.workingOnIt': 'Working on it...',
  'pages.chat.outlookSearch.offTooltip': 'Search your Outlook mail',
  'pages.chat.outlookSearch.onTooltip': 'Outlook search is on',
  'pages.chat.outlookSearch.connectTooltip': 'Connect Microsoft to search your Outlook mail',
  'pages.chat.outlookSearch.permissionMissing':
    'Outlook search needs permission to read your mail. Please try again.',
  'pages.chat.webSearch.confidentialityNotice':
    'Web search is turned on. Please do not include any client-confidential or privileged information in your prompts.',
  'pages.chat.researchPlan.complete': 'Research complete',
  'pages.chat.researchReport.tab.report': 'Report',
  'pages.chat.researchReport.tab.searches': 'Searches ({count})',
  'pages.chat.researchReport.tab.sources': 'Sources ({count})',
  'pages.chat.researchReport.noSearches': 'No searches were recorded for this report.',
  'pages.chat.researchReport.noSources': 'No sources were cited in this report.',
  'pages.chat.researchReport.openReport': 'View report',
  'pages.chat.researchReport.counts': '{searches} searches · {sources} sources',
  'pages.chat.researchReport.title': 'Research report',
  'pages.chat.researchReport.open': 'Open the full report',
  'pages.chat.researchPlan.ready': 'Ready to start',
  'pages.chat.researchPlan.editing': 'Editing',
  'pages.chat.researchPlan.addTopic': 'Add topic',
  'pages.chat.researchPlan.editSubtitle':
    'Edit the topics below. Changes apply before the research starts.',
  'pages.chat.researchPlan.cancel': 'Cancel',
  'pages.chat.researchPlan.saveChanges': 'Save changes',
  'pages.chat.researchPlan.showDetails': 'Show details',
  'pages.chat.researchPlan.working': 'Working ({done}/{total})',
  'pages.chat.researchPlan.stop': 'Stop',
  'pages.chat.researchPlan.viewProgress': 'View progress',
  'pages.chat.researchPlan.progressTitle': 'Research progress',
  'pages.chat.researchPlan.tab.progress': 'Progress',
  'pages.chat.research.copied': 'Report copied',
  'pages.chat.research.copyFailed': 'Could not copy the report',
  'pages.chat.research.pageRead': 'Read',
  'pages.chat.research.tableOfContents': 'Table of contents',
  'pages.chat.research.resizeContents': 'Resize table of contents',
  'pages.chat.research.windowTitle': 'Research',
  'pages.chat.research.completed': 'Completed',
  'pages.chat.research.running': 'In progress',
  'pages.chat.research.stopped': 'Stopped',
  'pages.chat.research.failed': 'Failed',
  'pages.chat.research.tab.report': 'Report',
  'pages.chat.research.tab.searches': 'Searches ({count})',
  'pages.chat.research.tab.sources': 'Sources ({count})',
  'pages.chat.research.reportPending': 'The report will appear here as it is written.',
  'pages.chat.research.noSearches': 'No searches yet.',
  'pages.chat.research.noSources': 'No sources yet.',
  'pages.chat.research.searchSent': 'Sent',
  'pages.chat.research.searchRunning': 'Searching',
  'pages.chat.research.searchSkipped': 'Skipped',
  'pages.chat.researchPlan.title': 'Research plan',
  'pages.chat.researchPlan.stepCount': '{count, plural, one {# step} other {# steps}}',
  'pages.chat.researchPlan.inProgress': 'Research running',
  'pages.chat.researchPlan.edit': 'Edit',
  'pages.chat.researchPlan.done': 'Done',
  'pages.chat.researchPlan.start': 'Start research',
  'pages.chat.researchPlan.addStep': 'Add a step',
  'pages.chat.researchPlan.removeStep': 'Remove step {number}',
  'pages.chat.researchPlan.includeStep': 'Include step {number}',
  'pages.chat.researchPlan.started': 'Research started',
  'pages.chat.webSearch.googleSuggestions': 'Google Search suggestions',
  'pages.chat.webSearch.permission.title': 'Search permission',
  'pages.chat.webSearch.permission.manual': 'Manual',
  'pages.chat.webSearch.permission.manualDescription': "Review each query before it's sent",
  'pages.chat.webSearch.permission.auto': 'Auto',
  'pages.chat.webSearch.permission.autoDescription': 'Runs without review. Queries leave the firm',
  'pages.chat.webSearch.permission.deep': 'Deep research',
  'pages.chat.webSearch.permission.deepDescription': 'Plans and runs many searches. Always auto',
  'pages.comparison.analysisFallbackTitle': 'Analysis',
  'pages.comparison.outcomeUnverified': 'Unverified',
  'pages.comparison.commentTags': 'Comment tags',
  'pages.comparison.allCommentTags': 'All comment tags',
  'pages.comparison.noMatchingComments': 'No comments match the selected tags',
  'pages.comparison.downloadExcel': 'Download Excel',
  'pages.comparison.stopSuccess': 'Comparison stopped successfully. You can view partial results.',
  'pages.comparison.stopFailed': 'Failed to stop comparison',
  'pages.comparison.uploadSuccess': '{fileName} uploaded successfully',
  'pages.comparison.uploadFailed': '{fileName} upload failed',
  'pages.comparison.uploadLimitExceeded': 'You can only upload {max} file(s) for this task type.',
  'pages.comparison.pollingTimeout': 'Polling timeout. The task may still be processing.',
  'pages.comparison.taskStarted': 'Comparison task started',
  'pages.comparison.startFailed': 'Failed to start comparison',
  'pages.comparison.previousAnalysisTitle': 'Previous Analysis',
  'pages.comparison.analysisPositionCounter': '{current} / {total}',
  'pages.comparison.analysisFoundCounter': '{total} Found',
  'pages.comparison.nextAnalysisTitle': 'Next Analysis',
  'pages.comparison.messageHeading': 'Message',
  'pages.comparison.noResultsYet': 'No results yet',
  'pages.comparison.startComparisonButton': 'Start Comparison',
  'pages.comparison.newComparisonButton': 'Start a new Comparison',
  'pages.comparison.searchComparisonsPlaceholder': 'Search Comparisons',
  'pages.comparison.reuseButton': 'Re-use',
  'pages.comparison.selectMattersLabel': 'Select matter(s):',
  'pages.comparison.searchMattersPlaceholder': 'Search matters...',
  'pages.comparison.mattersUpdated': 'Matters updated successfully',
  'pages.comparison.mattersUpdateFailed': 'Failed to update matters',
  'pages.comparison.addToMattersButton': 'Add to Matters',
  'pages.comparison.untitled': '(Untitled)',
  'pages.comparison.processingMoreResults': 'Processing more results...',
  'pages.comparison.processingComparison': 'Processing comparison...',
  'pages.comparison.taskType.strikethroughUnderline.label': 'Strikethrough & Underline',
  'pages.comparison.taskType.strikethroughUnderline.description':
    'Analyze changes marked with standard strikethrough and underline formatting.',
  'pages.comparison.taskType.trackedChanges.label': 'Tracked Changes',
  'pages.comparison.taskType.trackedChanges.description':
    'Review revisions and comments made using the Track Changes feature.',
  'pages.comparison.taskType.twoVersions.label': 'Two Versions',
  'pages.comparison.taskType.twoVersions.description':
    'Compare two separate versions of a document to identify differences.',
  'pages.comparison.taskType.referenceDocument.label': 'Target to Reference',
  'pages.comparison.taskType.referenceDocument.description':
    'Compare a target document against a reference document (i.e. termsheet).',
  'pages.comparison.requirement.singleDocument': 'Single Document',
  'pages.comparison.requirement.twoDocuments': 'Two Documents',
  'pages.comparison.startHereTab': 'Start here',
  'pages.comparison.selectDocumentsPrompt':
    'Select the document(s) you wish to perform a comparison on',
  'pages.comparison.dragUploadText': 'Click or drag file to this area to upload',
  'pages.comparison.swapOrderButton': 'Swap Order',
  'pages.comparison.fileLabel.old': '(Old) ',
  'pages.comparison.fileLabel.new': '(New) ',
  'pages.comparison.fileLabel.reference': '(Reference) ',
  'pages.comparison.fileLabel.target': '(Target) ',
  'pages.comparison.customInstructionTab': 'Custom Instruction (optional)',
  'pages.comparison.modifyPromptTitle': 'Modify Prompt',
  'pages.comparison.customInstructionPlaceholder':
    'Enter your specific instructions for A&GEL (such as "My clients are XYZ. Focus on amendments that impact my clients" or "Comment in Bahasa Malaysia")',
  'pages.comparison.pageTitle': 'Comparison',
  'pages.comparison.legalReviewDescription':
    'Comparison is optimised to carry out a “legal review" of amendments (i.e. by default it will comment on legal consequences arising from amendments).',
  'pages.comparison.similarDocumentComparisonTitle': 'Similar Document Comparison',
  'pages.comparison.referenceDocumentComparisonTitle': 'Reference Document Comparison',
  'pages.comparison.dragHereToUpload': 'Drag here to upload',
  'pages.comparison.documentCount.unknownFile': 'Unknown File',
  'pages.comparison.documentCount.fileCount': '{count} File(s)',
  'pages.comparison.reviewDirection.reviewedOnBehalfOf': 'Reviewed on behalf of ',
  'pages.comparison.reviewDirection.swapButton': 'Swap review direction',
  'pages.comparison.invalidFileDocxOrPdf': '{fileName} is not a valid .docx or .pdf file',
  'pages.comparison.invalidFileDocx': '{fileName} is not a valid .docx file',
  'pages.comparison.twoVersionsFileCountError':
    'Please upload exactly 2 documents for Two Versions comparison.',
  'pages.comparison.singleFileCountError': 'Please upload exactly 1 document for this task.',
  'pages.composer.changeAction.accept': 'Accept',
  'pages.composer.changeAction.reject': 'Reject',
  'pages.composer.changeAction.reset': 'Reset',
  'pages.composer.documentView.foundCount': '{count} Found',
  'pages.composer.documentView.nextChangeArrow': 'Next ↓',
  'pages.composer.documentView.nextChangeTitle': 'Next Change',
  'pages.composer.documentView.positionCount': '{current} / {total}',
  'pages.composer.documentView.previousChangeTitle': 'Previous Change',
  'pages.composer.documentView.stepNumber': 'Step {number}',
  'pages.composer.documentView.turnNumber': 'Turn {number}',
  'pages.composer.playbook.askAgel': 'Ask A&GEL',
  'pages.composer.playbook.chooseDocumentDescription':
    'Select a .docx to open its canvas and chat.',
  'pages.composer.playbook.chooseDocumentTitle': 'Choose a document to begin',
  'pages.composer.playbook.createSessionFailed': 'Failed to create Workstudio session',
  'pages.composer.playbook.documentCanvas': 'Document canvas',
  'pages.composer.playbook.docxOnlyAllowedError':
    'Only .docx files are allowed for Workstudio mode',
  'pages.composer.playbook.docxOnlySkippedWarning':
    'Some files were skipped. Only .docx files are allowed',
  'pages.composer.playbook.docxOnlySupportedError':
    'Only .docx files are supported for Workstudio mode',
  'pages.composer.playbook.downloadGenerating': 'Generating…',
  'pages.composer.playbook.dragToUpload': 'Drag here to upload',
  'pages.composer.playbook.fileUploadFailed': 'Failed to upload {fileName}',
  'pages.composer.playbook.fileUploadedSuccess': '{fileName} uploaded successfully',
  'pages.composer.playbook.newButtonText': 'New Workstudio',
  'pages.composer.playbook.openFailed': 'Failed to open Workstudio',
  'pages.composer.playbook.reuseButton': 'Re-use',
  'pages.composer.playbook.resizeChatPane': 'Resize chat area',
  'pages.composer.playbook.searchPlaceholder': 'Search Workstudio',
  'pages.composer.playbook.title': 'Workstudio',
  'pages.composer.playbookReview.acceptAllButton': 'Accept All',
  'pages.composer.playbookReview.acceptChangeError': 'Failed to accept change. Please try again.',
  'pages.composer.playbookReview.addCommentButton': 'Comment',
  'pages.composer.playbookReview.addCommentPlaceholder': 'Add a comment...',
  'pages.composer.playbookReview.addCommentTooltip': 'Add comment',
  'pages.composer.playbookReview.allAcceptError': 'Failed to accept all changes. Please try again.',
  'pages.composer.playbookReview.allAcceptedSuccess': 'All changes accepted',
  'pages.composer.playbookReview.allRejectError': 'Failed to reject all changes. Please try again.',
  'pages.composer.playbookReview.allRejectedSuccess': 'All changes rejected',
  'pages.composer.playbookReview.allResetError': 'Failed to reset all changes. Please try again.',
  'pages.composer.playbookReview.allResetSuccess': 'All changes reset to pending',
  'pages.composer.playbookReview.backToWorkstudio': 'Back to Workstudio',
  'pages.composer.playbookReview.changeOfTotal': 'Change {index} of {total}',
  'pages.composer.playbookReview.commentSaveError': 'Failed to save comment. Please try again.',
  'pages.composer.playbookReview.commentSavedSuccess': 'Comment saved',
  'pages.composer.playbookReview.discardDraftButton': 'Discard draft',
  'pages.composer.playbookReview.documentLoadFailedError':
    'Unable to load this document. Please refresh to try again.',
  'pages.composer.playbookReview.documentViewAriaLabel': 'Document view',
  'pages.composer.playbookReview.doneEditingButton': 'Done',
  'pages.composer.playbookReview.downloadGenericError': 'Failed to generate download',
  'pages.composer.playbookReview.downloadInfoTooltip':
    'Each turn remains reviewable. Download produces the current flattened document after accepted and pending layers are applied.',
  'pages.composer.playbookReview.downloadSuccess': 'Document downloaded successfully!',
  'pages.composer.playbookReview.downloadTimeoutError': 'Download generation timed out',
  'pages.composer.playbookReview.editCommentButton': 'Edit Comment',
  'pages.composer.playbookReview.editCommentTooltip': 'Edit comment',
  'pages.composer.playbookReview.editDocumentButton': 'Edit',
  'pages.composer.playbookReview.groupAcceptAllCount': 'Accept All ({count})',
  'pages.composer.playbookReview.groupAcceptedError':
    'Failed to accepted changes. Please try again.',
  'pages.composer.playbookReview.groupAcceptedSuccess': '{count} identical changes accepted',
  'pages.composer.playbookReview.groupRejectAllCount': 'Reject All ({count})',
  'pages.composer.playbookReview.groupRejectedError':
    'Failed to rejected changes. Please try again.',
  'pages.composer.playbookReview.groupRejectedSuccess': '{count} identical changes rejected',
  'pages.composer.playbookReview.groupResetAllCount': 'Reset All ({count})',
  'pages.composer.playbookReview.groupResetError': 'Failed to reset changes. Please try again.',
  'pages.composer.playbookReview.groupResetSuccess': '{count} identical changes reset',
  'pages.composer.playbookReview.hidePromptButton': 'Hide Prompt',
  'pages.composer.playbookReview.layerChangeCount':
    '{count, plural, one {# change} other {# changes}}',
  'pages.composer.playbookReview.loadingDocument': 'Loading document...',
  'pages.composer.playbookReview.sourcePreviewOnly':
    'Original document preview. AI changes are not shown in this view yet.',
  'pages.composer.playbookReview.sourcePreviewInteractionsUnavailable':
    'Selection-to-chat and document citation navigation are unavailable in this preview.',
  'pages.composer.playbookReview.folioReplacementTitle': 'Replacement',
  'pages.composer.playbookReview.folioReplacementPreview':
    'AI replacement preview. Decisions are saved to this session.',
  'pages.composer.playbookReview.folioReplacementUnavailable':
    'This proposal cannot be safely previewed in Folio. Showing the original read-only document.',
  'pages.composer.playbookReview.folioDecisionFailed':
    'Could not save this decision. Refresh to review the current session before retrying.',
  'pages.composer.playbookReview.documentPreviewError': 'Unable to display this document.',
  'pages.composer.playbookReview.localDraftTag': 'Local draft',
  'pages.composer.playbookReview.localDraftTooltip':
    'Unsaved draft. Use Save edits to record your text changes as tracked changes.',
  'pages.composer.playbookReview.noChangesDescription':
    'The AI did not propose any changes for the given instruction.',
  'pages.composer.playbookReview.noChangesFromStep': 'No changes from this step',
  'pages.composer.playbookReview.noChangesTitle': 'No changes identified',
  'pages.composer.playbookReview.previousChangesFallback': 'Previous changes',
  'pages.composer.playbookReview.processingTimeoutError':
    'Processing is taking longer than expected. Please refresh to check status.',
  'pages.composer.playbookReview.regenerateLabel': 'Regenerate',
  'pages.composer.playbookReview.rejectAllButton': 'Reject All',
  'pages.composer.playbookReview.rejectChangeError': 'Failed to reject change. Please try again.',
  'pages.composer.playbookReview.resetAllButton': 'Reset All',
  'pages.composer.playbookReview.reviewViewAriaLabel': 'Review view',
  'pages.composer.playbookReview.saveEditsButton': 'Save edits',
  'pages.composer.playbookReview.saveEditsError':
    'Failed to save edits. Your draft is kept — please try again.',
  'pages.composer.playbookReview.saveEditsNoChanges': 'No text changes to save.',
  'pages.composer.playbookReview.saveEditsSuccess': 'Edits saved as tracked changes.',
  'pages.composer.playbookReview.saveEditsTooltip':
    'Saves text changes as tracked changes. Formatting-only changes are not saved.',
  'pages.composer.playbookReview.saveEditsUnavailableTooltip':
    'Saving is unavailable because this document layout cannot be mapped back to the document text. Edits stay a local draft.',
  'pages.composer.playbookReview.selfPromptedUsing': 'Self-prompted using {promptName}.',
  'pages.composer.playbookReview.showFullPromptButton': 'Show Full Prompt',
  'pages.composer.playbookReview.showMoreIdentical':
    '{action, select, hide {Hide} other {Show}} {count} more identical {count, plural, one {change} other {changes}}',
  'pages.composer.playbookReview.showingDocumentView': 'Showing Document view',
  'pages.composer.playbookReview.showingStepView': 'Showing Step-by-step view',
  'pages.composer.playbookReview.status.accepted': 'Accepted',
  'pages.composer.playbookReview.status.pending': 'Pending',
  'pages.composer.playbookReview.status.rejected': 'Rejected',
  'pages.composer.playbookReview.statusDistributionAriaLabel': 'Review status distribution',
  'pages.composer.playbookReview.previousGroup': 'Previous',
  'pages.composer.playbookReview.nextGroup': 'Next',
  'pages.composer.playbookReview.chooseGroup': 'Choose paragraph',
  'pages.composer.playbookReview.groupOfTotal': '{index} of {total}',
  'pages.composer.playbookReview.viewGroup': 'View',
  'pages.composer.playbookReview.acceptGroup': 'Accept',
  'pages.composer.playbookReview.rejectGroup': 'Reject',
  'pages.composer.playbookReview.resetGroup': 'Reset',
  'pages.composer.playbookReview.toolbarLabel': 'Paragraph review',
  'pages.composer.playbookReview.acceptChange': 'Accept change',
  'pages.composer.playbookReview.rejectChange': 'Reject change',
  'pages.composer.playbookReview.resetAcceptance': 'Reset acceptance',
  'pages.composer.playbookReview.resetRejection': 'Reset rejection',
  'pages.composer.playbookReview.reviewDetails': 'Change details',
  'pages.composer.playbookReview.chooseIndividualChange': 'Choose individual change',
  'pages.composer.playbookReview.totalChanges': '{total} changes',
  'pages.composer.playbookReview.statusDistributionText':
    '{accepted} accepted, {rejected} rejected, {pending} pending',
  'pages.composer.playbookReview.chooseChange': 'Choose change',
  'pages.composer.playbookReview.selectedChange': 'Selected change',
  'pages.composer.playbookReview.previousChange': 'Previous change',
  'pages.composer.playbookReview.nextChange': 'Next change',
  'pages.composer.playbookReview.viewChange': 'View change',
  'pages.composer.playbookReview.changeComment': 'Change comment',
  'pages.composer.playbookReview.saveComment': 'Save comment',
  'pages.composer.playbookReview.blockedChange':
    'This change depends on an earlier decision. Review that change first.',
  'pages.composer.playbookReview.reviewPreviewFailed':
    'Your saved decisions are retained, but the reviewed preview could not be prepared.',
  'pages.composer.playbookReview.changeAnchorUnavailable':
    'This change has no available document anchor. Its review decision can still be saved.',
  'pages.composer.playbookReview.preparingReviewedPreview': 'Preparing reviewed preview…',
  'pages.composer.playbookReview.stepChangeCount':
    '{count, plural, one {# change} other {# changes}}',
  'pages.composer.playbookReview.stepTag': 'Step {number}',
  'pages.composer.playbookReview.stepViewAriaLabel': 'Step-by-step view',
  'pages.composer.playbookReview.turnNeedsRegeneration': 'This turn needs to be regenerated.',
  'pages.composer.playbookReview.turnRegenerationReason':
    'A decision on an earlier turn changed the document it was based on.',
  'pages.composer.playbookReview.turnHasConflicts': 'This turn has conflicting changes.',
  'pages.composer.playbookReview.turnConflictReason':
    'Some proposed changes overlap each other. Regenerate the turn to re-apply them.',
  'pages.composer.playbookReview.turnHasUnlocatableChanges':
    'This turn has changes that could not be located.',
  'pages.composer.playbookReview.turnUnlocatableReason':
    'Some proposed changes could not be located in the document. Regenerate the turn to re-apply them.',
  'pages.composer.playbookReview.turnTitle': 'Turn {order}: {prompt}',
  'pages.composer.playbookReview.undoChangeError': 'Failed to undo. Please try again.',
  'pages.composer.playbookReview.updatingCanvas': 'Updating the review canvas...',
  'pages.composer.playbookReview.viewChangeTooltip': 'View change in original document',
  'pages.composer.playbookReview.viewContextButton': 'View Context',
  'pages.composer.playbookReview.waitForUpdateWarning':
    'Please wait for the current update to finish before downloading.',
  'pages.dashboard.allChannelsOption': 'All Channels',
  'pages.dashboard.presetPast30Days': 'Past 30 Days',
  'pages.dashboard.presetToday': 'Today',
  'pages.dashboard.presetWtd': 'WTD',
  'pages.dashboard.presetMtd': 'MTD',
  'pages.dashboard.presetYtd': 'YTD',
  'pages.dashboard.exportLoading': 'Export Dashboard',
  'pages.dashboard.downloaded': 'Downloaded',
  'pages.dashboard.downloadingName': 'Downloading {name}',
  'pages.dashboard.chatGptMessageSeries': 'ChatGPT Message',
  'pages.dashboard.storyboardMessageSeries': 'Storyboard message',
  'pages.dashboard.broadcastMessageSeries': 'Broadcast message',
  'pages.dashboard.messageTrendDataTitle': 'Message Trend Data',
  'pages.dashboard.messageTrendDataTooltip':
    'Historical trends for messages statistics during the selected period.',
  'pages.dashboard.newUsersSeries': 'New Users',
  'pages.dashboard.activeUsersSeries': 'Active Users',
  'pages.dashboard.userTrendDataTitle': 'User Trend Data',
  'pages.dashboard.userTrendDataTooltip':
    'Historical trends for users statistics during the selected period.',
  'pages.dashboard.userActivityHeatmapTitle': 'User Activity Heatmap',
  'pages.dashboard.userActivityHeatmapTooltip':
    'Average number of user messages per hour per weekday for the selected period.',
  'pages.dashboard.wordCloudTitle': 'Word Cloud',
  'pages.dashboard.wordCloudTooltip':
    'Graphical representation of the frequently queried words in user messages within the selected period.',
  'pages.dashboard.realTimeUsersTitle': 'Real Time Users',
  'pages.dashboard.activeUsersTitle': 'Active Users',
  'pages.dashboard.newUsersTitle': 'New Users',
  'pages.dashboard.promptTokensTitle': 'Prompt Tokens',
  'pages.dashboard.completionTokensTitle': 'Completion Tokens',
  'pages.dashboard.userMessagesTitle': 'User Messages',
  'pages.dashboard.chatGptTitle': 'ChatGPT',
  'pages.dashboard.storyboardsTitle': 'Storyboards',
  'pages.dashboard.botMessagesTitle': 'Bot Messages',
  'pages.dashboard.broadcastsTitle': 'Broadcasts',
  'pages.dashboard.repliesTitle': 'Replies',
  'pages.dashboard.messageExchangesTitle': 'Message Exchanges',
  'pages.dashboard.broadcastTitle': '#Broadcast',
  'pages.dashboard.outreachTitle': 'Outreach',
  'pages.dashboard.totalUsersTitle': 'Total Users',
  'pages.dashboard.totalUserMessagesTitle': 'Total User Messages',
  'pages.dashboard.totalBotMessagesTitle': 'Total Bot Messages',
  'pages.dashboard.totalMessageExchangesTitle': 'Total Message Exchanges',
  'pages.diagnostics.usersFilter.label': 'Users:',
  'pages.diagnostics.usersFilter.placeholder': 'Users',
  'pages.diagnostics.typesFilter.label': 'Types:',
  'pages.diagnostics.typesFilter.placeholder': 'Types',
  'pages.diagnostics.dateFilter.label': 'Date:',
  'pages.diagnostics.datePreset.past30Days': 'Past 30 Days',
  'pages.diagnostics.datePreset.today': 'Today',
  'pages.diagnostics.datePreset.wtd': 'WTD',
  'pages.diagnostics.datePreset.mtd': 'MTD',
  'pages.diagnostics.datePreset.ytd': 'YTD',
  'pages.diagnostics.errorItem.description': ' {username} · Created Time: {createdTime}',
  'pages.files.you': 'You',
  'pages.files.assignAnotherOwnerFirst': 'Please assign another owner first.',
  'pages.files.keepAtLeastOneMember': 'Please keep at least one member.',
  'pages.files.keepAtLeastOneOwner': 'Please keep at least one owner.',
  'pages.files.deletingEllipsis': 'Deleting...',
  'pages.files.failedToDelete': 'Failed to delete',
  'pages.files.dropToUploadCurrentFolder': 'Drop to upload to current folder',
  'pages.files.deleteConfirm.title': 'Delete {count} file(s)?',
  'pages.files.fromPath': 'From: {path}',
  'pages.files.createdAtColumn': 'Created at',
  'pages.files.favoritesTitle': 'Favorites',
  'pages.files.searchFavoritesPlaceholder': 'Search favorites...',
  'pages.files.chatTooltip': 'Chat',
  'pages.files.uploadingEllipsis': 'Uploading...',
  'pages.files.paginationRangeOfTotal': '{start}-{end} of {total}',
  'pages.files.enterNamePlaceholder': 'Enter name',
  'pages.files.deleteConfirm.itemContent': 'Are you sure you want to delete “{name}”?',
  'pages.files.chatWithFolderTooltip': 'Chat with this folder',
  'pages.files.chatWithFileTooltip': 'Chat with this file',
  'pages.files.filePreviewAlt': 'File Preview',
  'pages.files.fileTypeCannotBePreviewed': 'This file type cannot be previewed',
  'pages.files.uploadFilesMenuItem': 'Upload Files',
  'pages.files.uploadFolderMenuItem': 'Upload Folder',
  'pages.files.newFolderButton': 'New Folder',
  'pages.files.sortOption.newestFirst': 'Newest first',
  'pages.files.sortOption.oldestFirst': 'Oldest first',
  'pages.files.sortOption.nameAZ': 'Name A–Z',
  'pages.files.sortOption.nameZA': 'Name Z–A',
  'pages.files.deleteAllFailedFilesConfirm':
    '{count, plural, one {Delete all {count} upload failed file?} other {Delete all {count} upload failed files?}}',
  'pages.files.cleanupButton': 'Cleanup',
  'pages.files.selectButton': 'Select',
  'pages.files.addGroupTitle': 'Add Group',
  'pages.files.editGroupTitle': 'Edit Group',
  'pages.files.groupType.privateGroup': 'Private Group',
  'pages.files.groupType.firmWide': 'Firm Wide',
  'pages.files.groupType.public': 'Public',
  'pages.files.selectGroupTypeRequired': 'Please select a group type.',
  'pages.files.groupNameRequired': 'Please enter a group name.',
  'pages.files.groupNameTaken': 'A group with this name already exists.',
  'pages.files.folderNameTaken': 'A folder with this name already exists.',
  'pages.files.newFolderDisabledTooltip':
    'Folders cannot be created here. Open a group and create the folder inside it.',
  'pages.files.addPersonPlaceholder': 'Add a person',
  'pages.files.noMembersYet': 'No members yet.',
  'pages.files.memberColumn': 'Member',
  'pages.files.roleColumn': 'Role',
  'pages.files.roleOwner': 'Owner',
  'pages.files.roleMember': 'Member',
  'pages.files.revisionHistoryTitle': 'Revision History',
  'pages.files.renamedTo': ' to ',
  'pages.files.noFieldValue': 'No {field}',
  'pages.files.chatWithGroupTooltip': 'Chat with this group',
  'pages.files.searchFilesPlaceholder': 'Search files...',
  'pages.files.historyTitle': 'History',
  'pages.files.addNewButton': 'Add New',
  'pages.files.homeButton': 'Home',
  'pages.files.selectFolderPlaceholder': 'Select folder',
  'pages.files.moveMultipleFilesTitle': 'Move {count} file(s)',
  'pages.files.moveSingleFileTitle': 'Move "{name}"',
  'pages.files.addAtLeastOneMember': 'Please add at least one member.',
  'pages.files.selectAtLeastOneOwner': 'Please select at least one owner.',
  'pages.files.folderWarning.privateGroup': 'Less safe: Visible by your group.',
  'pages.files.folderWarning.firmWide': 'Very unsafe: Visible by your firm.',
  'pages.files.folderWarning.public': 'Very unsafe: Visible by everyone.',
  'pages.files.duplicateFileNameError': 'Duplicate file name. Please rename the file',
  'pages.files.failedToUpdate': 'Failed to update',
  'pages.files.filesDeletedCount': '{count} file(s) deleted',
  'pages.files.filesMovedCount': '{count} file(s) moved',
  'pages.files.failedToDeleteCount': 'Failed to delete {count} file(s)',
  'pages.files.failedToMoveCount': 'Failed to move {count} file(s)',
  'pages.files.filesDeletedCountWithFailures': '{count} file(s) deleted, {failedCount} failed',
  'pages.files.filesMovedCountWithFailures': '{count} file(s) moved, {failedCount} failed',
  'pages.files.failedToDeleteFiles': 'Failed to delete files',
  'pages.files.failedToMoveFiles': 'Failed to move files',
  'pages.files.unnamedFile': 'Unnamed',
  'pages.files.failedToUploadFile': 'Failed to upload {fileName}',
  'pages.files.failedToCreateFolder': 'Failed to create folder: {folderName}',
  'pages.files.someFilesSkippedUnsupportedTypes':
    'Some files were skipped due to unsupported types',
  'pages.files.uploadingFolderEllipsis': 'Uploading folder...',
  'pages.files.folderUploadFailed': 'Folder upload failed',
  'pages.files.allowedFileTypesMessage':
    'Only PDF, DOC, DOCX, MSG, EML, TXT, MD, PPT, PPTX, XLS, XLSX files are supported',
  'pages.library.attachedDocsAccessNote':
    "Access to a prompt's attached documents mirrors access to the prompt itself.",
  'pages.library.functionOption.summarise': 'Summarise',
  'pages.library.functionOption.search': 'Search',
  'pages.library.functionOption.selfInstruct': 'Self instruct',
  'pages.library.functionOption.translate': 'Translate',
  'pages.library.functionOption.transcribe': 'Transcribe',
  'pages.library.functionOption.reviewAnalyse': 'Review/Analyse',
  'pages.library.functionOption.playbook': 'Playbook',
  'pages.library.functionOption.comparison': 'Comparison',
  'pages.library.functionOption.template': 'Template',
  'pages.library.functionOption.review': 'Review',
  'pages.library.functionOption.amend': 'Amend',
  'pages.library.functionOption.redFlagging': 'Red-flagging',
  'pages.library.functionOption.promptlet': 'Promptlet',
  'pages.library.visibilityOption.personal': 'Personal',
  'pages.library.visibilityOption.group': 'Group',
  'pages.library.visibilityOption.firmWide': 'Firm-wide',
  'pages.library.visibilityOption.public': 'Public',
  'pages.library.updateSuccess': 'Updated successfully',
  'pages.library.updateFailed': 'Failed to update',
  'pages.library.copySuccess': 'Prompt copied to clipboard!',
  'pages.library.copyFailed': 'Failed to copy prompt',
  'pages.library.selfInstruction': 'Self-instruction',
  'pages.library.pendingApproval': 'Pending Approval',
  'pages.library.publishPromptModalTitle': 'Publish Prompt',
  'pages.library.publishButton': 'Publish',
  'pages.library.publishRequestSentToAdmin':
    'Your request to publish this prompt has been sent to the admin for approval.',
  'pages.library.publishSuccess': 'Prompt published successfully.',
  'pages.library.publishFailedDefault': 'Failed to submit publish request. Please try again.',
  'pages.library.field.visibility': 'Visibility',
  'pages.library.firmWideVisibilityNote':
    'This prompt will be visible to everyone in your organisation. A request will be sent to the organisation admin for approval.',
  'pages.library.publicVisibilityNote':
    'This prompt will be visible to all users. A request will be sent to the super admin for approval.',
  'pages.library.pendingApprovalNote':
    'A publish request is pending approval. Firm-wide and Public are unavailable until the request is approved or rejected.',
  'pages.library.cloneButton': 'Clone',
  'pages.library.chatWithPromptButton': 'Chat with this prompt',
  'pages.library.enterPromptNamePlaceholder': 'Enter prompt name',
  'pages.library.field.purpose': 'Purpose',
  'pages.library.enterPurposePlaceholder': 'Enter purpose',
  'pages.library.field.notes': 'Notes',
  'pages.library.enterNotesPlaceholder': 'Enter notes',
  'pages.library.field.author': 'Author',
  'pages.library.allowSelfInstruction': 'Allow self-instruction',
  'pages.library.attachedDocuments': 'Add additional context',
  'pages.library.addTemplate': 'Add Template',
  'pages.library.documentsCount': '{count} document(s)',
  'pages.library.field.prompt': 'Prompt',
  'pages.library.enterPromptContentPlaceholder': 'Enter prompt content',
  'pages.library.noPromptsSelected': 'No prompts selected',
  'pages.library.promptClonedSuccess': 'Prompt cloned successfully',
  'pages.library.cloneAuthorLabel': 'Author: {author}',
  'pages.library.cloneAudienceLabel': 'Audience: {visibility}',
  'pages.library.undoChangesButton': 'Undo Changes',
  'pages.library.saveChangesButton': 'Save Changes',
  'pages.library.unsavedChangesTitle': 'Unsaved changes',
  'pages.library.unsavedChangesContent': 'You have unsaved changes. Are you sure you want to exit?',
  'pages.library.exitModifyButton': 'Exit Modify',
  'pages.library.field.tags': 'Tags',
  'pages.library.title': 'Prompt Library',
  'pages.library.description':
    'A structured collection of pre-designed prompts used to guide or optimize interactions with AI language models. It serves as a centralized repository where prompts are organized by purpose, task, or domain—such as writing, coding, data analysis, or creative generation.',
  'pages.library.exitCompareButton': 'Exit Compare',
  'pages.library.compareButton': 'Compare',
  'pages.library.addPromptModalTitle': 'Add Prompt',
  'pages.library.clonePromptModalTitle': 'Clone Prompt',
  'pages.library.addButton': 'Add +',
  'pages.library.tagsPlaceholder': 'List of tags',
  'pages.library.filterByFunctionPlaceholder': 'Filter by function',
  'pages.library.filterByAudiencePlaceholder': 'Filter by audience',
  'pages.library.searchPlaceholder': 'Search prompt and tags',
  'pages.library.favoriteOnly': 'Favorite only',
  'pages.library.filterByLabel': 'Filter by:',
  'pages.library.compareSelectHint': 'Select two/three prompts you’d like to compare',
  'pages.library.untitledPrompt': 'Untitled Prompt',
  'pages.library.compareLimitWarning': 'You can only compare up to 3 prompts',
  'pages.library.copyPromptButton': 'Copy prompt',
  'pages.organisation.idColumnTitle': 'ID',
  'pages.organisation.untitledOrganisationFallback': 'Untitled Organisation',
  'pages.organisation.userLimitLabel': 'User Limit',
  'pages.organisation.userLimitUnlimitedCount': '{count} / Unlimited',
  'pages.organisation.userLimitUnlimited': 'Unlimited',
  'pages.organisation.userLimitOnly': 'Limit: {limit}',
  'pages.organisation.msTenantIdsLabel': 'MS Tenant IDs',
  'pages.organisation.organisationsTableHeaderTitle': 'Organisations',
  'pages.organisation.createOrganisationLabel': 'Create Organisation',
  'pages.organisation.usersTableHeaderTitle': '{orgName} Users',
  'pages.organisation.defaultOrganisationName': 'Organisation',
  'pages.organisation.userLimitReachedTooltip': 'User limit reached',
  'pages.organisation.addUserButtonLabel': 'Add User',
  'pages.organisation.usernameColumnTitle': 'Username',
  'pages.organisation.emailColumnTitle': 'Email',
  'pages.organisation.roleLabel': 'Role',
  'pages.organisation.defaultUserRoleLabel': 'User',
  'pages.organisation.changeRoleButtonLabel': 'Change Role',
  'pages.organisation.removeUserConfirmTitle': 'Remove user from organisation?',
  'pages.organisation.userRemovedSuccessMessage': 'User removed',
  'pages.organisation.unableToRemoveUserErrorMessage': 'Unable to remove user',
  'pages.organisation.editOrganisationModalTitle': 'Edit Organisation',
  'pages.organisation.organisationUpdatedSuccessMessage': 'Organisation updated successfully',
  'pages.organisation.organisationCreatedSuccessMessage': 'Organisation created successfully',
  'pages.organisation.organisationNameRequiredMessage': 'Organisation name is required',
  'pages.organisation.organisationNameLabel': 'Organisation Name',
  'pages.organisation.userLimitTooltip':
    'Maximum number of users allowed. Leave empty for unlimited.',
  'pages.organisation.msTenantIdsTooltip':
    'Users from these Microsoft tenant IDs can log in via SSO.',
  'pages.organisation.userEmailLabel': 'User Email',
  'pages.organisation.userEmailPlaceholder': 'user@company.com',
  'pages.organisation.emailRequiredMessage': 'Email is required',
  'pages.organisation.roleRequiredMessage': 'Role is required',
  'pages.organisation.userAddedSuccessMessage': 'User added',
  'pages.organisation.unableToAddUserErrorMessage': 'Unable to add user',
  'pages.organisation.roleUpdatedSuccessMessage': 'Role updated',
  'pages.organisation.unableToUpdateRoleErrorMessage': 'Unable to update role',
  'pages.organisation.unableToLoadRolesErrorMessage': 'Unable to load roles',
  'pages.playbook.header.title': 'Workstudio',
  'pages.playbook.emptyState.title': 'Ready when you are.',
  'pages.playbook.emptyState.description':
    'Ask for a rewrite, clause review, summary, or a targeted amendment.',
  'pages.playbook.checkingDocument': 'Checking the document...',
  'pages.playbook.updatingReviewCanvas': 'Updating the review canvas...',
  'pages.playbook.inputPlaceholder': 'Tell A&GEL what to change...',
  'pages.playbook.inputAriaLabel': 'Workstudio instruction',
  'pages.playbook.contextButton': 'Context',
  'pages.playbook.sendButtonAriaLabel': 'Send Workstudio instruction',
  'pages.playbook.sendInstructionError': 'Failed to send your Workstudio instruction',
  'pages.projectsHub.func.chat': 'Chat',
  'pages.projectsHub.func.scribe': 'Scribe',
  'pages.projectsHub.func.apps': 'Apps',
  'pages.projectsHub.func.review': 'Review',
  'pages.projectsHub.func.sideBySide': 'Side by Side',
  'pages.projectsHub.func.comparison': 'Comparison',
  'pages.projectsHub.func.translation': 'Translation',
  'pages.projectsHub.func.template': 'Custom Output',
  'pages.projectsHub.func.quote': 'Quote',
  'pages.projectsHub.untitledSession': 'Untitled',
  'pages.projectsHub.untitledFileLabel': '(Untitled)',
  'pages.projectsHub.errors.loadDataFailed': 'Failed to load data',
  'pages.projectsHub.subfolderCreated': 'Subfolder created',
  'pages.projectsHub.collectionCreated': 'Collection created',
  'pages.projectsHub.errors.createFailed': 'Failed to create',
  'pages.projectsHub.errors.updateFailed': 'Failed to update',
  'pages.projectsHub.deleteCollectionConfirm.title': 'Delete Collection',
  'pages.projectsHub.deleteCollectionConfirm.content': 'Delete "{name}"?',
  'pages.projectsHub.collectionDeleted': 'Deleted',
  'pages.projectsHub.errors.deleteFailed': 'Failed',
  'pages.projectsHub.sessionsAdded': '{count} session(s) added',
  'pages.projectsHub.errors.addSessionsFailed': 'Failed to add',
  'pages.projectsHub.sessionRemoved': 'Session removed',
  'pages.projectsHub.errors.removeSessionFailed': 'Failed to remove session',
  'pages.projectsHub.sessionsRemoved': '{count} session(s) removed',
  'pages.projectsHub.errors.removeSessionsFailed': 'Failed to remove sessions',
  'pages.projectsHub.fieldSaved': 'Saved',
  'pages.projectsHub.errors.saveFieldFailed': 'Failed to save',
  'pages.projectsHub.folderDeleted': 'Folder deleted',
  'pages.projectsHub.errors.deleteFolderFailed': 'Failed to delete folder',
  'pages.projectsHub.folderCreated': 'Folder created',
  'pages.projectsHub.errors.createFolderFailed': 'Failed to create folder',
  'pages.projectsHub.deleteFolderConfirm.description': 'Delete "{name}" and all its contents?',
  'pages.projectsHub.deleteSessionsConfirm.title': 'Delete Sessions',
  'pages.projectsHub.deleteSessionsConfirm.description':
    'Remove {count} session(s) from this collection?',
  'pages.projectsHub.removeSessionConfirm.title': 'Remove Session',
  'pages.projectsHub.removeSessionConfirm.description': 'Remove "{name}" from this collection?',
  'pages.projectsHub.sort.newestFirst': 'Newest first',
  'pages.projectsHub.sort.oldestFirst': 'Oldest first',
  'pages.projectsHub.sort.nameAsc': 'Name (A-Z)',
  'pages.projectsHub.sort.nameDesc': 'Name (Z-A)',
  'pages.projectsHub.doubleClickToOpen': 'Double-click to open',
  'pages.projectsHub.tidyUp': 'Tidy up',
  'pages.projectsHub.exit': 'Exit',
  'pages.projectsHub.manage': 'Manage',
  'pages.projectsHub.deleteSessionsButton': 'Delete ({count})',
  'pages.projectsHub.searchSessionsPlaceholder': 'Search sessions',
  'pages.projectsHub.emptyState.noFiles': 'No files',
  'pages.projectsHub.newFolderButton': 'New Folder',
  'pages.projectsHub.addSessionsButton': 'Add Sessions',
  'pages.projectsHub.folderInfoLabel': 'Folder Info',
  'pages.projectsHub.mattersHeading': 'Matters',
  'pages.projectsHub.mattersSubtitle':
    'Create collections and organise sessions from different functions in one workspace.',
  'pages.projectsHub.hubBreadcrumbLabel': 'Hub',
  'pages.projectsHub.deleteFolderButton': 'Delete Folder',
  'pages.projectsHub.itemsLabel': 'Items',
  'pages.projectsHub.selectSubfolderEmptyState': 'Select a subfolder to view details',
  'pages.projectsHub.selectFolderEmptyState': 'Select a folder to view details',
  'pages.projectsHub.noCollectionsMatch': 'No collections match your current filter.',
  'pages.projectsHub.noSessionsFoundForFunction': 'No {func} sessions found.',
  'pages.projectsHub.addSelectedSessionsButton':
    'Add {count, plural, =0 {selected} other {# session(s)}}',
  'pages.projectsHub.step1ChooseFunctionType': 'Step 1 — Choose a function type',
  'pages.projectsHub.selectFunctionPlaceholder': 'Select function',
  'pages.projectsHub.step2SelectSessions': 'Step 2 — Select sessions to add',
  'pages.projectsHub.createFolderButton': 'Create Folder',
  'pages.projectsHub.folderNameLabel': 'Folder name',
  'pages.projectsHub.subfolderNamePlaceholder': 'e.g. Due Diligence',
  'pages.projectsHub.collectionNamePlaceholder': 'e.g. M&A Due Diligence',
  'pages.projectsHub.optionalDescriptionPlaceholder': 'Optional description',
  'pages.projectsHub.optionalNotesPlaceholder': 'Optional notes',
  'pages.projectsHub.createCollectionModalTitle': 'Create Collection',
  'pages.projectsHub.collectionNameLabel': 'Collection name',
  'pages.projectsHub.editCollectionModalTitle': 'Edit • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, one {# item} other {# items}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, one {# file} other {# files}}',
  'pages.quote.historyTooltip': 'History (Tab+H)',
  'pages.quote.hideTooltip': 'Hide (Tab+H)',
  'pages.quote.newQuoteTooltip': 'New quote (Tab+N)',
  'pages.quote.untitled': '(Untitled)',
  'pages.quote.newQuote': 'New Quote',
  'pages.quote.deletedExample': 'Deleted example',
  'pages.quote.generateDescription': 'Generate quotations based on your template and facts',
  'pages.quote.sizeLabel': 'Size',
  'pages.quote.sizeShort': 'Short',
  'pages.quote.sizeMedium': 'Medium',
  'pages.quote.sizeLong': 'Long',
  'pages.quote.examplesLabel': 'Examples',
  'pages.quote.promptLabel': 'Prompt',
  'pages.quote.examplesTitle': 'Examples',
  'pages.quote.quoteTitle': 'Quote',
  'pages.quote.uploadManageExamples': 'Upload / Manage examples',
  'pages.quote.generateQuoteSubtitle': 'Generate quote',
  'pages.quote.fileLabel': 'File',
  'pages.quote.deleteConfirmTitle': 'Are you sure to delete the following example?',
  'pages.review.addAtLeastOneQuestion': 'Please add at least one question before submitting.',
  'pages.review.addAtLeastOneQuestionFirst': 'Please add at least one question first.',
  'pages.review.addAtLeastOneQuestionRule': 'Please add at least one question',
  'pages.review.addQuestionButton': 'Question',
  'pages.review.addSectionButton': 'Section',
  'pages.review.addToMatters': 'Add to Matters',
  'pages.review.adhocModifyMode': 'Ad-hoc Modify',
  'pages.review.audiencePlaceholder': 'name of client or target audience',
  'pages.review.authorLabel': 'Author',
  'pages.review.categoryLabel': 'Category',
  'pages.review.cellDetailsDrawer.addCommentPlaceholder': 'Add a comment...',
  'pages.review.cellDetailsDrawer.answer': 'Answer',
  'pages.review.cellDetailsDrawer.comments': 'Comments',
  'pages.review.cellDetailsDrawer.commentsWithCount': 'Comments ({count})',
  'pages.review.cellDetailsDrawer.exactMatch': 'Exact match found in source document',
  'pages.review.cellDetailsDrawer.explanation': 'Explanation',
  'pages.review.cellDetailsDrawer.fullReference': 'Full Reference',
  'pages.review.cellDetailsDrawer.fuzzyMatch': 'Approximate match found in source document',
  'pages.review.cellDetailsDrawer.openDocument': 'Open document',
  'pages.review.cellDetailsDrawer.openInSearch': 'Open in Search',
  'pages.review.cellDetailsDrawer.verified': 'Verified',
  'pages.review.cellDetailsDrawer.verify': 'Verify',
  'pages.review.cellMarkedUnverified': 'Cell marked as unverified',
  'pages.review.cellMarkedVerified': 'Cell marked as verified',
  'pages.review.cellUpdateFailed': 'Failed to update cell',
  'pages.review.cellUpdatedSuccessfully': 'Cell updated successfully',
  'pages.review.cellVerificationUpdateFailed': 'Failed to update cell verification',
  'pages.review.changesUndone': 'Changes undone',
  'pages.review.chatWithEntireOutput': 'Chat with Entire Output',
  'pages.review.cloneButton': 'Clone',
  'pages.review.clonedNamePrefix': 'CLONED - {name}',
  'pages.review.columnEditModal.addTitle': 'Add New Document (Column)',
  'pages.review.columnEditModal.columnUpdated':
    'Column update(s) started. The column will refresh shortly.',
  'pages.review.columnEditModal.columnsAdded':
    'New column(s) added. The matrix will refresh shortly.',
  'pages.review.columnEditModal.dropToUpload': 'Drop file here to upload',
  'pages.review.columnEditModal.fileRequired':
    'Please upload or select a file to use for this column.',
  'pages.review.columnEditModal.filesRequiredValidation':
    'Please upload files or select existing files',
  'pages.review.columnEditModal.updateFailed': 'Failed to update column',
  'pages.review.columnEditModal.updateTitle': 'New document for this column',
  'pages.review.createQuestionListButton': 'Create Question List',
  'pages.review.createdByYou': 'You',
  'pages.review.customInstruction': 'Custom Instruction',
  'pages.review.customInstructionOptional': 'Custom Instruction (optional)',
  'pages.review.deleteQuestionListConfirm': 'Are you sure you want to delete this question list?',
  'pages.review.downloadExcel': 'Excel (.xlsx)',
  'pages.review.downloadWord': 'Word (.docx)',
  'pages.review.dragHereToUpload': 'Drag here to upload',
  'pages.review.exitButton': 'Exit',
  'pages.review.exitClone': 'Exit Clone',
  'pages.review.exitCreate': 'Exit Create',
  'pages.review.exitModify': 'Exit Modify',
  'pages.review.fileCount': '{count} File(s)',
  'pages.review.mattersUpdateFailed': 'Failed to update matters',
  'pages.review.mattersUpdated': 'Matters updated successfully',
  'pages.review.modifyButton': 'Modify',
  'pages.review.newCategoryPlaceholder': 'New category',
  'pages.review.newQuestionListDefaultName': 'New Review Question List',
  'pages.review.noEmailOnFile': 'No email on file',
  'pages.review.noNotesAvailable': 'No notes available.',
  'pages.review.noPrivateGroupsFound': 'No private groups found',
  'pages.review.noPurposeAvailable': 'No purpose available.',
  'pages.review.noQuestionsYet': 'No questions yet.',
  'pages.review.notesLabel': 'Notes',
  'pages.review.pendingApproval': 'Pending Approval',
  'pages.review.pollingTimeout': 'Polling timeout. The review may still be processing.',
  'pages.review.publishButton': 'Publish',
  'pages.review.publishFailed': 'Failed to publish question list',
  'pages.review.publishTargetFirm': 'Firm-wide',
  'pages.review.publishToLabel': 'Publish to:',
  'pages.review.publishedAccess.firm': 'Firm',
  'pages.review.publishedAccess.privateGroup': 'Private group',
  'pages.review.publishedAccess.public': 'Public',
  'pages.review.publishedToLabel': 'Published to {access}',
  'pages.review.publishedToPrivateGroup': 'Question list published to private group',
  'pages.review.publishedToPrivateGroups': 'Question list published to private groups',
  'pages.review.purposeLabel': 'Purpose',
  'pages.review.questionListCloned': 'Question list cloned successfully',
  'pages.review.questionListCreated': 'Question list created successfully',
  'pages.review.questionListDeleted': 'Question list deleted successfully',
  'pages.review.questionListImporter.allColumns': 'All columns (join every cell)',
  'pages.review.questionListImporter.checklistText': 'Checklist text',
  'pages.review.questionListImporter.checklistTextPlaceholder':
    'Paste a checklist here, one requirement per line.',
  'pages.review.questionListImporter.columnOption': 'Column {index} - {label}',
  'pages.review.questionListImporter.couldNotParse': 'Could not parse the checklist.',
  'pages.review.questionListImporter.couldNotReadFile': 'Could not read {fileName}.',
  'pages.review.questionListImporter.docxColumn': 'DOCX column',
  'pages.review.questionListImporter.dropZoneHint':
    'DOCX, PDF, EML, MSG, TXT, or MD. Files stay local.',
  'pages.review.questionListImporter.dropZoneText': 'Click or drag a checklist to this area',
  'pages.review.questionListImporter.granularityEveryLine': 'Every line a question',
  'pages.review.questionListImporter.granularityLevel2': 'Down to level 2',
  'pages.review.questionListImporter.granularityLevel3': 'Down to level 3',
  'pages.review.questionListImporter.granularityLevel4': 'Down to level 4',
  'pages.review.questionListImporter.granularityLevel5': 'Down to level 5',
  'pages.review.questionListImporter.granularityTopLevel': 'Top level only',
  'pages.review.questionListImporter.groupByLevel': 'Group questions by level',
  'pages.review.questionListImporter.importQuestions': 'Import Questions',
  'pages.review.questionListImporter.importQuestionsAction': 'Import questions',
  'pages.review.questionListImporter.loadedFile': 'Loaded {fileName}',
  'pages.review.questionListImporter.noQuestionsDetected':
    'No questions were detected in the checklist.',
  'pages.review.questionListImporter.noQuestionsSelected': 'No questions selected for import.',
  'pages.review.questionListImporter.pasteOrSelectRequired':
    'Paste or select a checklist before previewing.',
  'pages.review.questionListImporter.previewQuestions': 'Preview questions',
  'pages.review.questionListImporter.questionGranularity': 'Question granularity',
  'pages.review.questionListImporter.questionsReadyCount':
    '{count, plural, one {# question} other {# questions}} ready',
  'pages.review.questionListImporter.readingChecklist': 'Reading checklist...',
  'pages.review.questionListImporter.removeFile': 'Remove file',
  'pages.review.questionListImporter.removeQuestion': 'Remove question {number}',
  'pages.review.questionListImporter.removeQuestionsHint':
    'Remove any questions you do not want to import.',
  'pages.review.questionListImporter.reviewQuestions': 'Review Questions',
  'pages.review.questionListNamePlaceholder': 'Review Question List Name',
  'pages.review.questionListUpdated': 'Question list updated successfully',
  'pages.review.questionNamePlaceholder': 'Question',
  'pages.review.questionRow.dragToReorder': 'Drag to reorder',
  'pages.review.questionRow.moveDown': 'Move down',
  'pages.review.questionRow.moveUp': 'Move up',
  'pages.review.questionRow.rowType': 'Row type',
  'pages.review.questionsList': 'Questions List',
  'pages.review.quickQuestionsDescription':
    'Generate structured reviews of one or more documents based on a set of ad-hoc questions',
  'pages.review.quickQuestionsHeading': 'Quick Questions',
  'pages.review.rejected': 'Rejected',
  'pages.review.resizeHint': 'Drag borders to resize.',
  'pages.review.restoreConfigFailed': 'Failed to restore configuration. Please try again.',
  'pages.review.resultPanel.processing': 'Processing',
  'pages.review.resultPanel.stopped': 'Processing stopped.',
  'pages.review.reuseButton': 'Re-use',
  'pages.review.rowEditModal.addTitle': 'Add New Question (Row)',
  'pages.review.rowEditModal.promptLabel': 'Prompt',
  'pages.review.rowEditModal.promptRequired': 'Please enter a prompt.',
  'pages.review.rowEditModal.rowAdded': 'New row added. The matrix will refresh shortly.',
  'pages.review.rowEditModal.rowUpdated': 'Row update started. The row will refresh shortly.',
  'pages.review.rowEditModal.updateFailed': 'Failed to update row',
  'pages.review.rowEditModal.updateTitle': 'Update Question Prompt',
  'pages.review.saveAsButton': 'Save As',
  'pages.review.saveChangesButton': 'Save Changes',
  'pages.review.searchMattersPlaceholder': 'Search matters...',
  'pages.review.sectionNamePlaceholder': 'Section header',
  'pages.review.selectCellHint': 'Click a cell, row, or column to select it.',
  'pages.review.selectDocumentsToReview': 'Select the document(s) you wish to perform a review on',
  'pages.review.selectDocumentsToReviewNumbered':
    '2. Select the document(s) you wish to perform a review on',
  'pages.review.selectMatters': 'Select matter(s):',
  'pages.review.selectPrivateGroupsHint': 'Select one or more private groups to share with:',
  'pages.review.selectPrivateGroupsPlaceholder': 'Select private groups',
  'pages.review.sentForApproval': 'Question list sent for approval',
  'pages.review.sentimentLegendPrefix': "Legend: AI's sentiment:",
  'pages.review.sentimentNegative': 'negative',
  'pages.review.sentimentPositive': 'positive',
  'pages.review.showAll': 'Show all',
  'pages.review.startNewReview': 'Start a new Review',
  'pages.review.stayButton': 'Stay',
  'pages.review.submitReviewFailed': 'Failed to submit review',
  'pages.review.systemPromptLabel': 'System Prompt',
  'pages.review.tabs.customiseOptional': 'Customise (Optional)',
  'pages.review.tabs.prompts': 'Prompts',
  'pages.review.tabs.selectDocuments': 'Select Documents',
  'pages.review.tabs.startHere': 'Start here',
  'pages.review.typeHerePlaceholder': 'Type here...',
  'pages.review.undoChangesButton': 'Undo Changes',
  'pages.review.unsavedChangesWillBeLost': 'Any unsaved changes will be lost.',
  'pages.review.untitledSession': '(Untitled)',
  'pages.review.updateFailed': 'Failed to update',
  'pages.review.viewMode': 'View',
  'pages.review.whatsNewDescription':
    'Introduced several new features to enhance your document review process.',
  'pages.review.whoIsItFor': 'Who is it for?',
  'pages.review.whoIsItForNumbered': '1. Who is it for?',
  'pages.scribe.addToMatters': 'Add to Matters',
  'pages.scribe.aiWorking': 'AI is working...',
  'pages.scribe.appDescription': 'Transcribe audio files or recordings into structured text.',
  'pages.scribe.audioUploadFailedSavingOnly': 'Failed to upload audio file, saving transcript only',
  'pages.scribe.audioUploadSuccess': 'Audio file uploaded successfully',
  'pages.scribe.autoDetect': 'Auto-detect',
  'pages.scribe.autoGenerateFailed': 'Failed to auto-generate selected outputs',
  'pages.scribe.autoRecordingName': 'Recording {timestamp}',
  'pages.scribe.autoSavedNote': 'Auto-saved {relative} ({time})',
  'pages.scribe.convertingEllipsis': 'Converting...',
  'pages.scribe.customLanguageFallback': 'Custom',
  'pages.scribe.deleteConfirm.content': 'Are you sure you want to delete this transcript?',
  'pages.scribe.deleteConfirm.title': 'Delete Transcript',
  'pages.scribe.deleteTranscriptFailed': 'Failed to delete transcript',
  'pages.scribe.discardChangesConfirm.cancelText': 'Keep editing',
  'pages.scribe.discardChangesConfirm.content': 'You have unsaved edits. Discard them?',
  'pages.scribe.discardChangesConfirm.okText': 'Discard',
  'pages.scribe.discardChangesConfirm.title': 'Discard changes?',
  'pages.scribe.downloadAudio': 'Download Audio',
  'pages.scribe.downloadFailed': 'Download failed',
  'pages.scribe.downloadScript': 'Download Script',
  'pages.scribe.downloadStarted': 'Download started',
  'pages.scribe.downloadingAudio': 'Downloading audio...',
  'pages.scribe.enterTranscriptNamePlaceholder': 'Enter transcript name',
  'pages.scribe.errors.authTokenFailed': 'Failed to get authentication token',
  'pages.scribe.errors.startRecordingFailed': 'Failed to start recording',
  'pages.scribe.exitRecordingConfirm.cancelText': 'Continue recording',
  'pages.scribe.exitRecordingConfirm.content': 'Transcript will not be saved.',
  'pages.scribe.exitRecordingConfirm.okText': 'Exit recording',
  'pages.scribe.exitRecordingConfirm.title': 'Exit recording?',
  'pages.scribe.exitRecordingPopconfirm.description':
    'Exit recording? Transcript will not be saved.',
  'pages.scribe.fastForward10': 'Fast forward 10 seconds',
  'pages.scribe.fileUploadFailed': '{fileName} file upload failed.',
  'pages.scribe.fileUploadSuccess': 'File uploaded successfully. Processing started.',
  'pages.scribe.generateButton': 'Generate',
  'pages.scribe.generationFailedRetryText': 'Generation failed. Please try regenerating.',
  'pages.scribe.generationStarted': 'Generation started',
  'pages.scribe.historyButton': 'History',
  'pages.scribe.homeButton': 'Home',
  'pages.scribe.initializingTranscription': 'Initializing transcription...',
  'pages.scribe.interruptedModal.content':
    'Your recording was interrupted because the connection was lost (e.g. your device went to sleep). Click "View transcript" to save what was captured.',
  'pages.scribe.interruptedModal.okText': 'View transcript',
  'pages.scribe.interruptedModal.title': 'Recording interrupted',
  'pages.scribe.langGroup.custom': 'Custom',
  'pages.scribe.langGroup.everythingElse': 'Everything else',
  'pages.scribe.langGroup.otherOption': 'Other…',
  'pages.scribe.langGroup.preferred': 'Preferred',
  'pages.scribe.langGroup.seaEastAsian': 'SEA + East Asian',
  'pages.scribe.languageSelector.addLanguageButton': 'Add language',
  'pages.scribe.languageSelector.customPlaceholder': 'Type language (e.g. Malay)',
  'pages.scribe.liveTranslationLabel': 'Live Translation',
  'pages.scribe.loadingAudio': 'Loading audio...',
  'pages.scribe.mattersUpdatedSuccess': 'Matters updated successfully',
  'pages.scribe.modeNotGenerated': '{modeLabel} has not been generated',
  'pages.scribe.nameYourTranscriptPlaceholder': 'Name your transcript',
  'pages.scribe.newRecordingTitle': 'New recording',
  'pages.scribe.newTranscript': 'New Transcript',
  'pages.scribe.newTranscriptName': 'New Transcript {timestamp}',
  'pages.scribe.noAudioFileAvailable': 'No audio file available.',
  'pages.scribe.noAudioForDownload': 'No audio file available for download.',
  'pages.scribe.noContentAvailable': 'No content available. Please regenerate.',
  'pages.scribe.noOutputsGenerated': 'No outputs were generated',
  'pages.scribe.noRecentRecordings': 'No recent recordings yet.',
  'pages.scribe.noSegmentsToEdit': 'No segments available to edit',
  'pages.scribe.noTimestampedSegments': 'No transcript segments with timestamps available.',
  'pages.scribe.notAvailable': 'N/A',
  'pages.scribe.optionEmailDrafts': 'Email Drafts',
  'pages.scribe.outputNotGeneratedYet': 'This output has not been generated yet.',
  'pages.scribe.outputViewer.actionItemsLabel': 'Action Items',
  'pages.scribe.outputViewer.addActionItemButton': 'Add Action Item',
  'pages.scribe.outputViewer.columnAction': 'Action',
  'pages.scribe.outputViewer.columnAssignee': 'Assignee',
  'pages.scribe.outputViewer.columnDueDate': 'Due Date',
  'pages.scribe.outputViewer.columnTask': 'Task',
  'pages.scribe.outputViewer.commaSeparatedNamesPlaceholder': 'Comma separated names',
  'pages.scribe.outputViewer.fieldBody': 'Body',
  'pages.scribe.outputViewer.fieldCategory': 'Category',
  'pages.scribe.outputViewer.fieldCleanedTranscript': 'Cleaned Transcript',
  'pages.scribe.outputViewer.fieldExecutiveSummary': 'Executive Summary',
  'pages.scribe.outputViewer.fieldGeneratedTitle': 'Generated Title',
  'pages.scribe.outputViewer.fieldKeyDecisions': 'Key Decisions',
  'pages.scribe.outputViewer.fieldNextMeeting': 'Next Meeting',
  'pages.scribe.outputViewer.fieldParticipants': 'Participants',
  'pages.scribe.outputViewer.fieldRecipients': 'Recipients',
  'pages.scribe.outputViewer.fieldSignatureBlock': 'Signature Block',
  'pages.scribe.outputViewer.fieldSubject': 'Subject',
  'pages.scribe.outputViewer.fieldTopic': 'Topic',
  'pages.scribe.outputViewer.generatingContent': 'Generating content...',
  'pages.scribe.outputViewer.generationFailed': 'Generation Failed',
  'pages.scribe.outputViewer.onePerLinePlaceholder': 'One per line',
  'pages.scribe.outputViewer.pleaseCheckFields': 'Please check the fields',
  'pages.scribe.outputViewer.titleDefault': 'Output',
  'pages.scribe.outputViewer.titleEmailDraft': 'Email Draft',
  'pages.scribe.outputViewer.titleMeetingNotes': 'Meeting Notes',
  'pages.scribe.outputViewer.titleVoiceMemo': 'Voice Memo',
  'pages.scribe.outputViewer.unknownOutputType': 'Unknown output type',
  'pages.scribe.pauseRecordingTitle': 'Pause Recording',
  'pages.scribe.recentRecordingsTitle': 'Recent recordings',
  'pages.scribe.recentlyTranscribed': 'Recently Transcribed',
  'pages.scribe.recordingInProgressWarning':
    'You are currently in a recording. Please stop recording before switching sessions',
  'pages.scribe.recordingMicOnlyNote':
    'Recording captures audio from your microphone only — not your speaker. To transcribe audio playing on your computer, use a separate device or upload a recording.',
  'pages.scribe.recordingPaused': 'Recording Paused',
  'pages.scribe.recordingPausedInline': 'Recording paused',
  'pages.scribe.regenerateButton': 'Regenerate',
  'pages.scribe.resumeRecordingTitle': 'Resume Recording',
  'pages.scribe.retranslatingSegments': 'Re-translating edited segments...',
  'pages.scribe.fillingMissingTranslations': 'Translating missing segments...',
  'pages.scribe.rewind10': 'Rewind 10 seconds',
  'pages.scribe.saveEditsFailed': 'Failed to save transcript edits',
  'pages.scribe.saveFailed': 'Failed to save',
  'pages.scribe.saveTranscriptFailed': 'Failed to save transcript',
  'pages.scribe.saveTranscriptModalTitle': 'Save transcript',
  'pages.scribe.saveTranscriptTitle': 'Save Transcript',
  'pages.scribe.savedSuccessfully': 'Saved successfully',
  'pages.scribe.savingTranscript': 'Saving transcript...',
  'pages.scribe.scribeTitle': 'Scribe',
  'pages.scribe.scrollToBottom': 'Scroll to bottom',
  'pages.scribe.searchMattersPlaceholder': 'Search matters...',
  'pages.scribe.searchTranscriptsPlaceholder': 'Search transcripts',
  'pages.scribe.segmentTranslationFailed': 'Segment translation failed',
  'pages.scribe.selectMattersLabel': 'Select matter(s):',
  'pages.scribe.startGenerationFailed': 'Failed to start generation',
  'pages.scribe.startTranscriptionFailed': 'Failed to start transcription process',
  'pages.scribe.status.clickMicToStart': 'Click mic to start recording',
  'pages.scribe.status.defaultDescription':
    'Transcribe audio files or recordings into structured text',
  'pages.scribe.status.processingFile': 'Processing file... {stage}',
  'pages.scribe.status.queued': 'Queued',
  'pages.scribe.status.transcriptionCancelled': 'Transcription cancelled',
  'pages.scribe.status.transcriptionCompleted': 'Transcription completed',
  'pages.scribe.status.transcriptionFailed': 'Transcription failed',
  'pages.scribe.stopRecordingConfirm.cancelText': 'Stay',
  'pages.scribe.stopRecordingConfirm.content':
    'You have an active recording. Leaving this page will stop the recording. Do you want to continue?',
  'pages.scribe.stopRecordingConfirm.okText': 'Leave Page',
  'pages.scribe.stopRecordingConfirm.title': 'Stop Recording?',
  'pages.scribe.stopRecordingSaveTitle': 'Stop Recording and Save',
  'pages.scribe.tabs.emailDraft': 'Email draft',
  'pages.scribe.tabs.meetingNotes': 'Meeting Notes',
  'pages.scribe.tabs.rawTranscript': 'Raw Transcript',
  'pages.scribe.tabs.voiceMemo': 'Voice Memo',
  'pages.scribe.transcriptDeleted': 'Transcript deleted',
  'pages.scribe.transcriptEmpty': 'Transcript is empty',
  'pages.scribe.transcriptNameUpdated': 'Transcript name updated',
  'pages.scribe.transcriptSavedSuccess': 'Transcript saved successfully',
  'pages.scribe.transcriptUpdated': 'Transcript updated',
  'pages.scribe.transcriptionFailedDesc':
    'Scribe failed to transcribe this audio. Try downloading the audio file and uploading it again.',
  'pages.scribe.transcriptionFailedTitle': 'Transcription Failed',
  'pages.scribe.transcriptionLanguageQuestion': 'What language should transcription use?',
  'pages.scribe.transcriptionPurposeQuestion':
    'What is this transcription intended to be used for?',
  'pages.scribe.translatingEllipsis': 'Translating...',
  'pages.scribe.increaseTranslationSize': 'Increase translated text size',
  'pages.scribe.decreaseTranslationSize': 'Decrease translated text size',
  'pages.scribe.translationTextSize': 'Translation Text Size',
  'pages.scribe.unassigned': 'Unassigned',
  'pages.scribe.unnamedTranscript': 'Unnamed Transcript',
  'pages.scribe.untitled': 'Untitled',
  'pages.scribe.untitledParens': '(Untitled)',
  'pages.scribe.untitledTranscript': 'Untitled Transcript',
  'pages.scribe.updateMattersFailed': 'Failed to update matters',
  'pages.scribe.updateNameFailed': 'Failed to update transcript name',
  'pages.scribe.updateTranscriptNameTitle': 'Update Transcript Name',
  'pages.scribe.uploadRecordingButton': 'Upload Recording',
  'pages.scribe.uploadingAudioFile': 'Uploading audio file...',
  'pages.scribe.waitingEllipsis': 'Waiting...',
  'pages.scribe.waitingForTranslations': 'Waiting for translations to complete...',
  'pages.scribe.whatsNew': "What's New",
  'pages.scribe.whatsNew.filteringSortingDesc':
    'Improved UI for managing and finding your transcripts.',
  'pages.scribe.whatsNew.filteringSortingLabel': 'Filtering & Sorting:',
  'pages.scribe.whatsNew.guidanceTabsDesc':
    'Easily find instructions on how to begin or discover new features.',
  'pages.scribe.whatsNew.guidanceTabsLabel': 'Guidance Tabs:',
  'pages.scribe.whatsNew.intro':
    "We've enhanced Scribe to provide a more seamless transcription experience:",
  'pages.scribe.whatsNew.upcomingFeaturesDesc':
    'Stay tuned for deeper multilingual controls and advanced structured output formats.',
  'pages.scribe.whatsNew.upcomingFeaturesTitle': 'Upcoming Features',
  'pages.search.chunkCopiedSuccess': 'Chunk copied!',
  'pages.search.chunkCopyFailed': 'Failed to copy chunk',
  'pages.search.searchRatioLabel': 'Search Ratio',
  'pages.search.favouriteFileWeightLabel': 'Favourite File Weight',
  'pages.search.rerankLabel': 'Re-rank',
  'pages.search.filePreviewAlt': 'File Preview',
  'pages.search.previewNotSupported': 'This file type cannot be previewed',
  'pages.search.chunkPageLabel': 'Page: {pageNumber}',
  'pages.search.matchPercentage': '{score}% match',
  'pages.search.openChunkAriaLabel': 'Open chunk {index}',
  'pages.search.navigateResultsTitle': 'Navigate results',
  'pages.search.loadingChunkResults': 'Loading chunk results...',
  'pages.search.chunkResultCount': '{count, plural, one {chunk result} other {chunk results}}',
  'pages.search.previousResultTitle': 'Previous result',
  'pages.search.nextResultTitle': 'Next result',
  'pages.search.chatWithDocumentButton': 'Chat with this document',
  'pages.search.searchWithinDocumentPlaceholder': 'Search within document...',
  'pages.search.filterDownLabel': 'Filter Down',
  'pages.search.documentPreviewTitle': 'Document Preview',
  'pages.search.askAgelPlaceholder': 'Ask A&GEL',
  'pages.search.searchAllButton': 'Search ALL',
  'pages.search.advancedSettingsButton': 'Advanced Settings',
  'pages.search.allTagsOption': ' All tags',
  'pages.sideBySide.addAtLeastOneQuestion': 'Please add at least one question',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    'Please add at least one question before submitting.',
  'pages.sideBySide.addNewQuestionsPlaceholder': 'Add new questions (one per line)',
  'pages.sideBySide.addPlusButton': 'Add +',
  'pages.sideBySide.addQuestionsLabel': 'Add Questions',
  'pages.sideBySide.addToMattersButton': 'Add to Matters',
  'pages.sideBySide.authorFieldLabel': 'Author',
  'pages.sideBySide.authorLabel': 'Author: ',
  'pages.sideBySide.categoryLabel': 'Category',
  'pages.sideBySide.cellDetails.answer': 'Answer',
  'pages.sideBySide.cellDetails.verified': 'Verified',
  'pages.sideBySide.cellDetails.verify': 'Verify',
  'pages.sideBySide.cellMarkedUnverified': 'Cell marked as unverified',
  'pages.sideBySide.cellMarkedVerified': 'Cell marked as verified',
  'pages.sideBySide.cellUpdatedSuccess': 'Cell updated successfully',
  'pages.sideBySide.changesUndone': 'Changes undone',
  'pages.sideBySide.clickOrDragToUpload': 'Click or drag to upload',
  'pages.sideBySide.cloneButton': 'Clone',
  'pages.sideBySide.cloneModeLabel': 'Clone',
  'pages.sideBySide.clonedNamePrefix': 'CLONED - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    'New column added. The matrix will refresh shortly.',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    'Column update started. The column will refresh shortly.',
  'pages.sideBySide.columnEditModal.enterPromptWarning': 'Please enter a prompt.',
  'pages.sideBySide.columnEditModal.promptLabel': 'Prompt',
  'pages.sideBySide.columnEditModal.promptPlaceholder':
    'Describe the prompt/system instruction for this column',
  'pages.sideBySide.columnEditModal.title': 'Modify Column',
  'pages.sideBySide.columnEditModal.updateColumnFailed': 'Failed to update column',
  'pages.sideBySide.createCustomQuestionListDescription':
    'Create a custom Side by Side question list for this session',
  'pages.sideBySide.createModeLabel': 'Create',
  'pages.sideBySide.createQuestionListButton': 'Create Question List',
  'pages.sideBySide.createdByLabel': 'Created by: ',
  'pages.sideBySide.createdByYou': 'You',
  'pages.sideBySide.customInstructionOptional': '2. Custom Instruction (optional)',
  'pages.sideBySide.deleteQuestionListConfirm':
    'Are you sure you want to delete this question list?',
  'pages.sideBySide.dragHereToUpload': 'Drag here to upload',
  'pages.sideBySide.emailButton': 'Email',
  'pages.sideBySide.exitButton': 'Exit',
  'pages.sideBySide.exitModeButton': 'Exit {mode}',
  'pages.sideBySide.fileCount': '{count} File(s)',
  'pages.sideBySide.firmOption': 'Firm',
  'pages.sideBySide.firmWideOption': 'Firm-wide',
  'pages.sideBySide.fromDocumentOption': 'From Document',
  'pages.sideBySide.groupOption': 'Group',
  'pages.sideBySide.leadRowHeader': 'Paragraphs of Source Document',
  'pages.sideBySide.manualCraftOption': 'Manual Craft',
  'pages.sideBySide.modifyButton': 'Modify',
  'pages.sideBySide.modifyModeLabel': 'Modify',
  'pages.sideBySide.newCategoryPlaceholder': 'New category',
  'pages.sideBySide.newQuestionListButtonLabel': 'New Side by Side Question List',
  'pages.sideBySide.newQuestionListDefaultName': 'New Side by Side Question List',
  'pages.sideBySide.noNotesAvailable': 'No notes available.',
  'pages.sideBySide.noPurposeAvailable': 'No purpose available.',
  'pages.sideBySide.noSystemPromptConfigured': 'No system prompt configured.',
  'pages.sideBySide.notesFieldLabel': 'Notes',
  'pages.sideBySide.notesLabel': 'Notes: ',
  'pages.sideBySide.pendingApprovalTag': 'Pending Approval',
  'pages.sideBySide.pollingTimeoutWarning':
    'Polling timeout. The side by side may still be processing.',
  'pages.sideBySide.processing': 'Processing',
  'pages.sideBySide.processingStopped': 'Processing stopped.',
  'pages.sideBySide.publicOption': 'Public',
  'pages.sideBySide.publishButton': 'Publish',
  'pages.sideBySide.publishQuestionListFailed': 'Failed to publish question list',
  'pages.sideBySide.publishStatusLabel': 'Publish Status',
  'pages.sideBySide.publishToLabel': 'Publish to:',
  'pages.sideBySide.publishedToAccess': 'Published to {access}',
  'pages.sideBySide.publishedToGroupSuccess': 'Question list published to group',
  'pages.sideBySide.publishedToPrivateGroups': 'Question list published to private groups',
  'pages.sideBySide.publisherLabel': 'Publisher: ',
  'pages.sideBySide.purposeFieldLabel': 'Purpose',
  'pages.sideBySide.purposeLabel': 'Purpose: ',
  'pages.sideBySide.questionListClonedSuccess': 'Question list cloned successfully',
  'pages.sideBySide.questionListCreatedSuccess': 'Question list created successfully',
  'pages.sideBySide.questionListDeletedSuccess': 'Question list deleted successfully',
  'pages.sideBySide.questionListNamePlaceholder': 'Side-by-side Question List Name',
  'pages.sideBySide.questionListUpdatedSuccess': 'Question list updated successfully',
  'pages.sideBySide.questionsListLabel': 'Questions List',
  'pages.sideBySide.quickQuestionsDescription':
    'Generate structured side by side of one or more documents based on a set of ad-hoc questions',
  'pages.sideBySide.quickQuestionsTitle': 'Quick Questions',
  'pages.sideBySide.rejectedTag': 'Rejected',
  'pages.sideBySide.restoreConfigurationFailed':
    'Failed to restore configuration. Please try again.',
  'pages.sideBySide.reuseButton': 'Re-use',
  'pages.sideBySide.reviewTemplateQuestionsDescription': 'Review questions for this template',
  'pages.sideBySide.saveChangesButton': 'Save Changes',
  'pages.sideBySide.selectDocumentDescription':
    'Select the document you wish to perform a Side by Side on',
  'pages.sideBySide.selectGroupsPlaceholder': 'Select groups',
  'pages.sideBySide.selectGroupsToShareDescription': 'Select one or more groups to share with:',
  'pages.sideBySide.selectionDescription':
    'Generate structured side by side of one or more documents based on your Question Lists',
  'pages.sideBySide.selectionFeatureName': 'side by side',
  'pages.sideBySide.selectionTitle': 'Side-by-side',
  'pages.sideBySide.sentForApprovalSuccess': 'Question list sent for approval',
  'pages.sideBySide.showQuestionsButton': 'Show Questions',
  'pages.sideBySide.startGenerateReview': 'Start generate review',
  'pages.sideBySide.startNewSideBySideButton': 'Start a new Side-by-Side',
  'pages.sideBySide.stayButton': 'Stay',
  'pages.sideBySide.submitFailed': 'Failed to submit side-by-side',
  'pages.sideBySide.systemPromptLabel': 'System Prompt',
  'pages.sideBySide.tabs.prompts': 'Prompts',
  'pages.sideBySide.tabs.questionList': 'Question List',
  'pages.sideBySide.tabs.selectDocuments': 'Select Documents',
  'pages.sideBySide.targetAudiencePlaceholder': 'name of client or target audience',
  'pages.sideBySide.teamsButton': 'Teams',
  'pages.sideBySide.templateSystemPromptLabel': 'Template System Prompt',
  'pages.sideBySide.tour.noHistorySessions':
    'No side-by-side sessions available in history. Please create one first to see this step.',
  'pages.sideBySide.tour.step1.description':
    'Start by selecting a question list from the available categories. Click on any question list card to proceed.',
  'pages.sideBySide.tour.step1.title': 'Choose a Question List',
  'pages.sideBySide.tour.step2.description':
    'Enter the target audience or client name, then select the document you want to compare side by side.',
  'pages.sideBySide.tour.step2.title': 'Fill Target Audience and Select a File',
  'pages.sideBySide.tour.step3.description':
    'Review the system prompt and questions list here. Switch to the history panel to see previous sessions.',
  'pages.sideBySide.tour.step3.title': 'View System Prompt and Questions',
  'pages.sideBySide.tour.step4.description':
    'Once you submit, the side-by-side results will appear in a table. Click a cell to view details.',
  'pages.sideBySide.tour.step4.title': 'View Side-by-Side Results',
  'pages.sideBySide.typeHerePlaceholder': 'Type here...',
  'pages.sideBySide.undoChangesButton': 'Undo Changes',
  'pages.sideBySide.unsavedChangesWillBeLost': 'Any unsaved changes will be lost.',
  'pages.sideBySide.untitled': '(Untitled)',
  'pages.sideBySide.updateCellFailed': 'Failed to update cell',
  'pages.sideBySide.updateCellVerificationFailed': 'Failed to update cell verification',
  'pages.sideBySide.updateFailed': 'Failed to update',
  'pages.sideBySide.uploadDocumentFailed': 'Failed to upload document',
  'pages.sideBySide.whatsNewDescription':
    'Introduced several new features to enhance your document side by side process.',
  'pages.sideBySide.whoIsItForQuestion': '1. Who is it for?',
  'pages.template.waitingMessage.justAMoment': 'Just a moment...',
  'pages.template.waitingMessage.fetchingThatForYou': 'Fetching that for you...',
  'pages.template.waitingMessage.hangTight': "Hang tight, I'm on it...",
  'pages.template.waitingMessage.letMeCheck': 'Let me check...',
  'pages.template.waitingMessage.oneSecPlease': 'One sec, please...',
  'pages.template.waitingMessage.lookingThatUp': 'Looking that up for you...',
  'pages.template.waitingMessage.almostThere': 'Almost there...',
  'pages.template.waitingMessage.holdOnRetrieving': "Hold on, I'm retrieving info...",
  'pages.template.waitingMessage.workingOnIt': 'Working on it...',
  'pages.template.dragDropUpload': 'Drag here to upload',
  'pages.template.uploadInvalidFileTypes':
    'Please upload only PDF, DOC, DOCX, MSG, EML, TXT, or MD files',
  'pages.template.someFilesSkipped':
    'Some files were skipped. Only PDF, DOC, DOCX, MSG, EML, TXT, or MD files are allowed',
  'pages.template.fileUploadedSuccess': '{fileName} uploaded successfully',
  'pages.template.fileUploadFailed': 'Failed to upload {fileName}',
  'pages.template.loadTemplateDetailsFailed': 'Failed to load template details',
  'pages.template.viewLess': 'View Less',
  'pages.template.viewAll': 'View All',
  'pages.template.tour.step1Title': 'Choose a Custom Output Template',
  'pages.template.tour.step1Description':
    'Start by selecting a template preset from the available categories.',
  'pages.template.tour.step2Title': 'Select Files for Analysis',
  'pages.template.tour.step2Description':
    'Upload or select document(s) you want to run the custom output on.',
  'pages.template.tour.step3Title': 'Review Prompts & Instructions',
  'pages.template.tour.step3Description':
    'Provide target audience details and optional custom instructions here.',
  'pages.template.tour.step4Title': 'View Results',
  'pages.template.tour.step4Description':
    'After submitting, the generated custom output will appear in this area.',
  'pages.template.noSessionsFound': 'No template sessions found. Please run one to see results.',
  'pages.template.startNewCustomOutput': 'Start a new Custom Output',
  'pages.template.untitled': '(Untitled)',
  'pages.template.newSession': 'New Session',
  'pages.template.fileCount': '{count} File(s)',
  'pages.template.reuseButton': 'Re-use',
  'pages.template.addToMattersButton': 'Add to Matters',
  'pages.template.startFillingTemplates': 'Start filling templates',
  'pages.template.unsavedChangesWarning': 'Any unsaved changes will be lost.',
  'pages.template.stayButton': 'Stay',
  'pages.template.exitButton': 'Exit',
  'pages.template.undoChangesButton': 'Undo Changes',
  'pages.template.changesUndoneMessage': 'Changes undone',
  'pages.template.templateCreatedSuccess': 'Template created successfully',
  'pages.template.templateUpdatedSuccess': 'Template updated successfully',
  'pages.template.fillRequiredFields': 'Please fill in all required fields',
  'pages.template.saveTemplateFailed': 'Failed to save template',
  'pages.template.createTemplateButton': 'Create Template',
  'pages.template.saveTemplateButton': 'Save Template',
  'pages.template.presetNamePlaceholder': 'Custom Template Preset Name',
  'pages.template.categoryLabel': 'Category',
  'pages.template.newCategoryPlaceholder': 'New category',
  'pages.template.addCategoryButton': 'Add category',
  'pages.template.purposeLabel': 'Purpose',
  'pages.template.notesLabel': 'Notes',
  'pages.template.systemPromptLabel': 'System Prompt',
  'pages.template.typeProse': 'Prose',
  'pages.template.typeTable': 'Table',
  'pages.template.tableTypeLabel': 'Table Type',
  'pages.template.tableTypeTooltip':
    "User defined columns are not available for 'Clause by clause' and 'Document by document' tables.",
  'pages.template.tableTypeStandard': 'Standard',
  'pages.template.tableTypeDocument': 'Document by Document',
  'pages.template.tableTypeClause': 'Clause by Clause',
  'pages.template.columnsLabel': 'Columns',
  'pages.template.newColumnButton': 'New Column',
  'pages.template.exampleLabel': 'Example',
  'pages.template.userDefinedLabel': 'User Defined',
  'pages.template.userDefinedColumnTooltip': 'User Defined Column',
  'pages.template.columnTypeString': 'String',
  'pages.template.columnTypeNumber': 'Number',
  'pages.template.columnTypeDatetime': 'Datetime',
  'pages.template.sectionsLabel': 'Sections',
  'pages.template.newSectionButton': 'New Section',
  'pages.template.headingColumnHeader': 'Heading',
  'pages.template.promptColumnHeader': 'Prompt',
  'pages.template.modifyButton': 'Modify',
  'pages.template.publishToLabel': 'Publish to:',
  'pages.template.publishFirmWide': 'Firm-wide',
  'pages.template.publicAccessLabel': 'Public',
  'pages.template.firmAccessLabel': 'Firm',
  'pages.template.publishButton': 'Publish',
  'pages.template.publishSentForApproval': 'Template preset sent for approval',
  'pages.template.publishTemplateFailed': 'Failed to publish template',
  'pages.template.deleteConfirmQuestion': 'Are you sure you want to delete this template?',
  'pages.template.templateDeletedSuccess': 'Template deleted successfully',
  'pages.template.deleteTemplateFailed': 'Failed to delete template',
  'pages.template.customTemplateCreatedForSession':
    'Custom template created successfully for this session',
  'pages.template.publishStatusLabel': 'Publish Status',
  'pages.template.pendingApprovalStatus': 'Pending Approval',
  'pages.template.rejectedStatus': 'Rejected',
  'pages.template.publishedToStatus': 'Published to {target}',
  'pages.template.authorLabel': 'Author',
  'pages.template.emailButton': 'Email',
  'pages.template.noPurposeAvailable': 'No purpose available.',
  'pages.template.noNotesAvailable': 'No notes available.',
  'pages.template.startHereTab': 'Start here',
  'pages.template.whoIsItForQuestion': '1. Who is it for?',
  'pages.template.clientAudiencePlaceholder': 'name of client or target audience',
  'pages.template.selectDocumentsQuestion':
    '2. Select the document(s) you wish to perform a review on',
  'pages.template.customInstructionTab': 'Custom Instruction (optional)',
  'pages.template.modifyPromptLabel': 'Modify Prompt',
  'pages.template.typeHerePlaceholder': 'Type here...',
  'pages.template.noSystemPromptConfigured': 'No system prompt configured.',
  'pages.template.exampleValuePrefix': 'e.g. {example}',
  'pages.template.customOutputTitle': 'Custom Output',
  'pages.template.customOutputDescription':
    'Create and use customised prompts (called "Custom Outputs" on A&GEL) for more tailored analysis of documents where you require specific types of information to be extracted or where a more thorough level of analysis is required',
  'pages.template.whatsNewButton': "What's New",
  'pages.template.tourButton': 'Tour',
  'pages.template.addNewCustomTemplateButton': 'Add New Custom Template',
  'pages.template.whatsNewModal.intro':
    "We've introduced several new features to enhance your document review process:",
  'pages.template.whatsNewModal.improvedFilteringTitle': 'Improved Filtering: ',
  'pages.template.whatsNewModal.improvedFilteringBody':
    'New audience and author filters to help you find your question lists faster.',
  'pages.template.whatsNewModal.adhocQuestionsTitle': 'Ad-hoc Questions: ',
  'pages.template.whatsNewModal.adhocQuestionsBody':
    'More flexible way to add questions on the fly.',
  'pages.template.whatsNewModal.uiEnhancementsTitle': 'UI Enhancements: ',
  'pages.template.whatsNewModal.uiEnhancementsBody':
    'A cleaner, more intuitive interface for managing your templates.',
  'pages.template.upcomingFeaturesTitle': 'Upcoming Features',
  'pages.template.upcomingFeaturesBody':
    'Stay tuned for more updates, including collaborative reviews and advanced AI analytics.',
  'pages.template.tourIndicator': '{current} / {total}',
  'pages.translation.addToMattersButton': 'Add to Matters',
  'pages.translation.batchFileCountLabel': '{count} files',
  'pages.translation.batchTranslationStarted': 'Batch translation started',
  'pages.translation.copiedSuccess': 'Copied!',
  'pages.translation.couldNotResolveFile':
    'Could not resolve the selected file. Please upload or select a file again.',
  'pages.translation.customInstructionTab': 'Custom Instruction (optional)',
  'pages.translation.docxOrPdfOnly': 'Please select DOCX or PDF files only.',
  'pages.translation.downloadFailed': 'Download failed ({status})',
  'pages.translation.dragHereToUpload': 'Drag here to upload',
  'pages.translation.enterLanguageRequired': 'Please enter language',
  'pages.translation.failedRenderOriginalPreview': 'Failed to render original preview',
  'pages.translation.failedRenderTranslatedPreview': 'Failed to render translated preview',
  'pages.translation.failedToFetchDocx': 'Failed to fetch DOCX ({status})',
  'pages.translation.failedToStartTranslation': 'Failed to start translation',
  'pages.translation.failedToStartTranslationMissingId': 'Failed to start translation (missing id)',
  'pages.translation.fileCountLabel': '{count} File(s)',
  'pages.translation.filterFilesPlaceholder': 'Filter files',
  'pages.translation.liveTranslationHint':
    'Type on the left, see the translation on the right — instantly.',
  'pages.translation.liveTranslationTitle': 'Live Translation',
  'pages.translation.modifyPromptLabel': 'Modify Prompt',
  'pages.translation.failed': 'Translation failed',
  'pages.translation.noPreviewAvailable': 'No preview available',
  'pages.translation.noFilesMatch': 'No files match "{query}"',
  'pages.translation.noTranslatedDocumentYet': 'No translated document available yet.',
  'pages.translation.originalLabel': 'Original',
  'pages.translation.viewSideBySide': 'Side by side',
  'pages.translation.viewAlternating': 'Alternating',
  'pages.translation.originalPdfTitle': 'Original PDF',
  'pages.translation.otherLanguagePlaceholder': 'e.g., Tamil',
  'pages.translation.outputLanguageStep': '2. Output Language',
  'pages.translation.previewNotSupported':
    'Preview is currently supported for DOCX and PDF files only.',
  'pages.translation.processingTitle': 'Processing…',
  'pages.translation.processingTranslation': 'Processing translation…',
  'pages.translation.promptOptionalLabel': 'Prompt (optional)',
  'pages.translation.recentlyTranslatedLabel': 'Recently Translated',
  'pages.translation.renderingOriginal': 'Rendering original…',
  'pages.translation.renderingTranslation': 'Rendering translation…',
  'pages.translation.reuseButton': 'Re-use',
  'pages.translation.searchTranslationsPlaceholder': 'Search Translations',
  'pages.translation.selectAtLeastOneDocument':
    'Please upload or select at least 1 document to translate.',
  'pages.translation.selectAtMostDocuments': 'Please select at most {max} documents to translate.',
  'pages.translation.selectDocumentStep': '1. Select the document you wish to translate',
  'pages.translation.selectLanguagePlaceholder': 'Select language',
  'pages.translation.selectLanguageRequired': 'Please select a language',
  'pages.translation.selectOutputLanguagePlaceholder': 'Select one output language',
  'pages.translation.selectOutputLanguageRequired': 'Please select an output language.',
  'pages.translation.startHereTab': 'Start here',
  'pages.translation.startLiveTranslationButton': 'Start a Live Translation',
  'pages.translation.startNewTranslationButton': 'Start a new Translation',
  'pages.translation.startTranslationButton': 'Start Translation',
  'pages.translation.stopTranslationFailed': 'Failed to stop translation',
  'pages.translation.swapLanguagesTooltip': 'Swap languages',
  'pages.translation.title': 'Translation',
  'pages.translation.translateButton': 'Translate',
  'pages.translation.translatedLabel': 'Translated',
  'pages.translation.translatedPdfTitle': 'Translated PDF',
  'pages.translation.downloadAsPdf': 'PDF – original layout',
  'pages.translation.downloadAsWord': 'Word – editable text',
  'pages.translation.zoomIn': 'Zoom in',
  'pages.translation.zoomOut': 'Zoom out',
  'pages.translation.fitWidth': 'Fit to width',
  'pages.translation.translationFailedError': 'Translation failed',
  'pages.translation.translationHint':
    'Translate your document into one or more output languages. Results are displayed side-by-side with the original segments.',
  'pages.translation.translationStoppedSuccess': 'Translation stopped',
  'pages.translation.translationTaskStarted': 'Translation task started',
  'pages.translation.typeTextToTranslatePlaceholder': 'Type text to translate',
  'pages.translation.unknownLanguage': 'Unknown',
  'pages.translation.untitledFallback': '(Untitled)',
  'pages.translation.untitledTranslationFallback': 'Untitled Translation',
  'pages.user.passwordConfirmationPlaceholder': 'Password Confirmation',
  'pages.user.logoAlt': 'Logo',
  'pages.user.emailPlaceholder': 'Email',
  'pages.user.passwordPlaceholder': 'Password',
  'pages.user.newPasswordPlaceholder': 'New Password',
  'pages.user.forgotPassword.emailSentMessage':
    'An email will be sent shortly if the email is registered',
  'pages.user.forgotPassword.submitButton': 'Send Reset Link',
  'pages.user.resetPassword.successMessage': 'Your password has been updated',
  'pages.user.resetPassword.submitButton': 'Reset Password',
  'pages.user.resetPassword.passwordRequired': 'Password is required',
  'pages.user.resetPassword.passwordMinLength': 'Should be at least 8 characters long',
  'pages.user.resetPassword.passwordNeedsAlpha': 'Should contain at least 1 alphabet',
  'pages.user.resetPassword.passwordNeedsNumber': 'Should contain at least 1 numberic',
  'pages.user.resetPassword.passwordNeedsSpecial': 'Should contain at least 1 special charater',
  'pages.user.resetPassword.confirmPasswordRequired': 'Please confirm your new password!',
  'pages.user.resetPassword.passwordMismatch': 'The two passwords that you entered do not match!',
  'pages.user.login.tenantNotRegistered':
    'Your Microsoft tenant is not registered for this app. Please contact your IT administrator.',
  'pages.user.login.ssoNotConfigured': 'Microsoft SSO is not properly configured',
  'pages.user.login.ssoAccountNotFound': 'Microsoft SSO account not found',
  'pages.user.login.emailPasswordWrong': 'Email / Password is wrong',
  'pages.user.login.contactAdminContent': 'Please contact your admin to reset your password.',
  'pages.user.management.pageTitle': 'Manage',
  'pages.user.rolesLoadingPlaceholder': 'Loading roles...',
  'pages.user.selectRolePlaceholder': 'Select a role',
  'pages.user.billing.seatsMinimumError': 'Seats must be an integer of at least 1.',
  'pages.user.billing.contactRequiredError': 'Billing contact name and email are required.',
  'pages.user.billing.contactNameInvalidError':
    "Billing contact name can only contain letters, spaces, hyphens (-) and apostrophes (').",
  'pages.user.billing.renewOrChoosePlan': 'Renew / choose a plan',
  'pages.user.billing.switchPlanAction': 'Switch plan',
  'pages.user.billing.subscribeAction': 'Subscribe',
  'pages.user.billing.renewPlanAction': 'Renew plan',
  'pages.user.billing.switchPlanModalTitle': 'Switch Plan',
  'pages.user.billing.switchPlanConfirmContent':
    'You will be redirected to checkout and charged {total} for {seats} seats on {planName} ({interval}ly).',
  'pages.user.billing.switchPlanConfirmContentRenewal':
    'You will be redirected to checkout and charged {total} for {seats} seats on {planName} ({interval}ly) to renew your canceled subscription.',
  'pages.user.billing.switchPlanConfirmContentReplace':
    'You will be redirected to checkout and charged {total} for {seats} seats on {planName} ({interval}ly). Your current plan will be replaced.',
  'pages.user.billing.renewThisPlanButton': 'Renew this plan',
  'pages.user.billing.currentPlanButton': 'Current plan',
  'pages.user.billing.switchToThisPlanButton': 'Switch to this plan',
  'pages.user.billing.subscribeToThisPlanButton': 'Subscribe to this plan',
  'pages.user.billing.planText': 'Plan',
  'pages.user.billing.selectedTag': 'Selected',
  'pages.user.billing.totalLabel': 'Total:',
  'pages.user.billing.billingContactTitle': 'Billing contact',
  'pages.user.billing.billingContactHint': 'Required for payment checkout and invoices.',
  'pages.user.billing.fullNameLabel': 'Full name',
  'pages.user.billing.billingEmailLabel': 'Billing email',
  'pages.user.billing.seatsLabel': 'Seats',
  'pages.user.billing.registeringTenantTitle': 'Registering Microsoft tenant',
  'pages.user.billing.tenantStep1': 'Step 1/4: Loading Microsoft SSO configuration...',
  'pages.user.billing.ssoNotEnabledError':
    'Microsoft SSO is not enabled. Please contact your administrator.',
  'pages.user.billing.tenantStep2':
    'Step 2/4: Opening Microsoft sign-in popup. Please sign in and grant permission for your tenant.',
  'pages.user.billing.tenantStep3': 'Step 3/4: Verifying tenant token with server...',
  'pages.user.billing.tenantStep4':
    'Step 4/4: Saving tenant registration to your current organisation...',
  'pages.user.billing.tenantRegistrationCompleteTitle': 'Microsoft tenant registration complete',
  'pages.user.billing.tenantAddedMessage':
    'Success. Tenant ID {tenantId} has been added to your organisation.',
  'pages.user.billing.tenantAlreadyRegisteredMessage':
    'Tenant ID {tenantId} is already registered for your organisation. No further action is needed.',
  'pages.user.billing.tenantRegisterGenericError':
    'Unable to register Microsoft tenant. Please try again.',
  'pages.user.billing.tenantRegistrationFailedTitle': 'Microsoft tenant registration failed',
  'pages.user.billing.tenantRegistrationIncompleteMessage':
    'Registration did not complete. {detail}',
  'pages.user.billing.loadInvoicesError': 'Unable to load invoices.',
  'pages.user.billing.loadBillingDetailsError': 'Unable to load billing details.',
  'pages.user.billing.openCheckoutError': 'Unable to open billing checkout.',
  'pages.user.billing.seatChangeScheduledMessage':
    'Seat change scheduled — takes effect at next renewal.',
  'pages.user.billing.seatsUpdatedMessage': 'Seats updated.',
  'pages.user.billing.tenantPopupNotice':
    'Keep this window open. A Microsoft popup is required. Complete sign-in and consent to continue.',
  'pages.user.billing.editSeatsModalTitle': 'Edit Seats',
  'pages.user.billing.saveSeatsButton': 'Save Seats',
  'pages.user.billing.currentTotalLabel': 'Current total',
  'pages.user.billing.previewTotalLabel': 'Preview total',
  'pages.user.billing.differenceLabel': 'Difference from next renewal',
  'pages.user.billing.seatChangeRenewalNotice':
    'Seat changes take effect at your next renewal on {nextInvoiceDisplay}.',
  'pages.user.billing.invoices': 'Invoices',
  'pages.user.billing.nextInvoiceDateLabel': 'Next invoice date:',
  'pages.user.billing.invoiceColumn': 'Invoice',
  'pages.user.billing.dueColumn': 'Due',
  'pages.user.billing.amountColumn': 'Amount',
  'pages.user.billing.downloadInvoiceError': 'Unable to download invoice PDF.',
  'pages.user.billing.membersSeatsLabel': 'Members / Seats',
  'pages.user.billing.scheduledTag': 'Scheduled',
  'pages.user.billing.pendingSeatsNotice': '→ {seats} seats from next renewal',
  'pages.user.billing.editSeatsButton': 'Edit seats',
  'pages.user.billing.currentPlanCardLabel': 'Current Plan',
  'pages.user.billing.priceLabel': 'Price:',
  'pages.user.billing.billingCardTitle': 'Billing',
  'pages.user.billing.nextInvoiceLabel': 'Next Invoice',
  'pages.user.billing.registerMicrosoftTenantButton': 'Register Microsoft Tenant',
  'pages.user.billing.contactOrgAdmin': 'Contact your organisation admin.',
  'pages.user.billing.graceDeadlineFallback': 'the grace deadline',
  'pages.user.billing.paymentIssueTitle': 'Payment issue',
  'pages.user.billing.pastDueDescription':
    'Your subscription is past due. Access continues until {graceDate}. Renew now to avoid interruption.',
  'pages.user.billing.subscriptionCancelledTitle': 'Subscription cancelled.',
  'pages.user.billing.subscriptionInactiveTitle': 'Subscription inactive',
  'pages.user.billing.orgAccessRestrictedDescription':
    'organisation access is restricted until billing is resolved.',
  'pages.welcomeDashboard.jsonResponseTitle': 'JSON Response',
  'pages.welcomeDashboard.textResponseTitle': 'Text Response',
  'pages.welcomeDashboard.visibility.public': 'Public',
  'pages.welcomeDashboard.visibility.firm': 'Firm',
  'pages.welcomeDashboard.visibility.unknown': 'Unknown',
  'pages.welcomeDashboard.rejectButton': 'Reject',
  'pages.welcomeDashboard.approveButton': 'Approve',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.title': 'Words Generated Today',
  'pages.welcomeDashboard.metrics.wordsGenerated.chartLabel': 'Words Generated',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.description': 'AI-assisted drafting',
  'pages.welcomeDashboard.metrics.pagesProcessed.title': 'A4 Pages Processed',
  'pages.welcomeDashboard.metrics.pagesProcessed.chartLabel': 'Pages Processed',
  'pages.welcomeDashboard.metrics.pagesProcessed.description': 'Across active matters today',
  'pages.welcomeDashboard.metrics.documentsDownloaded.title': 'Documents Downloaded',
  'pages.welcomeDashboard.metrics.documentsDownloaded.chartLabel': 'Documents Downloaded',
  'pages.welcomeDashboard.metrics.documentsDownloaded.description': 'Files exported today',
  'pages.welcomeDashboard.metrics.questionsAnswered.title': 'Questions Answered',
  'pages.welcomeDashboard.metrics.questionsAnswered.chartLabel': 'Questions Answered',
  'pages.welcomeDashboard.metrics.questionsAnswered.description': 'AI prompts served today',
  'pages.welcomeDashboard.features.apps.name': 'Apps',
  'pages.welcomeDashboard.features.apps.description': 'Analyze and summarize content',
  'pages.welcomeDashboard.features.scribe.name': 'Scribe',
  'pages.welcomeDashboard.features.scribe.description': 'Document transcription',
  'pages.welcomeDashboard.features.comparison.name': 'Comparison',
  'pages.welcomeDashboard.features.comparison.description': 'Compare documents side by side',
  'pages.welcomeDashboard.features.review.name': 'Review',
  'pages.welcomeDashboard.features.review.description': 'Review documents with questions',
  'pages.welcomeDashboard.features.translation.name': 'Translation',
  'pages.welcomeDashboard.features.translation.description': 'Translate documents',
  'pages.welcomeDashboard.features.chat.name': 'Chat',
  'pages.welcomeDashboard.features.chat.description': 'Chat with AI assistant',
  'pages.welcomeDashboard.features.templates.name': 'Templates',
  'pages.welcomeDashboard.features.templates.description': 'Manage templates',
  'pages.welcomeDashboard.features.quote.name': 'Quote',
  'pages.welcomeDashboard.features.quote.description': 'Generate quotes',
  'pages.welcomeDashboard.features.files.name': 'Files',
  'pages.welcomeDashboard.features.files.description': 'Manage your files',
  'pages.welcomeDashboard.features.library.name': 'Library',
  'pages.welcomeDashboard.features.library.description': 'Access your library',
  'pages.welcomeDashboard.features.sideBySide.name': 'Side by Side',
  'pages.welcomeDashboard.features.sideBySide.description': 'Side by side comparison',
  'pages.welcomeDashboard.features.playbook.name': 'Workstudio',
  'pages.welcomeDashboard.features.playbook.description': 'Create and manage Workstudio sessions',
  'pages.welcomeDashboard.features.fallback.description': 'Feature',
  'pages.welcomeDashboard.features.search.name': 'Search',
  'pages.welcomeDashboard.greeting': 'Greetings, {username}',
  'pages.welcomeDashboard.useCasesButton': 'Use Cases',
  'pages.welcomeDashboard.faqsButton': 'FAQs',
  'pages.welcomeDashboard.publishingApprovalsButton': 'Publishing Approvals ({count})',
  'pages.welcomeDashboard.jumpBackInTitle': 'Recents',
  'pages.welcomeDashboard.untitledSession': 'Untitled Session',
  'pages.welcomeDashboard.viewAllButton': 'View All',
  'pages.welcomeDashboard.noRecentSessions': 'No recent sessions',
  'pages.welcomeDashboard.statsTitle': 'My Stats',
  'pages.welcomeDashboard.usefulFeaturesTitle': 'Useful Features',
  'pages.welcomeDashboard.sessionsCount': '{count, plural, one {# session} other {# sessions}}',
  'pages.welcomeDashboard.foundUsefulThisWeek': '{count} users found useful this week',
  'pages.welcomeDashboard.noRecentActivity': 'No recent activity',
  'pages.welcomeDashboard.publishingApprovalsModalTitle': 'Publishing Approvals',
  'pages.welcomeDashboard.approvalTag.template': 'Template',
  'pages.welcomeDashboard.approvalTag.review': 'Review',
  'pages.welcomeDashboard.approvalTag.sideBySide': 'Side-by-Side',
  'pages.welcomeDashboard.approvalTag.prompt': 'Prompt',
  'pages.welcomeDashboard.approvalTag.multiStep': 'Multi-Step',
  'pages.welcomeDashboard.recentSessionsModalTitle': '{pageName} — Recent Sessions',
  'pages.welcomeDashboard.detail.publishTarget': 'Publish Target',
  'pages.welcomeDashboard.detail.author': 'Author',
  'pages.welcomeDashboard.detail.unknown': 'Unknown',
  'pages.welcomeDashboard.detail.category': 'Category',
  'pages.welcomeDashboard.detail.purpose': 'Purpose',
  'pages.welcomeDashboard.detail.notes': 'Notes',
  'pages.welcomeDashboard.systemPromptLabel': 'System Prompt',
  'pages.welcomeDashboard.noSystemPromptProvided': 'No system prompt provided',
  'pages.welcomeDashboard.promptContentLabel': 'Prompt Content',
  'pages.welcomeDashboard.noPromptContentAvailable': 'No prompt content available',
  'pages.welcomeDashboard.multiStepConfigFallback': 'Multi-Step Config',
  'pages.welcomeDashboard.detail.description': 'Description',
  'pages.welcomeDashboard.stepsLabel': 'Steps',
  'pages.welcomeDashboard.stepFallback': 'Step {number}',
  'pages.welcomeDashboard.templateFallback': 'Template',
  'pages.welcomeDashboard.detail.target': 'Target',
  'pages.welcomeDashboard.miscFallback': 'Misc',
  'pages.welcomeDashboard.detail.type': 'Type',
  'pages.welcomeDashboard.templateType.prose': 'Prose',
  'pages.welcomeDashboard.templateType.table': 'Table',
  'pages.welcomeDashboard.tableTypeLabel': 'Table Type',
  'pages.welcomeDashboard.tableType.standard': 'Standard',
  'pages.welcomeDashboard.tableType.documentByDocument': 'Document by Document',
  'pages.welcomeDashboard.tableType.clauseByClause': 'Clause by Clause',
  'pages.welcomeDashboard.columnsLabel': 'Columns',
  'pages.welcomeDashboard.sectionsLabel': 'Sections',
  'pages.welcomeDashboard.userDefinedTag': 'User Defined',
  'pages.welcomeDashboard.noTemplateStructureAvailable': 'No template structure available',
  'pages.welcomeDashboard.questionListFallback': 'Question List',
  'pages.welcomeDashboard.noQuestionsAvailable': 'No questions available',
  'pages.clipboard.goTo': 'Go to it',
  'pages.clipboard.remove': 'Remove clip',
  'pages.clipboard.close': 'Close Clipboard',
  'pages.clipboard.empty': 'Select text and choose Copy to Clipboard to collect it here.',
  'pages.clipboard.copyAll': 'Copy all clips',
  'pages.clipboard.search': 'Clipboard Search',
  'pages.clipboard.searchPlaceholder': 'Search all clips',
  'pages.clipboard.noMatches': 'No clips match your search.',
  'pages.clipboard.expand': 'Expand clip',
  'pages.clipboard.collapse': 'Collapse clip',
  'pages.clipboard.singleCount': '{count} stack',
  'pages.clipboard.totalCount': '{count} stacks',
  'pages.clipboard.filteredCount': '{visible} of {total} stacks',
  'pages.clipboard.loadFailed': 'Could not load your saved stacks.',
  'pages.clipboard.deleteFailed': 'Could not remove the stack. Please try again.',
  'pages.clipboard.retry': 'Retry',
  'pages.files.sharePoint.title': 'SharePoint folder',
  'pages.files.sharePoint.intro':
    'Link this group to a SharePoint folder. Its files sync into A&GEL, and members follow who can open the folder in SharePoint.',
  'pages.files.sharePoint.link': 'Link a SharePoint folder',
  'pages.files.sharePoint.linkConfirmTitle': 'Link to “{name}”?',
  'pages.files.sharePoint.linkConfirmBody':
    "Members will follow who can open this folder in SharePoint: people who can't open it are removed at the next sync. Files already in the group stay, visible to all members.",
  'pages.files.sharePoint.linkConfirmOk': 'Link folder',
  'pages.files.sharePoint.linked': 'Linked to {name}',
  'pages.files.sharePoint.lastSynced': 'Last synced {time}',
  'pages.files.sharePoint.neverSynced': 'Waiting for the first sync',
  'pages.files.sharePoint.syncNow': 'Sync now',
  'pages.files.sharePoint.syncRequested': 'Sync requested. It can take a few minutes.',
  'pages.files.sharePoint.openInSharePoint': 'Open in SharePoint',
  'pages.files.sharePoint.unlink': 'Unlink',
  'pages.files.sharePoint.unlinkTitle': 'Unlink from SharePoint?',
  'pages.files.sharePoint.unlinkBody':
    'The group stops syncing. Current members stay and are managed in A&GEL again.',
  'pages.files.sharePoint.unlinkKeep': 'Keep the synced files',
  'pages.files.sharePoint.unlinkRemove': 'Remove the synced files',
  'pages.files.sharePoint.unlinked': 'Unlinked from SharePoint.',
  'pages.files.sharePoint.pausedFolderMissing':
    "Sync is paused: the folder can't be found in SharePoint. It may have been moved or deleted.",
  'pages.files.sharePoint.pausedNoLogin':
    "Sync is paused: no member's Microsoft connection could open the folder. Ask a member to reconnect Microsoft.",
  'pages.files.sharePoint.pausedTooLarge': 'Sync is paused: the folder has more than 5,000 items.',
  'pages.files.sharePoint.paused': 'Sync is paused.',
  'pages.files.sharePoint.membersNote':
    'Members are the A&GEL users who can open this folder in SharePoint. To add or remove someone, change their access in SharePoint, then click Sync now.',
  'pages.files.sharePoint.via': 'via {upn}',
  'pages.files.sharePoint.errorGeneric': 'Something went wrong. Please try again.',
  'pages.files.sharePoint.syncedChip': 'Synced with SharePoint',
  'pages.files.sharePoint.syncingChip': 'Syncing with SharePoint…',
  'pages.files.sharePoint.groupNameIs': 'Group name: {name}',
  'pages.files.sharePoint.modeNewFolder': 'New folder',
  'pages.files.sharePoint.modeSync': 'Sync a SharePoint folder',
  'pages.files.sharePoint.pickFolder': 'Pick a folder',
  'pages.files.sharePoint.pickFolderFirst': 'Pick a SharePoint folder first.',
  'pages.files.sharePoint.renameInSharePoint':
    'This name follows the SharePoint folder. Rename the folder in SharePoint to rename this group.',
  'pages.files.sharePoint.syncedGroupAddHint':
    "This group is synced from SharePoint. Add files there and they'll show here after the next sync.",
  'pages.files.sharePoint.checkingSharePoint': 'Checking SharePoint for changes…',
  'pages.files.sharePoint.changeFolder': 'Change folder',
  'pages.files.sharePoint.createdAndLinked':
    'Group created and linked to {name}. Its files are syncing now.',
  'pages.files.sharePoint.syncedFileHint':
    "This file comes from SharePoint. Make changes there and they'll show here after the next sync.",
  'pages.files.sharePoint.pausedChip': 'SharePoint sync paused',
};
